!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("prop-types")) : "function" == typeof define && define.amd ? define(["exports", "react", "prop-types"], t) : t((e = e || self).EconomistDesignSystemCommon = {}, e.React, e.PropTypes);
}(this, function (e, t, l) {
  "use strict";

  var n = "default" in t ? t.default : t;
  l = l && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
  var a = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

  function r(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var i = r(function (e) {
    function t() {
      return e.exports = t = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var l = arguments[t];

          for (var n in l) {
            Object.prototype.hasOwnProperty.call(l, n) && (e[n] = l[n]);
          }
        }

        return e;
      }, t.apply(this, arguments);
    }

    e.exports = t;
  });

  var c = function c(e, t) {
    if (null == e) return {};
    var l,
        n,
        a = {},
        r = Object.keys(e);

    for (n = 0; n < r.length; n++) {
      l = r[n], t.indexOf(l) >= 0 || (a[l] = e[l]);
    }

    return a;
  };

  var o = function o(e, t) {
    if (null == e) return {};
    var l,
        n,
        a = c(e, t);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);

      for (n = 0; n < r.length; n++) {
        l = r[n], t.indexOf(l) >= 0 || Object.prototype.propertyIsEnumerable.call(e, l) && (a[l] = e[l]);
      }
    }

    return a;
  },
      s = function s(e) {
    var t = e.height,
        l = e.secondary,
        a = e.width,
        r = o(e, ["height", "secondary", "width"]);
    return n.createElement("svg", i({
      width: a,
      height: t,
      viewBox: "0 0 40 40"
    }, r), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20",
      fill: l ? "#FFF" : "#E3120B"
    }), n.createElement("path", {
      d: "M28.86 26.64l-.798 5.825-2.67.035-8.495-.07-5.756.035.104-.901c2.531-.07 3.19-.763 3.19-3.363V11.8c0-2.6-.659-3.294-3.19-3.364l-.104-.901 5.374.07 8.46-.105 2.22.035.139 5.097-1.387.104c-.243-3.155-.833-3.502-5.826-3.502h-.762l-.347.034V18.7c.659 0 1.179.034 1.49.034.556.035 1.076.07 1.596.07 2.774 0 3.398-.59 3.432-3.225h1.18c-.105 2.115-.105 3.19-.105 4.23 0 .833 0 2.011.035 3.572h-1.11c-.138-2.497-.693-2.982-3.363-3.017l-1.872-.035-1.318.07v7.316c0 2.947.174 3.086 3.086 3.086 3.918 0 5.063-.867 5.41-4.23l1.386.069",
      fill: l ? "#E3120B" : "#FFF"
    })));
  };

  s.defaultProps = {
    height: 40,
    secondary: !1,
    width: 40
  }, s.propTypes = {
    height: l.number,
    secondary: l.bool,
    width: l.number
  };

  var d = function d(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 96 96"
    }, a), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("g", {
      fillRule: "nonzero"
    }, n.createElement("path", {
      d: "M45.614 66.567c-15.289 0-27.683-12.124-27.683-27.081 0-14.957 12.394-27.082 27.683-27.082 15.29 0 27.684 12.125 27.684 27.082S60.904 66.567 45.614 66.567",
      fill: "#FCDD83"
    }), n.createElement("path", {
      d: "M45.314 59.947c-11.135 0-20.161-9.026-20.161-20.16 0-11.135 9.026-20.161 20.16-20.161 11.135 0 20.161 9.026 20.161 20.16 0 11.135-9.026 20.161-20.16 20.161",
      fill: "#FDEBB4"
    }), n.createElement("path", {
      d: "M46.216 52.726c-6.98 0-12.638-5.659-12.638-12.638 0-6.98 5.658-12.639 12.638-12.639 6.98 0 12.638 5.659 12.638 12.639 0 6.98-5.658 12.638-12.638 12.638",
      fill: "#FEF8E6"
    }), n.createElement("path", {
      d: "M24.62 39.486l40.253.09-.07 31.334c-.01 4.925-3.974 8.908-8.852 8.897l-22.586-.05c-4.879-.011-8.825-4.012-8.814-8.937l.07-31.334z",
      fill: "#0D0D0D"
    }), n.createElement("path", {
      d: "M68.151 57.833a3.642 3.642 0 107.285.015 3.642 3.642 0 00-7.285-.015zm3.624 8.133a8.124 8.124 0 11.036-16.25 8.124 8.124 0 01-.036 16.25zm1.06 18.054H18.394c-1.248 0-2.268-1.083-2.268-2.407s1.02-2.407 2.268-2.407h54.441c1.248 0 2.268 1.083 2.268 2.407s-1.02 2.407-2.268 2.407",
      fill: "#0D0D0D"
    })), n.createElement("path", {
      d: "M0 0h96v96H0z"
    })));
  };

  d.defaultProps = {
    height: 96,
    width: 96
  }, d.propTypes = {
    height: l.number,
    width: l.number
  };

  var m = function m(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 112 112"
    }, a), n.createElement("path", {
      d: "M55.164 83.582c-21.234 0-38.448-16.84-38.448-37.612 0-20.772 17.214-37.612 38.448-37.612s38.448 16.84 38.448 37.612c0 20.773-17.214 37.612-38.448 37.612",
      fill: "#FAD051"
    }), n.createElement("path", {
      d: "M54.746 74.388c-15.464 0-28-12.536-28-28s12.536-28 28-28 28 12.536 28 28-12.536 28-28 28",
      fill: "#FCDD83"
    }), n.createElement("path", {
      d: "M56 64.358c-9.694 0-17.552-7.858-17.552-17.552 0-9.694 7.858-17.552 17.552-17.552 9.694 0 17.552 7.858 17.552 17.552 0 9.694-7.858 17.552-17.552 17.552",
      fill: "#FEF8E6"
    }), n.createElement("path", {
      d: "M26.006 45.97l55.904.126-.096 43.517c-.015 6.84-5.52 12.372-12.295 12.357l-31.368-.07c-6.775-.016-12.256-5.572-12.24-12.412l.095-43.518z",
      fill: "#0D0D0D"
    }), n.createElement("path", {
      d: "M86.464 71.452a5.058 5.058 0 1010.117.02 5.058 5.058 0 00-10.117-.02zm5.033 11.294c-6.232-.014-11.272-5.077-11.258-11.308.014-6.232 5.077-11.272 11.308-11.259 6.232.014 11.273 5.077 11.259 11.309-.014 6.231-5.077 11.272-11.309 11.258zM92.969 107.82h-75.61c-1.733 0-3.15-1.504-3.15-3.342 0-1.84 1.417-3.344 3.15-3.344h75.61c1.733 0 3.15 1.505 3.15 3.344 0 1.838-1.417 3.343-3.15 3.343",
      fill: "#0D0D0D"
    }));
  };

  m.defaultProps = {
    height: 112,
    width: 112
  }, m.propTypes = {
    height: l.number,
    width: l.number
  };

  var u = function u(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t
    }, a), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20s8.954 20 20 20 20-8.954 20-20",
      fill: "#D7D7D7"
    }), n.createElement("path", {
      d: "M29 27.14l-.81 5.825-2.712.035-8.63-.07-5.848.035.106-.901c2.571-.07 3.24-.763 3.24-3.363V12.3c0-2.6-.669-3.294-3.24-3.364L11 8.035l5.46.07L25.055 8l2.254.035.141 5.097-1.409.104c-.246-3.155-.845-3.502-5.918-3.502h-.775l-.352.034V19.2c.67 0 1.198.034 1.515.034.563.035 1.092.07 1.62.07 2.818 0 3.452-.59 3.487-3.225h1.198c-.106 2.115-.106 3.19-.106 4.23 0 .833 0 2.011.036 3.572h-1.128c-.14-2.497-.704-2.982-3.416-3.017l-1.903-.035-1.338.07v7.316c0 2.947.176 3.086 3.135 3.086 3.98 0 5.143-.867 5.495-4.23L29 27.14",
      fill: "#F2F2F2"
    })));
  };

  u.defaultProps = {
    height: 40,
    width: 40
  }, u.propTypes = {
    height: l.number,
    width: l.number
  };

  var h = function h(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 152 152"
    }, a), n.createElement("path", {
      d: "M42.435 83.36H25.812c-3.748 0-6.812 3.048-6.812 6.777v23.8c0 3.73 3.064 6.778 6.812 6.778h8.356l9.837 8.076V120.54c3.001-.706 5.255-3.402 5.255-6.602v-23.8c0-3.729-3.064-6.778-6.825-6.778M126.137 83.36h-16.624c-3.747 0-6.811 3.048-6.811 6.777v23.8c0 3.2 2.253 5.884 5.254 6.602v8.265l9.838-8.076h8.356c3.748 0 6.811-3.05 6.811-6.778V90.137c-.012-3.729-3.076-6.778-6.824-6.778",
      stroke: "#E1DFD0",
      fill: "#FFF"
    }), n.createElement("path", {
      d: "M115.933 49.468c1.202-2.684.899-5.91-1.09-8.354-9.533-11.754-23.7-18.495-38.869-18.495-14.952 0-29.006 6.59-38.54 18.08-2 2.419-2.342 5.644-1.177 8.34a45.349 45.349 0 00-6.394 23.283V83.36h8.52V72.31a37.044 37.044 0 014.913-18.444c2.457.113 4.938-.87 6.622-2.91 6.445-7.774 15.94-12.222 26.044-12.222 10.255 0 19.827 4.561 26.284 12.511 1.595 1.978 3.938 2.999 6.305 2.999.101 0 .203-.013.291-.013a36.9 36.9 0 014.723 18.08v11.036h8.52V72.31c0-8.316-2.253-16.102-6.152-22.842",
      fill: "#475ED1"
    }));
  };

  h.defaultProps = {
    height: 152,
    width: 152
  }, h.propTypes = {
    height: l.number,
    width: l.number
  };

  var g = function g(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 152 152"
    }, a), n.createElement("path", {
      d: "M42.435 83.36H25.812c-3.748 0-6.812 3.048-6.812 6.777v23.8c0 3.73 3.064 6.778 6.812 6.778h8.356l9.837 8.076V120.54c3.001-.706 5.255-3.402 5.255-6.602v-23.8c0-3.729-3.064-6.778-6.825-6.778M126.137 83.36h-16.624c-3.747 0-6.811 3.048-6.811 6.777v23.8c0 3.2 2.253 5.884 5.254 6.602v8.265l9.838-8.076h8.356c3.748 0 6.811-3.05 6.811-6.778V90.137c-.012-3.729-3.076-6.778-6.824-6.778",
      fill: "#FFF"
    }), n.createElement("path", {
      d: "M115.933 49.468c1.202-2.684.899-5.91-1.09-8.354-9.533-11.754-23.7-18.495-38.869-18.495-14.952 0-29.006 6.59-38.54 18.08-2 2.419-2.342 5.644-1.177 8.34a45.349 45.349 0 00-6.394 23.283V83.36h8.52V72.31a37.044 37.044 0 014.913-18.444c2.457.113 4.938-.87 6.622-2.91 6.445-7.774 15.94-12.222 26.044-12.222 10.255 0 19.827 4.561 26.284 12.511 1.595 1.978 3.938 2.999 6.305 2.999.101 0 .203-.013.291-.013a36.9 36.9 0 014.723 18.08v11.036h8.52V72.31c0-8.316-2.253-16.102-6.152-22.842",
      fill: "#0D0D0D"
    }));
  };

  g.defaultProps = {
    height: 152,
    width: 152
  }, g.propTypes = {
    height: l.number,
    width: l.number
  };

  var v = function v(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 152 152"
    }, a), n.createElement("path", {
      fill: "#475ED1",
      d: "M31.667 75.064l39.249-26.351 10.484.317 38.777 26.034-6.872 32.233-74.16.38z"
    }), n.createElement("path", {
      stroke: "#E1DFD0",
      fill: "#FFF",
      d: "M88.883 103.206l-.018-.017-25.79.064-.029.03-31.38-28.219v58.795h88.51V75.064z"
    }), n.createElement("path", {
      fill: "#D6DBF5",
      d: "M63.076 103.253l-.097-45.906h25.886v45.842z"
    }), n.createElement("path", {
      d: "M76.834 12.78v26.154a3.67 3.67 0 01-.912 7.23 3.679 3.679 0 01-3.679-3.68 3.67 3.67 0 012.766-3.55V12.782c-3.959 17.86-12.03 26.095-12.03 26.095l4.84 18.47h16.206l4.84-18.47s-8.072-8.236-12.03-26.097",
      fill: "#1F2E7A"
    }));
  };

  v.defaultProps = {
    height: 152,
    width: 152
  }, v.propTypes = {
    height: l.number,
    width: l.number
  };

  var p = function p(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 528 88"
    }, a), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      fill: "#E3120B",
      d: "M0 88h528V0H0z"
    }), n.createElement("path", {
      d: "M141.092 53.311l-1.121 8.173-3.753.049-11.939-.098-8.09.05.147-1.266c3.557-.097 4.483-1.07 4.483-4.719V32.49c0-3.648-.926-4.621-4.483-4.719l-.147-1.264 7.554.097 11.89-.146 3.12.049.194 7.15-1.949.147c-.341-4.427-1.17-4.914-8.187-4.914h-1.072l-.487.05V42.17c.926 0 1.657.049 2.095.049.78.048 1.511.097 2.242.097 3.898 0 4.776-.827 4.824-4.524h1.657c-.146 2.967-.146 4.475-.146 5.935 0 1.167 0 2.822.05 5.01h-1.56c-.196-3.502-.975-4.183-4.728-4.232l-2.631-.048-1.852.097v10.264c0 4.135.244 4.33 4.337 4.33 5.507 0 7.115-1.216 7.602-5.935l1.95.097M164.825 58.03c-2.778 2.87-5.069 3.989-8.285 3.989-6.432 0-10.623-5.01-10.623-12.648 0-7.88 4.434-12.892 11.452-12.892 1.852 0 3.752.34 6.676 1.12l.098 5.837-2.194.146c-.876-4.378-1.754-5.4-4.58-5.4-3.655 0-5.556 3.26-5.556 9.535 0 7.394 2.29 11.53 6.433 11.53 2.144 0 3.947-.925 5.848-2.968l.731 1.75M179.64 38.328c-3.558 0-5.36 3.065-5.36 9.146 0 .73.048 1.459.097 2.189.536 6.956 2.777 10.702 6.53 10.702 3.508 0 5.604-3.648 5.604-9.778 0-7.2-2.875-12.26-6.871-12.26zm.584 23.69c-6.968 0-11.647-4.669-11.89-11.82v-.73c0-8.221 4.434-12.989 12.037-12.989 7.066 0 12.037 5.254 12.037 12.795 0 7.637-4.825 12.745-12.184 12.745zM223.597 61.484c-2.827-.097-4.97-.194-6.384-.194-1.364 0-3.411.097-6.092.194l.098-1.168c2.583-.389 2.826-.875 2.875-5.205l.049-3.065v-4.33c0-6.129-1.121-8.172-4.289-8.172-1.9 0-3.509 1.022-4.483 2.822-.39.73-.731 1.897-.731 2.383v10.362c0 4.33.292 4.816 2.875 5.205l.146 1.168c-2.729-.097-4.776-.194-6.14-.194-1.413 0-3.509.097-6.335.194l.097-1.168c3.265 0 3.753-.632 3.753-5.205V43.825c0-4.524-.488-5.156-3.753-5.205l-.097-1.119c4.337-.244 5.312-.39 9.015-1.168l.244 4.379c2.777-3.114 4.922-4.233 7.895-4.233 4.727 0 7.407 3.065 7.407 8.562v10.07c-.049.39-.049.779-.049 1.168 0 3.113.829 4.037 3.802 4.037l.097 1.168M237.681 38.328c-3.557 0-5.36 3.065-5.36 9.146 0 .73.048 1.459.097 2.189.536 6.956 2.778 10.702 6.53 10.702 3.509 0 5.604-3.648 5.604-9.778 0-7.2-2.875-12.26-6.871-12.26zm.585 23.69c-6.969 0-11.647-4.669-11.89-11.82v-.73c0-8.221 4.434-12.989 12.036-12.989 7.067 0 12.037 5.254 12.037 12.795 0 7.637-4.824 12.745-12.183 12.745zM296.258 61.484c-2.826-.097-4.97-.194-6.384-.194-1.364 0-3.362.097-6.042.194l.097-1.168c2.583-.389 2.875-.875 2.875-5.205v-7.394c0-6.033-1.072-8.173-4.093-8.173-1.804 0-3.655 1.168-4.435 2.822-.243.584-.487 1.167-.633 1.848-.05.244-.098.438-.098.535v10.362c0 4.33.293 4.816 2.875 5.205l.098 1.168c-2.583-.097-4.532-.194-5.848-.194-1.267 0-3.168.097-5.702.194l.098-1.168c2.582-.389 2.875-.875 2.875-5.205v-7.394c0-6.033-1.072-8.173-4.094-8.173-1.852 0-3.509 1.07-4.435 2.822-.39.778-.73 1.897-.73 2.383v10.362c0 4.33.292 4.816 2.875 5.205l.097 1.168c-2.68-.097-4.727-.194-6.091-.194-1.414 0-3.51.097-6.336.194l.098-1.168c3.265 0 3.752-.632 3.752-5.205V43.825c0-4.524-.487-5.156-3.752-5.205l-.098-1.119c4.337-.244 5.312-.39 9.016-1.168l.244 4.379c2.777-3.065 4.922-4.233 7.797-4.233 3.313 0 5.263 1.363 6.725 4.622 2.973-3.406 5.166-4.622 8.138-4.622 4.63 0 7.262 3.114 7.262 8.562v10.07c0 .39-.05.779-.05 1.168 0 3.113.878 4.037 3.802 4.037l.097 1.168M306.2 31.517c-1.852 0-3.265-1.41-3.265-3.308 0-1.848 1.462-3.308 3.265-3.308 1.803 0 3.265 1.509 3.265 3.308 0 1.849-1.413 3.308-3.265 3.308zm6.919 29.967c-3.02-.097-5.213-.194-6.724-.194-1.462 0-3.655.097-6.628.194l.098-1.168c3.265 0 3.703-.632 3.752-5.205l.049-3.065V46.94l-.049-3.114c-.049-4.524-.487-5.156-3.752-5.205l-.098-1.119c4.484-.292 5.507-.438 9.454-1.168v15.713l.049 3.065c.049 4.573.438 5.205 3.752 5.205l.097 1.168zM323.452 62.019c-1.803 0-3.51-.389-6.627-1.41l-.196-4.963 2.487-.097c1.12 3.746 1.85 4.476 4.432 4.476 2.241 0 3.703-1.168 3.703-2.92 0-1.653-1.02-2.918-4.09-5.01-1.562-1.07-2.633-1.8-3.22-2.238-1.266-.973-2.191-2.14-2.678-3.454-.292-.73-.438-1.605-.438-2.627 0-4.427 3.02-7.297 7.602-7.297 1.704 0 2.678.146 6.627 1.07l.096 4.914-2.483.097c-.587-3.259-1.608-4.378-3.899-4.378-2.194 0-3.753 1.265-3.753 3.065 0 1.703.78 2.724 3.312 4.33 2.291 1.507 4.144 2.82 5.314 3.94 1.413 1.265 2.142 2.967 2.142 4.865 0 4.33-3.653 7.637-8.331 7.637M350.743 60.463c-1.658.924-3.949 1.459-6.289 1.459-2.142 0-4.19-1.216-5.066-3.016-.732-1.509-.974-3.016-.974-6.324V40.128h-3.12V37.89c3.849-.292 5.36-1.946 6.481-7.005h2.192v6.567h6.143l-.683 2.676h-5.46v11.967c0 5.984.782 7.394 4.094 7.394.78 0 1.512-.097 2.682-.438v1.412M397.478 47.863c-3.12.243-3.85 1.168-3.85 4.67v6.421l-.928.39c-2.824 1.167-4.532 1.654-7.26 2.14-2.095.34-4.19.535-6.236.535-11.358 0-18.668-6.908-18.668-17.561 0-5.741 2.195-11.14 5.848-14.303 3.12-2.724 7.652-4.183 13.112-4.183 2.824 0 6.577.389 9.501 1.021 1.413.292 2.095.535 3.607 1.168l.292 7.2-1.95.097c-.291-2.092-1.024-3.697-2.144-4.67-1.754-1.557-5.457-2.627-9.21-2.627-7.406 0-11.842 5.837-11.842 15.615 0 9.681 4.923 15.86 12.575 15.86 2.436 0 5.31-.633 6.869-1.412v-5.691c0-3.746-.975-4.719-4.824-4.719-.146 0-.292 0-.438.049l-.099-1.313c3.703.048 6.481.097 8.285.097 1.657 0 4.144-.05 7.456-.097l-.096 1.313M418.287 43.387l-2.194.195c0-.146-.047-.244-.047-.292 0-.097-.05-.34-.146-.681l-.195-.681c-.295-1.07-.78-1.41-2.05-1.41-2.923 0-4.727 2.188-4.727 5.837v8.756c0 4.622.537 5.254 3.949 5.254.146 0 .341 0 .537-.049l.096 1.168c-3.166-.097-5.556-.194-7.164-.194-1.509 0-3.8.097-6.87.194l.097-1.168c3.265 0 3.753-.632 3.753-5.205V43.825c0-4.524-.488-5.156-3.753-5.205l-.096-1.119c4.336-.244 5.31-.39 9.014-1.168l.292 4.379c2.827-3.6 3.998-4.233 7.409-4.233.292 0 .534 0 .633.05l1.024.242.193.049.245 6.567M51.13 34.047l-1.754.097c-.146-4.62-1.12-5.254-8.138-5.254h-1.511V55.5c0 3.649.926 4.622 4.532 4.72l.098 1.264c-3.412-.049-5.995-.049-7.7-.049-1.755 0-4.435 0-7.944.05l.098-1.266c3.606-.097 4.532-1.07 4.532-4.719V28.89h-1.755c-7.212 0-8.187.633-8.284 5.254l-1.803-.097.195-7.54c6.628.048 11.55.097 14.863.097 3.168 0 7.993-.049 14.376-.097l.195 7.54M82.125 61.484c-2.827-.097-4.97-.194-6.384-.194-1.365 0-3.363.097-6.043.194l.097-1.168c2.583-.389 2.876-.875 2.876-5.205v-7.394c0-6.13-1.073-8.173-4.289-8.173-1.803 0-3.655 1.12-4.435 2.822-.292.584-.487 1.216-.682 1.848-.048.244-.048.438-.048.535v10.362c0 4.33.292 4.816 2.875 5.205l.097 1.168c-2.729-.097-4.727-.194-6.091-.194-1.414 0-3.558.097-6.336.194l.098-1.168c3.265 0 3.752-.632 3.752-5.205V32.88c0-4.572-.487-5.205-3.752-5.205l-.098-1.167c4.435-.244 5.458-.39 9.455-1.119v15.08c2.582-2.87 4.775-3.989 7.65-3.989 4.776 0 7.408 3.017 7.408 8.562v10.07c0 4.573.487 5.205 3.752 5.205l.098 1.168M95.526 38.182c-2.923 0-4.434 2.432-4.922 7.735 4.484-.098 5.848-.194 10.38-.681-.584-4.719-2.387-7.054-5.458-7.054zm-4.775 9.583c.195 7.395 2.875 11.579 7.358 11.579 2.68 0 4.922-1.217 7.31-3.99l.731 1.363c-3.021 3.746-5.994 5.302-9.893 5.302-6.773 0-11.354-4.962-11.354-12.308 0-7.832 4.727-13.232 11.55-13.232 3.752 0 6.383 1.363 8.187 4.33 1.218 2.043 1.559 3.454 1.608 6.956H90.75zM432.224 38.328c-3.557 0-5.36 3.065-5.36 9.146 0 .73.05 1.459.096 2.189.537 6.956 2.778 10.702 6.53 10.702 3.508 0 5.604-3.648 5.604-9.778 0-7.2-2.875-12.26-6.87-12.26zm.584 23.69c-6.969 0-11.647-4.669-11.892-11.82v-.73c0-8.221 4.436-12.989 12.038-12.989 7.068 0 12.037 5.254 12.037 12.795 0 7.637-4.823 12.745-12.183 12.745zM476.18 60.852c-4.335.243-5.31.389-9.013 1.167l-.295-4.232c-2.775 3.113-4.874 4.232-7.844 4.232-4.777 0-7.41-3.065-7.41-8.562v-9.632c0-4.524-.487-5.156-3.75-5.205l-.099-1.119c4.436-.292 5.507-.438 9.455-1.168v14.449c0 6.13 1.071 8.172 4.287 8.172 1.853 0 3.51-1.07 4.436-2.821.39-.779.779-1.897.779-2.384v-6.81l-.047-3.114c-.05-4.524-.44-5.156-3.752-5.205l-.1-1.119c4.486-.292 5.507-.438 9.455-1.168v15.081l.05 3.113c.05 4.524.487 5.157 3.753 5.206l.096 1.119M499.573 48.884c-.487-5.837-3.02-9.437-6.627-9.437-2.34 0-4.532 1.946-5.165 4.573-.292 1.167-.488 3.308-.488 5.545 0 6.52 2.387 10.557 6.336 10.557 3.849 0 6.04-3.405 6.04-9.486 0-.584-.046-1.168-.096-1.752zm-5.36 13.135c-2.825 0-4.582-.584-6.532-2.189v6.47c0 4.621.488 5.254 3.949 5.254.146 0 .341-.049.487-.049l.146 1.168c-3.216-.097-5.556-.195-7.164-.195-1.558 0-3.85.098-6.87.195l.097-1.168c3.265 0 3.753-.632 3.753-5.205V43.825c0-4.524-.488-5.156-3.753-5.205l-.096-1.119c4.286-.244 5.31-.39 8.964-1.168l.295 4.33c2.728-3.016 4.92-4.184 7.844-4.184 5.947 0 10.038 5.06 10.038 12.405 0 7.638-4.628 13.135-11.159 13.135z",
      fill: "#FFF"
    })));
  };

  p.defaultProps = {
    height: 88,
    width: 528
  }, p.propTypes = {
    height: l.number,
    width: l.number
  };

  var f = function f(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 528 176"
    }, a), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      fill: "#E3120B",
      d: "M0 176h528V0H0z"
    }), n.createElement("g", {
      fill: "#FFF"
    }, n.createElement("path", {
      d: "M141.092 97.305l-1.121 8.173-3.753.048-11.939-.097-8.09.049.147-1.265c3.557-.098 4.483-1.07 4.483-4.72v-23.01c0-3.648-.926-4.62-4.483-4.718l-.147-1.265 7.554.097 11.89-.145 3.12.048.194 7.151-1.949.146c-.341-4.427-1.17-4.913-8.187-4.913h-1.072l-.487.049v13.232c.926 0 1.657.048 2.095.048.78.049 1.511.097 2.242.097 3.898 0 4.776-.826 4.824-4.524h1.657c-.146 2.968-.146 4.476-.146 5.935 0 1.168 0 2.822.05 5.01h-1.56c-.196-3.502-.975-4.183-4.728-4.231l-2.631-.049-1.852.097v10.265c0 4.135.244 4.33 4.337 4.33 5.507 0 7.115-1.217 7.602-5.936l1.95.098M164.825 102.023c-2.778 2.87-5.069 3.99-8.285 3.99-6.432 0-10.623-5.011-10.623-12.649 0-7.88 4.434-12.891 11.452-12.891 1.852 0 3.752.34 6.676 1.119l.098 5.838-2.194.146c-.876-4.379-1.754-5.4-4.58-5.4-3.655 0-5.556 3.259-5.556 9.534 0 7.395 2.29 11.53 6.433 11.53 2.144 0 3.947-.924 5.848-2.968l.731 1.751M179.64 82.321c-3.558 0-5.36 3.065-5.36 9.146 0 .73.048 1.46.097 2.19.536 6.956 2.777 10.702 6.53 10.702 3.508 0 5.604-3.649 5.604-9.778 0-7.2-2.875-12.26-6.871-12.26zm.584 23.691c-6.968 0-11.647-4.67-11.89-11.82v-.73c0-8.222 4.434-12.99 12.037-12.99 7.066 0 12.037 5.255 12.037 12.795 0 7.638-4.825 12.745-12.184 12.745zM223.597 105.478c-2.827-.098-4.97-.195-6.384-.195-1.364 0-3.411.097-6.092.195l.098-1.168c2.583-.39 2.826-.876 2.875-5.205l.049-3.065v-4.33c0-6.129-1.121-8.173-4.289-8.173-1.9 0-3.509 1.022-4.483 2.822-.39.73-.731 1.898-.731 2.384v10.362c0 4.33.292 4.816 2.875 5.205l.146 1.168c-2.729-.098-4.776-.195-6.14-.195-1.413 0-3.509.097-6.335.195l.097-1.168c3.265 0 3.753-.633 3.753-5.205V87.819c0-4.524-.488-5.157-3.753-5.206l-.097-1.118c4.337-.244 5.312-.39 9.015-1.168l.244 4.378c2.777-3.113 4.922-4.232 7.895-4.232 4.727 0 7.407 3.064 7.407 8.562v10.07c-.049.389-.049.778-.049 1.167 0 3.114.829 4.038 3.802 4.038l.097 1.168M237.681 82.321c-3.557 0-5.36 3.065-5.36 9.146 0 .73.048 1.46.097 2.19.536 6.956 2.778 10.702 6.53 10.702 3.509 0 5.604-3.649 5.604-9.778 0-7.2-2.875-12.26-6.871-12.26zm.585 23.691c-6.969 0-11.647-4.67-11.89-11.82v-.73c0-8.222 4.434-12.99 12.036-12.99 7.067 0 12.037 5.255 12.037 12.795 0 7.638-4.824 12.745-12.183 12.745zM296.258 105.478c-2.826-.098-4.97-.195-6.384-.195-1.364 0-3.362.097-6.042.195l.097-1.168c2.583-.39 2.875-.876 2.875-5.205V91.71c0-6.032-1.072-8.173-4.093-8.173-1.804 0-3.655 1.168-4.435 2.822-.243.584-.487 1.168-.633 1.849-.05.243-.098.438-.098.535v10.362c0 4.33.293 4.816 2.875 5.205l.098 1.168c-2.583-.098-4.532-.195-5.848-.195-1.267 0-3.168.097-5.702.195l.098-1.168c2.582-.39 2.875-.876 2.875-5.205V91.71c0-6.032-1.072-8.173-4.094-8.173-1.852 0-3.509 1.07-4.435 2.822-.39.778-.73 1.898-.73 2.384v10.362c0 4.33.292 4.816 2.875 5.205l.097 1.168c-2.68-.098-4.727-.195-6.091-.195-1.414 0-3.51.097-6.336.195l.098-1.168c3.265 0 3.752-.633 3.752-5.205V87.819c0-4.524-.487-5.157-3.752-5.206l-.098-1.118c4.337-.244 5.312-.39 9.016-1.168l.244 4.378c2.777-3.065 4.922-4.232 7.797-4.232 3.313 0 5.263 1.362 6.725 4.621 2.973-3.405 5.166-4.621 8.138-4.621 4.63 0 7.262 3.113 7.262 8.562v10.07c0 .389-.05.778-.05 1.167 0 3.114.878 4.038 3.802 4.038l.097 1.168M306.2 75.51c-1.852 0-3.265-1.41-3.265-3.307 0-1.849 1.462-3.308 3.265-3.308 1.803 0 3.265 1.508 3.265 3.308 0 1.848-1.413 3.308-3.265 3.308zm6.919 29.968c-3.02-.098-5.213-.195-6.724-.195-1.462 0-3.655.097-6.628.195l.098-1.168c3.265 0 3.703-.633 3.752-5.205l.049-3.065v-5.108l-.049-3.113c-.049-4.524-.487-5.157-3.752-5.206l-.098-1.118c4.484-.292 5.507-.439 9.454-1.168V96.04l.049 3.065c.049 4.572.438 5.205 3.752 5.205l.097 1.168zM323.452 106.012c-1.803 0-3.51-.388-6.627-1.41l-.196-4.962 2.487-.097c1.12 3.745 1.85 4.475 4.432 4.475 2.241 0 3.703-1.168 3.703-2.919 0-1.654-1.02-2.919-4.09-5.01-1.562-1.07-2.633-1.8-3.22-2.238-1.266-.973-2.191-2.14-2.678-3.454-.292-.73-.438-1.606-.438-2.627 0-4.427 3.02-7.297 7.602-7.297 1.704 0 2.678.146 6.627 1.07l.096 4.913-2.483.098c-.587-3.26-1.608-4.378-3.899-4.378-2.194 0-3.753 1.264-3.753 3.064 0 1.703.78 2.724 3.312 4.33 2.291 1.508 4.144 2.821 5.314 3.94 1.413 1.265 2.142 2.968 2.142 4.865 0 4.33-3.653 7.637-8.331 7.637M350.743 104.456c-1.658.924-3.949 1.46-6.289 1.46-2.142 0-4.19-1.217-5.066-3.017-.732-1.508-.974-3.016-.974-6.324V84.122h-3.12v-2.239c3.849-.291 5.36-1.945 6.481-7.005h2.192v6.568h6.143l-.683 2.676h-5.46v11.967c0 5.983.782 7.394 4.094 7.394.78 0 1.512-.097 2.682-.438v1.411M397.478 91.856c-3.12.243-3.85 1.168-3.85 4.67v6.422l-.928.39c-2.824 1.166-4.532 1.653-7.26 2.14-2.095.34-4.19.534-6.236.534-11.358 0-18.668-6.907-18.668-17.56 0-5.742 2.195-11.141 5.848-14.303 3.12-2.725 7.652-4.184 13.112-4.184 2.824 0 6.577.39 9.501 1.022 1.413.292 2.095.535 3.607 1.167l.292 7.2-1.95.097c-.291-2.092-1.024-3.697-2.144-4.67-1.754-1.557-5.457-2.627-9.21-2.627-7.406 0-11.842 5.838-11.842 15.616 0 9.68 4.923 15.859 12.575 15.859 2.436 0 5.31-.632 6.869-1.411v-5.692c0-3.745-.975-4.718-4.824-4.718-.146 0-.292 0-.438.048l-.099-1.313c3.703.048 6.481.097 8.285.097 1.657 0 4.144-.049 7.456-.097l-.096 1.313M418.287 87.38l-2.194.196c0-.146-.047-.244-.047-.293 0-.097-.05-.34-.146-.68l-.195-.682c-.295-1.07-.78-1.41-2.05-1.41-2.923 0-4.727 2.189-4.727 5.837v8.757c0 4.621.537 5.254 3.949 5.254.146 0 .341 0 .537-.05l.096 1.169c-3.166-.098-5.556-.195-7.164-.195-1.509 0-3.8.097-6.87.195l.097-1.168c3.265 0 3.753-.633 3.753-5.205V87.819c0-4.524-.488-5.157-3.753-5.206l-.096-1.118c4.336-.244 5.31-.39 9.014-1.168l.292 4.378c2.827-3.6 3.998-4.232 7.409-4.232.292 0 .534 0 .633.049l1.024.243.193.048.245 6.568M51.13 78.04l-1.754.098c-.146-4.621-1.12-5.254-8.138-5.254h-1.511v26.61c0 3.649.926 4.621 4.532 4.719l.098 1.265c-3.412-.049-5.995-.049-7.7-.049-1.755 0-4.435 0-7.944.049l.098-1.265c3.606-.098 4.532-1.07 4.532-4.72v-26.61h-1.755c-7.212 0-8.187.634-8.284 5.255l-1.803-.097.195-7.54c6.628.048 11.55.096 14.863.096 3.168 0 7.993-.048 14.376-.097l.195 7.54M82.125 105.478c-2.827-.098-4.97-.195-6.384-.195-1.365 0-3.363.097-6.043.195l.097-1.168c2.583-.39 2.876-.876 2.876-5.205V91.71c0-6.129-1.073-8.173-4.289-8.173-1.803 0-3.655 1.12-4.435 2.822-.292.584-.487 1.217-.682 1.849-.048.243-.048.438-.048.535v10.362c0 4.33.292 4.816 2.875 5.205l.097 1.168c-2.729-.098-4.727-.195-6.091-.195-1.414 0-3.558.097-6.336.195l.098-1.168c3.265 0 3.752-.633 3.752-5.205V76.873c0-4.573-.487-5.205-3.752-5.205l-.098-1.168c4.435-.243 5.458-.39 9.455-1.118v15.08c2.582-2.87 4.775-3.99 7.65-3.99 4.776 0 7.408 3.017 7.408 8.563v10.07c0 4.572.487 5.205 3.752 5.205l.098 1.168M95.526 82.176c-2.923 0-4.434 2.432-4.922 7.735 4.484-.098 5.848-.195 10.38-.682-.584-4.718-2.387-7.053-5.458-7.053zm-4.775 9.583c.195 7.394 2.875 11.578 7.358 11.578 2.68 0 4.922-1.216 7.31-3.989l.731 1.362c-3.021 3.746-5.994 5.302-9.893 5.302-6.773 0-11.354-4.961-11.354-12.307 0-7.832 4.727-13.232 11.55-13.232 3.752 0 6.383 1.362 8.187 4.33 1.218 2.043 1.559 3.454 1.608 6.956H90.75zM432.224 82.321c-3.557 0-5.36 3.065-5.36 9.146 0 .73.05 1.46.096 2.19.537 6.956 2.778 10.702 6.53 10.702 3.508 0 5.604-3.649 5.604-9.778 0-7.2-2.875-12.26-6.87-12.26zm.584 23.691c-6.969 0-11.647-4.67-11.892-11.82v-.73c0-8.222 4.436-12.99 12.038-12.99 7.068 0 12.037 5.255 12.037 12.795 0 7.638-4.823 12.745-12.183 12.745zM476.18 104.845c-4.335.243-5.31.39-9.013 1.167l-.295-4.232c-2.775 3.114-4.874 4.232-7.844 4.232-4.777 0-7.41-3.064-7.41-8.561v-9.632c0-4.524-.487-5.157-3.75-5.206l-.099-1.118c4.436-.292 5.507-.439 9.455-1.168v14.448c0 6.13 1.071 8.173 4.287 8.173 1.853 0 3.51-1.07 4.436-2.822.39-.778.779-1.897.779-2.383v-6.81l-.047-3.114c-.05-4.524-.44-5.157-3.752-5.206l-.1-1.118c4.486-.292 5.507-.439 9.455-1.168v15.08l.05 3.114c.05 4.524.487 5.156 3.753 5.205l.096 1.12M499.573 92.878c-.487-5.838-3.02-9.438-6.627-9.438-2.34 0-4.532 1.946-5.165 4.573-.292 1.168-.488 3.308-.488 5.546 0 6.519 2.387 10.556 6.336 10.556 3.849 0 6.04-3.405 6.04-9.486 0-.584-.046-1.167-.096-1.751zm-5.36 13.134c-2.825 0-4.582-.583-6.532-2.188v6.47c0 4.621.488 5.253 3.949 5.253.146 0 .341-.048.487-.048l.146 1.167c-3.216-.097-5.556-.194-7.164-.194-1.558 0-3.85.097-6.87.194l.097-1.167c3.265 0 3.753-.632 3.753-5.205V87.819c0-4.524-.488-5.157-3.753-5.206l-.096-1.118c4.286-.244 5.31-.39 8.964-1.168l.295 4.33c2.728-3.017 4.92-4.184 7.844-4.184 5.947 0 10.038 5.06 10.038 12.405 0 7.638-4.628 13.134-11.159 13.134z"
    }))));
  };

  f.defaultProps = {
    height: 176,
    width: 528
  }, f.propTypes = {
    height: l.number,
    width: l.number
  };

  var b = function b(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 482 48"
    }, a), n.createElement("g", {
      fill: "#E3120B",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M119.12 28.379l-1.116 8.164-3.737.048-11.893-.097-8.058.049.146-1.264c3.543-.097 4.466-1.069 4.466-4.713V7.58c0-3.645-.923-4.616-4.466-4.714l-.146-1.263 7.524.097 11.844-.146 3.107.049.194 7.143-1.942.146c-.34-4.422-1.164-4.908-8.154-4.908h-1.068l-.486.049V17.25c.923 0 1.65.049 2.088.049.776.048 1.504.097 2.232.097 3.884 0 4.757-.826 4.806-4.52h1.65c-.145 2.965-.145 4.471-.145 5.929 0 1.166 0 2.819.048 5.005h-1.553c-.194-3.499-.97-4.18-4.708-4.227l-2.622-.049-1.845.097v10.253c0 4.13.243 4.325 4.32 4.325 5.486 0 7.088-1.215 7.573-5.928l1.942.097M142.76 33.092c-2.766 2.868-5.048 3.985-8.251 3.985-6.408 0-10.582-5.005-10.582-12.634 0-7.872 4.417-12.877 11.407-12.877 1.844 0 3.737.34 6.65 1.117l.097 5.832-2.184.145c-.874-4.373-1.748-5.394-4.563-5.394-3.64 0-5.534 3.256-5.534 9.525 0 7.386 2.282 11.516 6.407 11.516 2.136 0 3.932-.923 5.825-2.964l.729 1.75M157.517 13.412c-3.544 0-5.34 3.062-5.34 9.136 0 .729.05 1.457.098 2.187.534 6.948 2.766 10.69 6.504 10.69 3.495 0 5.582-3.644 5.582-9.767 0-7.192-2.864-12.246-6.844-12.246zm.582 23.665c-6.94 0-11.601-4.665-11.843-11.808v-.729c0-8.213 4.417-12.974 11.99-12.974 7.038 0 11.989 5.248 11.989 12.78 0 7.629-4.806 12.731-12.136 12.731zM201.301 36.543c-2.815-.098-4.95-.195-6.358-.195-1.36 0-3.398.097-6.068.195l.097-1.167c2.573-.388 2.815-.874 2.864-5.2l.048-3.06V22.79c0-6.123-1.116-8.164-4.271-8.164-1.893 0-3.495 1.02-4.466 2.818-.388.73-.728 1.896-.728 2.381v10.35c0 4.326.291 4.812 2.864 5.2l.146 1.167c-2.719-.098-4.758-.195-6.117-.195-1.407 0-3.495.097-6.31.195l.097-1.167c3.252 0 3.738-.631 3.738-5.2V18.904c0-4.519-.486-5.15-3.738-5.2l-.097-1.117c4.32-.243 5.29-.389 8.98-1.166l.243 4.373c2.766-3.11 4.903-4.227 7.864-4.227 4.708 0 7.378 3.06 7.378 8.552v10.059c-.049.389-.049.777-.049 1.166 0 3.11.825 4.033 3.786 4.033l.097 1.167M215.33 13.412c-3.543 0-5.34 3.062-5.34 9.136 0 .729.05 1.457.098 2.187.534 6.948 2.767 10.69 6.505 10.69 3.494 0 5.582-3.644 5.582-9.767 0-7.192-2.864-12.246-6.845-12.246zm.583 23.665c-6.942 0-11.602-4.665-11.844-11.808v-.729c0-8.213 4.417-12.974 11.99-12.974 7.038 0 11.99 5.248 11.99 12.78 0 7.629-4.806 12.731-12.136 12.731zM273.677 36.543c-2.815-.098-4.95-.195-6.359-.195-1.359 0-3.349.097-6.019.195l.097-1.167c2.573-.388 2.864-.874 2.864-5.2v-7.385c0-6.026-1.068-8.164-4.077-8.164-1.796 0-3.641 1.166-4.417 2.818-.243.584-.486 1.166-.631 1.847-.049.243-.098.437-.098.534v10.35c0 4.326.292 4.812 2.864 5.2l.097 1.167c-2.572-.098-4.514-.195-5.824-.195-1.263 0-3.156.097-5.68.195l.097-1.167c2.573-.388 2.864-.874 2.864-5.2v-7.385c0-6.026-1.068-8.164-4.077-8.164-1.845 0-3.495 1.069-4.418 2.818-.388.778-.727 1.896-.727 2.381v10.35c0 4.326.29 4.812 2.863 5.2l.097 1.167c-2.67-.098-4.708-.195-6.067-.195-1.408 0-3.495.097-6.31.195l.096-1.167c3.253 0 3.738-.631 3.738-5.2V18.904c0-4.519-.485-5.15-3.738-5.2l-.097-1.117c4.32-.243 5.291-.389 8.98-1.166l.243 4.373c2.767-3.061 4.903-4.227 7.767-4.227 3.3 0 5.242 1.36 6.699 4.616 2.96-3.402 5.145-4.616 8.106-4.616 4.611 0 7.233 3.11 7.233 8.552v10.059c0 .389-.049.777-.049 1.166 0 3.11.874 4.033 3.786 4.033l.097 1.167M283.58 6.609c-1.845 0-3.253-1.41-3.253-3.305 0-1.846 1.457-3.304 3.253-3.304 1.795 0 3.252 1.507 3.252 3.304 0 1.847-1.408 3.305-3.252 3.305zm6.891 29.934c-3.008-.098-5.192-.195-6.697-.195-1.456 0-3.64.097-6.602.195l.097-1.167c3.252 0 3.69-.631 3.738-5.2l.048-3.06v-5.103l-.048-3.11c-.049-4.519-.486-5.15-3.738-5.2l-.097-1.117c4.466-.292 5.485-.438 9.417-1.166v15.695l.048 3.062c.05 4.568.437 5.2 3.738 5.2l.096 1.166zM300.764 37.077c-1.797 0-3.497-.388-6.601-1.409l-.195-4.957 2.476-.097c1.117 3.742 1.843 4.471 4.416 4.471 2.232 0 3.688-1.167 3.688-2.916 0-1.652-1.017-2.915-4.075-5.005-1.555-1.069-2.622-1.798-3.206-2.235-1.262-.972-2.183-2.138-2.668-3.45-.291-.73-.436-1.604-.436-2.625 0-4.422 3.008-7.288 7.572-7.288 1.697 0 2.668.145 6.6 1.069l.097 4.907-2.474.098c-.584-3.256-1.601-4.374-3.883-4.374-2.186 0-3.738 1.264-3.738 3.061 0 1.702.776 2.722 3.299 4.325 2.281 1.507 4.127 2.819 5.293 3.937 1.407 1.263 2.133 2.964 2.133 4.859 0 4.325-3.639 7.63-8.298 7.63M327.947 35.522c-1.65.923-3.933 1.458-6.264 1.458-2.133 0-4.174-1.215-5.046-3.013-.73-1.506-.97-3.013-.97-6.317V15.21h-3.108v-2.236c3.834-.29 5.34-1.943 6.456-6.997h2.183v6.56h6.119l-.68 2.673h-5.44v11.954c0 5.977.78 7.386 4.079 7.386.776 0 1.506-.097 2.671-.437v1.41M374.498 22.936c-3.107.243-3.834 1.167-3.834 4.665v6.415l-.924.389c-2.814 1.166-4.514 1.652-7.232 2.138-2.087.34-4.174.534-6.212.534-11.313 0-18.594-6.9-18.594-17.542 0-5.734 2.186-11.128 5.825-14.286 3.107-2.722 7.622-4.18 13.06-4.18 2.814 0 6.552.389 9.464 1.02 1.407.292 2.087.535 3.593 1.167l.29 7.192-1.941.097c-.29-2.09-1.02-3.693-2.137-4.665-1.746-1.555-5.435-2.624-9.173-2.624-7.377 0-11.795 5.831-11.795 15.598 0 9.67 4.903 15.842 12.525 15.842 2.427 0 5.29-.631 6.842-1.41v-5.685c0-3.741-.971-4.713-4.805-4.713-.145 0-.29 0-.436.048l-.099-1.311c3.689.048 6.456.096 8.252.096 1.651 0 4.128-.048 7.427-.096l-.096 1.311M395.226 18.466l-2.186.194c0-.145-.046-.243-.046-.292 0-.096-.05-.34-.146-.68l-.194-.68c-.294-1.069-.777-1.41-2.041-1.41-2.913 0-4.709 2.187-4.709 5.832v8.747c0 4.616.535 5.248 3.933 5.248.145 0 .34 0 .535-.049l.096 1.167c-3.154-.098-5.535-.195-7.136-.195-1.503 0-3.785.097-6.843.195l.096-1.167c3.253 0 3.738-.631 3.738-5.2V18.904c0-4.519-.485-5.15-3.738-5.2l-.096-1.117c4.32-.243 5.29-.389 8.979-1.166l.29 4.373c2.817-3.596 3.983-4.227 7.38-4.227.292 0 .533 0 .632.048l1.02.243.192.049.244 6.56M29.513 9.136l-1.747.097c-.146-4.616-1.116-5.248-8.106-5.248h-1.505v26.58c0 3.645.922 4.617 4.514 4.714l.097 1.264c-3.398-.049-5.97-.049-7.67-.049-1.747 0-4.417 0-7.912.049l.097-1.264c3.592-.097 4.515-1.069 4.515-4.713V3.985h-1.748c-7.184 0-8.155.632-8.252 5.248L0 9.136l.194-7.532C6.796 1.652 11.7 1.7 15 1.7c3.156 0 7.961-.049 14.32-.097l.194 7.532M60.386 36.543c-2.816-.098-4.951-.195-6.36-.195-1.358 0-3.348.097-6.018.195l.097-1.167c2.573-.388 2.864-.874 2.864-5.2v-7.385c0-6.123-1.068-8.164-4.272-8.164-1.796 0-3.64 1.118-4.417 2.818-.291.584-.486 1.215-.68 1.847-.048.243-.048.437-.048.534v10.35c0 4.326.29 4.812 2.864 5.2l.097 1.167c-2.719-.098-4.709-.195-6.068-.195-1.408 0-3.543.097-6.31.195l.097-1.167c3.252 0 3.738-.631 3.738-5.2V7.97c0-4.568-.486-5.2-3.738-5.2l-.097-1.166c4.417-.243 5.437-.39 9.417-1.118V15.55c2.572-2.867 4.757-3.984 7.62-3.984 4.758 0 7.379 3.012 7.379 8.552v10.059c0 4.568.486 5.2 3.738 5.2l.097 1.166M73.735 13.266c-2.913 0-4.418 2.43-4.903 7.727 4.466-.098 5.825-.195 10.34-.68-.583-4.714-2.38-7.047-5.437-7.047zm-4.757 9.573c.194 7.387 2.864 11.566 7.33 11.566 2.67 0 4.902-1.215 7.28-3.985l.729 1.36c-3.01 3.742-5.97 5.297-9.854 5.297-6.747 0-11.31-4.956-11.31-12.294 0-7.824 4.708-13.217 11.504-13.217 3.738 0 6.359 1.36 8.155 4.324 1.214 2.041 1.553 3.45 1.602 6.95H68.978zM409.108 13.412c-3.543 0-5.34 3.062-5.34 9.136 0 .729.05 1.457.097 2.187.534 6.948 2.767 10.69 6.505 10.69 3.494 0 5.58-3.644 5.58-9.767 0-7.192-2.862-12.246-6.842-12.246zm.582 23.665c-6.942 0-11.601-4.665-11.845-11.808v-.729c0-8.213 4.418-12.974 11.99-12.974 7.04 0 11.99 5.248 11.99 12.78 0 7.629-4.805 12.731-12.135 12.731zM452.892 35.911c-4.32.243-5.29.389-8.979 1.166l-.293-4.227c-2.765 3.11-4.855 4.227-7.814 4.227-4.758 0-7.38-3.061-7.38-8.552v-9.622c0-4.519-.485-5.15-3.735-5.2l-.099-1.117c4.419-.292 5.485-.438 9.418-1.166v14.432c0 6.123 1.067 8.164 4.27 8.164 1.846 0 3.497-1.07 4.418-2.819.39-.777.776-1.895.776-2.38v-6.804l-.046-3.11c-.05-4.519-.44-5.15-3.738-5.2l-.1-1.117c4.469-.292 5.486-.438 9.419-1.166v15.064l.05 3.11c.049 4.519.484 5.15 3.737 5.2l.096 1.117M476.192 23.957c-.485-5.831-3.008-9.427-6.601-9.427-2.331 0-4.514 1.944-5.145 4.568-.29 1.166-.485 3.304-.485 5.54 0 6.51 2.377 10.544 6.31 10.544 3.834 0 6.017-3.401 6.017-9.476 0-.583-.046-1.166-.096-1.75zm-5.34 13.12c-2.813 0-4.563-.583-6.505-2.186v6.463c0 4.616.486 5.248 3.933 5.248.145 0 .34-.049.486-.049l.145 1.166c-3.203-.097-5.535-.194-7.136-.194-1.552 0-3.834.097-6.842.194l.095-1.166c3.253 0 3.738-.631 3.738-5.2v-22.45c0-4.519-.485-5.15-3.738-5.2l-.095-1.117c4.27-.243 5.29-.389 8.929-1.166l.294 4.325c2.717-3.013 4.9-4.18 7.813-4.18 5.924 0 9.999 5.054 9.999 12.392 0 7.63-4.61 13.12-11.115 13.12z"
    })));
  };

  b.defaultProps = {
    height: 48,
    width: 482
  }, b.propTypes = {
    height: l.number,
    width: l.number
  };

  var E = function E(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      height: t,
      viewBox: "0 0 24 24",
      width: l,
      fill: "#000000"
    }, a), n.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), n.createElement("path", {
      d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
    }));
  };

  E.defaultProps = {
    height: 24,
    width: 24
  }, E.propTypes = {
    height: l.number,
    width: l.number
  };

  var w = function w(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      height: t,
      viewBox: "0 0 24 24",
      width: l,
      fill: "#000000"
    }, a), n.createElement("path", {
      d: "M0 0h24v24H0V0z",
      fill: "none"
    }), n.createElement("path", {
      d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    }));
  };

  w.defaultProps = {
    height: 24,
    width: 24
  }, w.propTypes = {
    height: l.number,
    width: l.number
  };

  var M = function M(e) {
    e.height, e.width, o(e, ["height", "width"]);
    return n.createElement("svg", {
      width: "24",
      height: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, n.createElement("g", {
      transform: "translate(1 1)",
      "fill-rule": "nonzero"
    }, n.createElement("rect", {
      fill: "#0D0D0D",
      width: "22",
      height: "22",
      rx: "5"
    }), n.createElement("path", {
      d: "M10.328 19.26c-.656-.234-.797-.553-1.066-2.423-.313-2.173-.381-3.517-.2-3.944.24-.564.893-.885 1.806-.888.906-.004 1.564.32 1.806.888.182.426.114 1.771-.2 3.944-.212 1.518-.33 1.902-.623 2.16-.403.357-.975.456-1.518.264h-.005zm-2.803-2.23c-2.266-1.114-3.718-3-4.246-5.51-.132-.647-.154-2.192-.03-2.786.33-1.595.961-2.842 2.01-3.945 1.51-1.593 3.454-2.435 5.617-2.435 2.141 0 4.077.826 5.551 2.372 1.122 1.166 1.753 2.4 2.076 4.026.11.54.11 2.016.007 2.625a7.796 7.796 0 01-2.97 4.855c-.557.42-1.921 1.155-2.141 1.155-.08 0-.088-.083-.052-.421.066-.543.132-.656.44-.785.492-.205 1.328-.8 1.841-1.316a7.007 7.007 0 001.84-3.24c.191-.756.17-2.436-.043-3.213-.668-2.471-2.684-4.393-5.156-4.906-.718-.147-2.024-.147-2.75 0-2.5.513-4.568 2.53-5.199 5.067-.169.69-.169 2.37 0 3.058.418 1.68 1.503 3.22 2.926 4.136.279.184.616.374.755.433.308.132.374.242.433.785.037.33.03.425-.051.425-.052 0-.426-.161-.822-.352l-.036-.027zm.03-2.982c-.764-.609-1.438-1.688-1.717-2.747-.169-.64-.169-1.856.007-2.494.462-1.722 1.731-3.056 3.491-3.683.601-.213 1.936-.26 2.677-.097 2.552.568 4.363 3.124 4.011 5.66-.14 1.02-.491 1.86-1.115 2.64-.308.393-1.056 1.054-1.188 1.054-.022 0-.044-.25-.044-.553v-.555l.382-.454c1.437-1.722 1.334-4.128-.235-5.706-.609-.614-1.313-.975-2.222-1.141-.587-.109-.711-.109-1.327-.008-.935.153-1.66.515-2.303 1.152-1.577 1.562-1.68 3.98-.242 5.703l.378.454v.558c0 .308-.024.557-.054.557s-.242-.147-.47-.33l-.03-.01zm2.544-2.994c-.653-.304-1.005-.877-1.012-1.623 0-.671.374-1.257 1.02-1.599.41-.216 1.136-.216 1.546.001.448.233.814.684.954 1.155.425 1.446-1.108 2.713-2.494 2.066H10.1z",
      fill: "#FFF"
    }), n.createElement("circle", {
      fill: "#FFF",
      cx: "10.992",
      cy: "9.509",
      r: "1.829"
    }), n.createElement("path", {
      d: "M11.167 12.046c.127.017.38.05.613.125.234.073.447.189.613.307.16.117.278.239.352.387.073.148.11.324.132.612.014.29.014.69-.052 1.438-.066.745-.198 1.839-.3 2.54-.103.703-.176 1.011-.272 1.238a1.17 1.17 0 01-.36.5c-.138.11-.3.175-.454.212-.154.036-.293.036-.425.036s-.257 0-.425-.036c-.17-.037-.39-.103-.55-.235-.17-.132-.28-.323-.367-.572-.088-.25-.154-.55-.242-1.151a64.799 64.799 0 01-.279-2.178 17.292 17.292 0 01-.108-1.467c-.008-.315.007-.471.044-.623a1.25 1.25 0 01.176-.404 1.33 1.33 0 01.635-.485c.127-.051.28-.095.47-.132.19-.037.41-.073.523-.088.113-.017.113-.017.239 0l.037-.024z",
      fill: "#FFF"
    })), n.createElement("path", {
      d: "M0 0h24v24H0z"
    })));
  };

  M.defaultProps = {
    height: 24,
    width: 24
  }, M.propTypes = {
    height: l.number,
    width: l.number
  };

  var y = function y(e) {
    e.height, e.width, o(e, ["height", "width"]);
    return n.createElement("svg", {
      width: "24",
      height: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, n.createElement("g", {
      fill: "#0D0D0D",
      "fill-rule": "nonzero"
    }, n.createElement("path", {
      d: "M4.25 11.463v1.324c0 .67-.504 1.213-1.125 1.213S2 13.457 2 12.787v-1.324c0-.67.504-1.213 1.125-1.213s1.125.543 1.125 1.213zM19.75 11.498v-.035c0-.67.504-1.213 1.125-1.213S22 10.793 22 11.463V12.821c-.017.654-.514 1.179-1.125 1.179-.61 0-1.108-.525-1.125-1.179v-1.323zM8.75 15.45v1.33c0 .674-.504 1.22-1.125 1.22S6.5 17.454 6.5 16.78v-1.33c0-.673.504-1.219 1.125-1.219s1.125.546 1.125 1.22zm0-7.98v4.35c-.014.66-.512 1.192-1.125 1.192S6.514 12.48 6.5 11.82V7.47c0-.674.504-1.22 1.125-1.22s1.125.546 1.125 1.22zM15.25 8.787c0 .67.504 1.213 1.125 1.213S17.5 9.457 17.5 8.787V7.463c0-.67-.504-1.213-1.125-1.213s-1.125.543-1.125 1.213v1.324zM11 4.614c0 .69.504 1.25 1.125 1.25s1.125-.56 1.125-1.25V3.25c0-.69-.504-1.25-1.125-1.25S11 2.56 11 3.25v1.364zm0 14.772c0-.69.504-1.25 1.125-1.25s1.125.56 1.125 1.25v1.364c0 .69-.504 1.25-1.125 1.25S11 21.44 11 20.75v-1.364zM15.25 12.262c0-.697.504-1.262 1.125-1.262s1.125.565 1.125 1.262v4.476c0 .697-.504 1.262-1.125 1.262s-1.125-.565-1.125-1.262v-4.476zM13.25 8.497v7.256c0 .689-.504 1.247-1.125 1.247S11 16.442 11 15.753V8.497c0-.689.504-1.247 1.125-1.247s1.125.558 1.125 1.247z"
    })), n.createElement("path", {
      d: "M0 0h24v24H0z"
    })));
  };

  y.defaultProps = {
    height: 24,
    width: 24
  }, y.propTypes = {
    height: l.number,
    width: l.number
  };

  var k = function k(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      xmlns: "http://www.w3.org/2000/svg",
      width: l,
      height: t,
      fill: "none"
    }, a), n.createElement("rect", {
      width: "27",
      height: "27",
      x: ".5",
      y: ".5",
      fill: "#EBEEFA",
      rx: "1.5"
    }), n.createElement("path", {
      fill: "#333",
      d: "M14 6c-4.418 0-8 3.394-8 7.579v5.895C6 20.872 7.191 22 8.667 22h2.666v-6.737H7.778V13.58c0-3.259 2.782-5.895 6.222-5.895 3.44 0 6.222 2.636 6.222 5.895v1.684h-3.555V22h2.666C20.81 22 22 20.872 22 19.474v-5.895C22 9.394 18.418 6 14 6Z"
    }), n.createElement("rect", {
      width: "27",
      height: "27",
      x: ".5",
      y: ".5",
      stroke: "#D6DBF5",
      rx: "1.5"
    }));
  };

  k.defaultProps = {
    height: 28,
    width: 28
  }, k.propTypes = {
    height: l.number,
    width: l.number
  };

  var N = function N(e) {
    var t = e.height,
        l = e.width,
        a = e.id,
        r = o(e, ["height", "width", "id"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 305 154",
      role: "img",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }, r), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "The Economist"), n.createElement("path", {
      fill: "#E3120B",
      d: "M.032 153.503h304.925V.29H.032z"
    }), n.createElement("path", {
      d: "M140.895 31.914l.182 7.396-1.723.09c-.136-4.526-1.09-5.144-7.97-5.144h-1.472v25.91c0 3.579.91 4.527 4.435 4.626l.088 1.237c-3.337-.044-5.868-.044-7.474-.044-1.689 0-4.312 0-7.751.044l.088-1.237c3.534-.099 4.446-1.047 4.446-4.627v-25.91h-1.721c-7.067 0-8.022.619-8.113 5.145l-1.713-.09.17-7.396c6.45.043 11.277.102 14.515.102 3.03 0 7.751-.059 14.013-.102M143.753 64.883c3.199 0 3.63-.619 3.678-5.101V38.17c-.048-4.491-.48-5.113-3.678-5.113l-.096-1.145c4.348-.234 5.344-.382 9.27-1.09v14.693c2.527-2.723 4.584-3.82 7.404-3.82 4.672 0 7.255 2.864 7.255 8.305v9.782c.048 4.482.478 5.101 3.67 5.101l.082 1.146c-2.747-.09-4.848-.19-6.233-.19-1.346 0-3.303.1-5.927.19l.1-1.146c2.524-.377 2.766-.847 2.813-5.101V52.62c0-6.012-1.045-8.009-4.198-8.009-1.678 0-3.488 1.088-4.251 2.763-.287.574-.479 1.187-.671 1.808-.044.248-.044.43-.044.527v10.073c0 4.254.287 4.724 2.806 5.101l.103 1.146c-2.673-.09-4.64-.19-5.97-.19-1.385 0-3.489.1-6.209.19l.096-1.146M179.025 50.863c4.387-.098 5.722-.203 10.076-.674-.574-4.627-2.312-6.825-5.26-6.825-2.864 0-4.345 2.286-4.816 7.5m15.137 10.488c-2.964 3.678-5.87 5.21-9.609 5.21-6.628 0-11.115-4.87-11.115-11.99 0-7.672 4.63-12.879 11.31-12.879 3.59 0 6.173 1.331 7.938 4.153 1.191 2.009 1.521 3.387 1.566 6.827h-15.091c.2 7.158 2.817 11.258 7.18 11.258 2.57 0 4.764-1.195 7.108-3.91l.713 1.331M18.235 110.135c3.874-.099 4.878-1.155 4.878-5.127v-24.84c0-3.967-1.004-5.022-4.878-5.132l-.154-1.28 8.12.102 12.84-.162 3.38.06.21 7.68-2.118.16c-.365-4.808-1.264-5.337-8.798-5.337h-1.17l-.528.046v14.3c.996 0 1.804.056 2.282.056a38.02 38.02 0 0 0 2.437.098c4.142 0 5.097-.89 5.141-4.823h1.807c-.16 3.148-.16 4.778-.16 6.362 0 1.274 0 3.062.053 5.44h-1.7c-.208-3.793-1.06-4.538-5.034-4.585l-2.867-.06-2.012.107v11.07c0 4.502.263 4.71 4.716 4.71 5.891 0 7.643-1.324 8.164-6.367l2.12.113-1.219 8.787-4.076.057-12.879-.104-8.71.047.155-1.378M71.709 107.761c-3.017 3.122-5.417 4.34-8.906 4.34-6.983 0-11.458-5.449-11.458-13.66 0-8.57 4.726-13.937 12.356-13.937 2.01 0 4.042.37 7.177 1.22l.09 6.254-2.382.16c-.885-4.669-1.815-5.78-4.885-5.78-3.966 0-6.03 3.451-6.03 10.273 0 7.96 2.478 12.455 6.984 12.455 2.329 0 4.197-1.009 6.266-3.228l.788 1.903M83.847 98.75c.526 7.476 3.017 11.545 7.092 11.545 3.81 0 6.093-3.96 6.093-10.535 0-7.824-3.135-13.246-7.469-13.246-3.861 0-5.827 3.249-5.827 9.862 0 .795 0 1.586.111 2.375m-6.482.587v-.803c0-8.932 4.812-14.03 12.994-14.03 7.59 0 12.987 5.63 12.987 13.82 0 8.219-5.243 13.777-13.146 13.777-7.542 0-12.568-5.08-12.835-12.764M109.6 110.247c3.453 0 3.978-.69 3.978-5.657V92.4c0-4.824-.525-5.513-3.978-5.567l-.106-1.213c4.617-.266 5.684-.426 9.698-1.275l.271 4.687c3.017-3.309 5.345-4.528 8.485-4.528 5.143 0 8.048 3.338 8.048 9.227v10.86c-.048.416-.048.843-.048 1.267 0 3.385.897 4.389 4.13 4.389l.104 1.266c-3.07-.101-5.4-.21-6.937-.21-1.48 0-3.704.109-6.526.21l.093-1.266c2.729-.427 3.042-.95 3.042-5.657l.058-3.244v-4.714c0-6.657-1.22-8.79-4.571-8.79-2.07 0-3.816 1.06-4.874 2.978-.423.794-.79 2.055-.79 2.591v11.18c.052 4.707.318 5.23 3.121 5.656l.163 1.266c-2.966-.101-5.189-.21-6.671-.21-1.542 0-3.803.109-6.796.21l.106-1.266M151.208 98.75c.534 7.476 3.014 11.545 7.007 11.545 3.812 0 6.09-3.96 6.09-10.535 0-7.824-3.122-13.246-7.433-13.246-3.806 0-5.765 3.249-5.765 9.862 0 .795 0 1.586.1 2.375m-6.564.587v-.803c0-8.932 4.824-14.03 12.997-14.03 7.676 0 13.068 5.63 13.068 13.82 0 8.219-5.239 13.777-13.227 13.777-7.49 0-12.57-5.08-12.838-12.764M176.631 110.247c3.555 0 4.085-.69 4.085-5.657V92.4c0-4.824-.53-5.513-4.085-5.567l-.107-1.213c4.713-.266 5.783-.426 9.775-1.275l.237 4.687c2.979-3.254 5.313-4.528 8.435-4.528 3.6 0 5.712 1.484 7.214 4.94 3.235-3.62 5.612-4.94 8.846-4.94 4.996 0 7.793 3.388 7.793 9.227v10.86c0 .416-.053.843-.053 1.267 0 3.385.959 4.389 4.13 4.389l.115 1.266c-3.075-.101-5.403-.21-6.894-.21-1.435 0-3.614.109-6.521.21l.105-1.266c2.802-.427 3.069-.95 3.121-5.657v-7.958c0-6.554-1.152-8.79-4.445-8.79-1.957 0-3.972 1.19-4.819 2.978-.266.63-.526 1.27-.685 2.011-.054.262-.11.474-.11.58v11.18c0 4.707.318 5.23 3.121 5.656l.115 1.266c-2.807-.101-4.87-.21-6.271-.21-1.372 0-3.442.109-6.196.21l.111-1.266c2.805-.427 3.07-.95 3.115-5.657v-7.958c0-6.554-1.158-8.79-4.447-8.79-2.001 0-3.806 1.107-4.813 2.978-.426.843-.767 2.055-.767 2.591v11.18c.053 4.707.29 5.23 3.098 5.656l.106 1.266c-2.914-.101-5.052-.21-6.528-.21-1.543 0-3.814.109-6.888.21l.107-1.266M231.001 75.52a3.498 3.498 0 0 1 3.502-3.51c1.965 0 3.547 1.629 3.547 3.51 0 2.002-1.531 3.595-3.547 3.595-2.01 0-3.502-1.537-3.502-3.595m6.783 8.825v17.001l.05 3.244c0 4.966.485 5.655 4.078 5.655l.111 1.268c-3.288-.101-5.669-.209-7.307-.209-1.585 0-3.908.108-7.112.209l.1-1.268c3.496 0 3.995-.689 3.995-5.655l.049-3.244V95.79l-.049-3.388c0-4.826-.5-5.515-3.995-5.568l-.1-1.215c4.784-.315 5.889-.478 10.18-1.274M248.398 110.566l-.208-5.404 2.695-.099c1.219 4.074 2.017 4.864 4.825 4.864 2.43 0 4.024-1.266 4.024-3.168 0-1.807-1.11-3.119-4.453-5.36-1.69-1.164-2.852-1.965-3.486-2.435-1.382-1.057-2.387-2.332-2.918-3.754-.324-.796-.479-1.744-.479-2.857 0-4.719 3.292-7.849 8.261-7.849 1.851 0 2.912.158 7.112 1.164l.115 5.256-2.691.11c-.6-3.458-1.675-4.676-4.16-4.676-2.383 0-4.081 1.378-4.081 3.243 0 1.849.853 2.96 3.604 4.706 2.484 1.645 4.387 3.12 5.68 4.285 1.485 1.426 2.336 3.224 2.336 5.225 0 4.677-3.93 8.284-8.97 8.284-1.955 0-3.809-.435-7.206-1.535M270.18 86.043c4.176-.32 5.756-2.113 6.954-7.622h2.38v7.145h6.676l-.746 2.909h-5.93v12.924c0 6.42.851 7.947 4.45 7.947.844 0 1.635-.104 2.912-.47v1.53c-1.797 1.007-4.285 1.586-6.823 1.586-2.343 0-4.513-1.318-5.423-3.28-.796-1.64-1.056-3.278-1.056-6.787v-13.45h-3.394v-2.432",
      fill: "#FFF"
    }));
  };

  N.defaultProps = {
    height: 154,
    id: "ds-economist-logo",
    width: 305
  }, N.propTypes = {
    height: l.number,
    width: l.number,
    id: l.string
  };

  var x = function x(e) {
    var t = e.height,
        l = e.width,
        a = e.id,
        r = o(e, ["height", "width", "id"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      style: {
        border: "".concat(l < 256 ? 1 : 2, "px solid white")
      },
      viewBox: "0 0 304 152",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }, r), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "The Economist"), n.createElement("path", {
      fill: "#FFF",
      d: "M140.433 31.601l.182 7.324-1.718.09c-.136-4.483-1.087-5.095-7.944-5.095h-1.467v25.656c0 3.545.907 4.483 4.42 4.581l.088 1.225c-3.326-.043-5.848-.043-7.45-.043-1.683 0-4.297 0-7.725.043l.088-1.225c3.522-.098 4.431-1.036 4.431-4.581V33.92h-1.715c-7.044 0-7.996.612-8.086 5.094l-1.708-.09.17-7.323c6.43.043 11.24.101 14.467.101 3.02 0 7.726-.058 13.967-.101m2.849 32.647c3.188 0 3.618-.613 3.665-5.051v-21.4c-.047-4.448-.477-5.064-3.665-5.064l-.096-1.133c4.334-.232 5.327-.378 9.24-1.08v14.55c2.519-2.697 4.568-3.784 7.38-3.784 4.656 0 7.231 2.837 7.231 8.225v9.686c.047 4.438.476 5.05 3.657 5.05l.082 1.135c-2.738-.089-4.832-.188-6.212-.188-1.342 0-3.293.1-5.908.188l.099-1.134c2.516-.374 2.758-.839 2.804-5.051v-7.093c0-5.952-1.04-7.93-4.184-7.93-1.672 0-3.476 1.078-4.237 2.736-.286.569-.477 1.175-.669 1.79-.044.246-.044.427-.044.522v9.975c0 4.212.286 4.677 2.798 5.05l.102 1.135c-2.664-.089-4.625-.188-5.951-.188-1.38 0-3.477.1-6.188.188l.096-1.134m35.156-13.883c4.373-.097 5.703-.201 10.043-.668-.573-4.581-2.305-6.758-5.243-6.758-2.854 0-4.33 2.264-4.8 7.426m15.087 10.386c-2.954 3.642-5.85 5.159-9.577 5.159-6.607 0-11.078-4.822-11.078-11.872 0-7.598 4.615-12.753 11.271-12.753 3.579 0 6.154 1.318 7.913 4.112 1.188 1.989 1.516 3.354 1.561 6.76h-15.042c.2 7.088 2.808 11.148 7.157 11.148 2.562 0 4.748-1.183 7.084-3.871l.711 1.317M18.176 109.056c3.86-.097 4.862-1.143 4.862-5.077V79.384c0-3.929-1.001-4.974-4.862-5.083l-.155-1.267 8.094.1 12.798-.16 3.369.06.21 7.605-2.112.158c-.364-4.76-1.26-5.285-8.769-5.285h-1.166l-.526.045v14.16c.992 0 1.797.056 2.274.056a38.18 38.18 0 002.43.097c4.128 0 5.08-.882 5.123-4.776h1.801c-.159 3.117-.159 4.732-.159 6.3 0 1.262 0 3.032.053 5.388h-1.695c-.207-3.757-1.056-4.495-5.018-4.541l-2.857-.06-2.005.106v10.962c0 4.458.262 4.664 4.7 4.664 5.872 0 7.618-1.311 8.138-6.305l2.113.112-1.215 8.7-4.063.058-12.837-.104-8.68.047.154-1.365m53.298-2.35c-3.007 3.092-5.4 4.297-8.877 4.297-6.96 0-11.42-5.395-11.42-13.526 0-8.487 4.71-13.8 12.316-13.8 2.003 0 4.028.367 7.153 1.207l.089 6.193-2.374.16c-.882-4.624-1.81-5.725-4.868-5.725-3.954 0-6.01 3.418-6.01 10.173 0 7.881 2.469 12.332 6.96 12.332 2.321 0 4.183-.998 6.246-3.195l.785 1.884m12.098-8.922c.524 7.402 3.007 11.431 7.07 11.431 3.796 0 6.072-3.922 6.072-10.432 0-7.747-3.125-13.116-7.444-13.116-3.85 0-5.808 3.217-5.808 9.765 0 .788 0 1.57.11 2.352m-6.46.581v-.795c0-8.844 4.796-13.893 12.95-13.893 7.566 0 12.945 5.575 12.945 13.686 0 8.137-5.226 13.64-13.102 13.64-7.518 0-12.527-5.03-12.794-12.638m32.129 10.802c3.443 0 3.966-.682 3.966-5.6V91.495c0-4.777-.523-5.46-3.965-5.513l-.106-1.201c4.602-.264 5.665-.423 9.666-1.263l.27 4.641c3.007-3.276 5.328-4.483 8.457-4.483 5.127 0 8.022 3.305 8.022 9.136v10.753c-.047.412-.047.836-.047 1.256 0 3.351.894 4.345 4.116 4.345l.104 1.254c-3.06-.1-5.383-.208-6.915-.208-1.474 0-3.692.108-6.505.208l.093-1.254c2.72-.422 3.032-.94 3.032-5.6l.058-3.213v-4.668c0-6.593-1.216-8.704-4.556-8.704-2.063 0-3.803 1.05-4.858 2.949-.422.786-.788 2.035-.788 2.565v11.07c.052 4.661.317 5.179 3.112 5.601l.162 1.254c-2.957-.1-5.172-.208-6.65-.208-1.536 0-3.79.108-6.773.208l.106-1.254m41.471-11.382c.533 7.402 3.005 11.431 6.984 11.431 3.8 0 6.07-3.922 6.07-10.432 0-7.747-3.111-13.116-7.408-13.116-3.794 0-5.747 3.217-5.747 9.765 0 .788 0 1.57.101 2.352m-6.543.581v-.795c0-8.844 4.808-13.893 12.954-13.893 7.65 0 13.025 5.575 13.025 13.686 0 8.137-5.221 13.64-13.184 13.64-7.466 0-12.529-5.03-12.795-12.638m31.883 10.802c3.543 0 4.071-.682 4.071-5.6V91.495c0-4.777-.528-5.46-4.071-5.513l-.107-1.201c4.698-.264 5.764-.423 9.743-1.263l.237 4.641c2.968-3.223 5.295-4.483 8.407-4.483 3.587 0 5.693 1.47 7.19 4.892 3.225-3.585 5.594-4.892 8.817-4.892 4.98 0 7.768 3.354 7.768 9.136v10.753c0 .412-.054.836-.054 1.256 0 3.351.956 4.345 4.117 4.345l.115 1.254c-3.065-.1-5.386-.208-6.872-.208-1.43 0-3.602.108-6.5.208l.105-1.254c2.793-.422 3.06-.94 3.111-5.6v-7.881c0-6.49-1.148-8.704-4.43-8.704-1.951 0-3.96 1.178-4.803 2.949-.265.623-.524 1.257-.683 1.991-.054.26-.11.47-.11.574v11.07c0 4.661.317 5.179 3.11 5.601l.115 1.254c-2.797-.1-4.853-.208-6.25-.208-1.367 0-3.43.108-6.176.208l.111-1.254c2.796-.422 3.06-.94 3.105-5.6v-7.881c0-6.49-1.155-8.704-4.432-8.704-1.995 0-3.794 1.096-4.798 2.949-.424.834-.764 2.035-.764 2.565v11.07c.052 4.661.29 5.179 3.088 5.601l.105 1.254c-2.904-.1-5.035-.208-6.506-.208-1.539 0-3.802.108-6.866.208l.107-1.254m54.192-34.386a3.475 3.475 0 013.49-3.476c1.958 0 3.535 1.614 3.535 3.476 0 1.983-1.526 3.56-3.535 3.56-2.002 0-3.49-1.522-3.49-3.56m6.76 8.739v16.835l.05 3.212c0 4.918.483 5.599 4.065 5.599l.11 1.256c-3.276-.1-5.65-.207-7.283-.207-1.58 0-3.895.107-7.088.207l.1-1.256c3.484 0 3.982-.681 3.982-5.599l.048-3.212v-5.502l-.048-3.354c0-4.78-.498-5.462-3.982-5.514l-.1-1.203c4.768-.313 5.87-.474 10.146-1.262m10.58 25.964l-.207-5.351 2.685-.098c1.215 4.034 2.01 4.816 4.81 4.816 2.422 0 4.01-1.253 4.01-3.137 0-1.788-1.105-3.088-4.438-5.307-1.685-1.153-2.842-1.945-3.475-2.411-1.377-1.047-2.379-2.31-2.908-3.718-.322-.788-.477-1.727-.477-2.828 0-4.673 3.28-7.772 8.234-7.772 1.845 0 2.902.156 7.088 1.152l.115 5.204-2.683.109c-.598-3.423-1.669-4.63-4.145-4.63-2.376 0-4.069 1.365-4.069 3.212 0 1.83.85 2.93 3.593 4.66 2.476 1.628 4.372 3.09 5.661 4.243 1.48 1.412 2.328 3.192 2.328 5.173 0 4.632-3.917 8.203-8.94 8.203-1.948 0-3.797-.431-7.182-1.52m21.71-24.283c4.162-.316 5.738-2.092 6.931-7.547h2.373v7.075h6.654l-.744 2.88h-5.91v12.798c0 6.357.848 7.87 4.434 7.87.842 0 1.63-.104 2.904-.466v1.515c-1.792.997-4.272 1.57-6.8 1.57-2.337 0-4.5-1.305-5.406-3.247-.794-1.625-1.053-3.246-1.053-6.721V87.608h-3.383v-2.407"
    }));
  };

  x.defaultProps = {
    width: 304,
    height: 152,
    id: "ds-economist-logo-keyline"
  }, x.propTypes = {
    height: l.number,
    width: l.number,
    id: l.string
  };

  var L = function L(e) {
    var t = e.height,
        l = e.id,
        a = e.inverse,
        r = e.width,
        c = o(e, ["height", "id", "inverse", "width"]);
    return n.createElement("svg", i({
      width: r,
      height: t,
      viewBox: "0 0 80 80"
    }, c, {
      role: "img",
      id: l,
      "aria-labelledby": "".concat(l, "-title")
    }), n.createElement("title", {
      id: "".concat(l, "-title")
    }, "The Economist"), n.createElement("path", {
      d: "M80 40C80 17.909 62.091 0 40 0S0 17.909 0 40s17.909 40 40 40 40-17.909 40-40",
      fill: a ? "#FFF" : "#E3120B"
    }), n.createElement("path", {
      d: "M57.718 53.28l-1.595 11.65-5.34.07-16.99-.139-11.511.07.208-1.803c5.062-.14 6.38-1.526 6.38-6.727V23.6c0-5.2-1.318-6.588-6.38-6.727l-.208-1.803 10.749.14L49.95 15l4.439.07.277 10.194-2.774.208c-.485-6.311-1.664-7.004-11.65-7.004h-1.526l-.694.069v18.862c1.318 0 2.358.07 2.983.07 1.11.07 2.15.139 3.19.139 5.547 0 6.796-1.18 6.865-6.45h2.358c-.208 4.23-.208 6.38-.208 8.46 0 1.665 0 4.023.07 7.143h-2.22c-.277-4.993-1.387-5.964-6.727-6.033l-3.744-.07-2.636.14V55.43c0 5.894.347 6.172 6.172 6.172 7.836 0 10.125-1.734 10.818-8.46l2.774.138",
      fill: a ? "#E3120B" : "#FFF"
    }));
  };

  L.defaultProps = {
    height: 80,
    id: "ds-monogram-circle",
    inverse: !1,
    width: 80
  }, L.propTypes = {
    height: l.number,
    id: l.string,
    inverse: l.bool,
    width: l.number
  };

  var T = function T(e) {
    var t = e.height,
        l = e.id,
        a = e.inverse,
        r = e.width,
        c = o(e, ["height", "id", "inverse", "width"]);
    return n.createElement("svg", i({
      width: r,
      height: t,
      viewBox: "0 0 80 80"
    }, c, {
      role: "img",
      id: l,
      "aria-labelledby": "".concat(l, "-title")
    }), n.createElement("title", {
      id: "".concat(l, "-title")
    }, "The Economist"), n.createElement("path", {
      d: "M21.793 0h36.414c7.578 0 10.326.789 13.096 2.27a15.447 15.447 0 016.426 6.427C79.211 11.467 80 14.215 80 21.793v36.414c0 7.578-.789 10.326-2.27 13.096a15.447 15.447 0 01-6.427 6.426C68.533 79.211 65.785 80 58.207 80H21.793c-7.578 0-10.326-.789-13.096-2.27a15.447 15.447 0 01-6.426-6.427C.789 68.533 0 65.785 0 58.207V21.793c0-7.578.789-10.326 2.27-13.096A15.447 15.447 0 018.698 2.27C11.467.789 14.215 0 21.793 0z",
      fill: a ? "#FFF" : "#E3120B"
    }), n.createElement("path", {
      d: "M57.703 53.28l-1.595 11.65-5.34.07-16.99-.139-11.511.07.208-1.803c5.062-.14 6.38-1.526 6.38-6.727V23.6c0-5.2-1.318-6.588-6.38-6.727l-.208-1.803 10.749.14L49.936 15l4.439.07.277 10.194-2.774.208c-.485-6.311-1.664-7.004-11.65-7.004h-1.526l-.694.069v18.862c1.318 0 2.358.07 2.983.07 1.11.07 2.15.139 3.19.139 5.547 0 6.796-1.18 6.865-6.45h2.358c-.208 4.23-.208 6.38-.208 8.46 0 1.665 0 4.023.07 7.143h-2.22c-.277-4.993-1.387-5.964-6.727-6.033l-3.744-.07-2.636.14V55.43c0 5.894.347 6.172 6.172 6.172 7.836 0 10.125-1.734 10.818-8.46l2.774.138",
      fill: a ? "#E3120B" : "#FFF"
    }));
  };

  T.defaultProps = {
    height: 80,
    id: "ds-monogram-rounded",
    inverse: !1,
    width: 80
  }, T.propTypes = {
    height: l.number,
    id: l.string,
    inverse: l.bool,
    width: l.number
  };

  var z = function z(e) {
    var t = e.height,
        l = e.inverse,
        a = e.id,
        r = e.width,
        c = o(e, ["height", "inverse", "id", "width"]);
    return n.createElement("svg", i({
      width: r,
      height: t,
      viewBox: "0 0 80 80"
    }, c, {
      role: "img",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "The Economist"), n.createElement("path", {
      fill: l ? "#FFF" : "#E3120B",
      d: "M0 79.996h80V0H0z"
    }), n.createElement("path", {
      d: "M57.703 53.28l-1.595 11.65-5.34.07-16.99-.139-11.511.07.208-1.803c5.062-.14 6.38-1.526 6.38-6.727V23.6c0-5.2-1.318-6.588-6.38-6.727l-.208-1.803 10.749.14L49.936 15l4.439.07.277 10.194-2.774.208c-.485-6.311-1.664-7.004-11.65-7.004h-1.526l-.694.069v18.862c1.318 0 2.358.07 2.983.07 1.11.07 2.15.139 3.19.139 5.547 0 6.796-1.18 6.865-6.45h2.358c-.208 4.23-.208 6.38-.208 8.46 0 1.665 0 4.023.07 7.143h-2.22c-.277-4.993-1.387-5.964-6.727-6.033l-3.744-.07-2.636.14V55.43c0 5.894.347 6.172 6.172 6.172 7.836 0 10.125-1.734 10.818-8.46l2.774.138",
      fill: l ? "#E3120B" : "#FFF"
    }));
  };

  z.defaultProps = {
    height: 80,
    id: "ds-monogram-square",
    inverse: !1,
    width: 80
  }, z.propTypes = {
    height: l.number,
    id: l.string,
    inverse: l.bool,
    width: l.number
  };

  var j = function j(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "Facebook"), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M17.49 26v-9.123h2.95l.44-3.555h-3.39v-2.27c0-1.03.276-1.731 1.697-1.731H21V6.14A23.34 23.34 0 0 0 18.359 6c-2.614 0-4.403 1.657-4.403 4.7v2.622H11v3.555h2.956V26h3.535z",
      fill: "#FFF",
      fillRule: "nonzero"
    })));
  },
      D = function D(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "Instagram"), n.createElement("defs", null, n.createElement("path", {
      id: "a",
      d: "M0 .006h19.994v19.992H0z"
    })), n.createElement("g", {
      id: "share-instagram",
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("g", {
      transform: "translate(6 6)"
    }, n.createElement("mask", {
      id: "b",
      fill: "#fff"
    }, n.createElement("use", {
      xlinkHref: "#a"
    })), n.createElement("path", {
      className: "path-foreground",
      d: "M9.997.006c-2.715 0-3.056.012-4.122.06-1.064.049-1.79.218-2.426.465a4.9 4.9 0 0 0-1.771 1.153 4.9 4.9 0 0 0-1.153 1.77C.278 4.092.109 4.818.06 5.882.012 6.948 0 7.288 0 10.003s.012 3.056.06 4.122c.049 1.064.218 1.79.465 2.426a4.9 4.9 0 0 0 1.153 1.771 4.9 4.9 0 0 0 1.77 1.153c.636.247 1.363.416 2.427.465 1.066.048 1.407.06 4.122.06s3.055-.012 4.122-.06c1.064-.049 1.79-.218 2.426-.465a4.9 4.9 0 0 0 1.77-1.153 4.9 4.9 0 0 0 1.154-1.77c.247-.636.416-1.363.465-2.427.048-1.066.06-1.407.06-4.122s-.012-3.055-.06-4.122c-.049-1.064-.218-1.79-.465-2.426a4.9 4.9 0 0 0-1.153-1.77A4.9 4.9 0 0 0 16.546.53c-.637-.247-1.363-.416-2.427-.465-1.067-.048-1.407-.06-4.122-.06zm0 1.802c2.67 0 2.985.01 4.04.058.974.044 1.503.207 1.856.344.466.181.8.398 1.15.748.349.35.566.683.747 1.15.137.352.3.88.344 1.856.048 1.054.058 1.37.058 4.04 0 2.668-.01 2.985-.058 4.039-.044.974-.207 1.504-.344 1.856-.181.467-.398.8-.748 1.15-.35.35-.683.566-1.15.747-.352.137-.88.3-1.856.344-1.054.049-1.37.059-4.04.059-2.669 0-2.985-.01-4.039-.059-.974-.044-1.504-.207-1.856-.344a3.097 3.097 0 0 1-1.15-.748 3.097 3.097 0 0 1-.747-1.149c-.137-.352-.3-.882-.344-1.856-.049-1.054-.059-1.37-.059-4.04s.01-2.985.059-4.04c.044-.974.207-1.503.344-1.856.181-.466.398-.8.748-1.15.35-.349.682-.566 1.149-.747.352-.137.882-.3 1.856-.344 1.054-.048 1.37-.058 4.04-.058z",
      fill: "#FFF",
      mask: "url(#b)"
    })), n.createElement("path", {
      className: "path-foreground",
      d: "M15.997 19.335a3.332 3.332 0 1 1 0-6.664 3.332 3.332 0 0 1 0 6.664zm0-8.465a5.133 5.133 0 1 0 0 10.267 5.133 5.133 0 0 0 0-10.267zM22.533 10.667a1.2 1.2 0 1 1-2.4 0 1.2 1.2 0 0 1 2.4 0",
      fill: "#FFF"
    })));
  },
      I = function I(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "LinkedIn"), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M25 24h-3.728v-5.847c0-1.395-.025-3.188-1.938-3.188-1.942 0-2.239 1.519-2.239 3.087V24h-3.728V11.977h3.579v1.642h.05c.497-.945 1.714-1.941 3.53-1.941 3.777 0 4.474 2.49 4.474 5.727V24zM9.163 10.333A2.165 2.165 0 0 1 7 8.166C7 6.971 7.968 6 9.163 6c1.193 0 2.162.97 2.162 2.166s-.969 2.167-2.162 2.167zM7.297 24h3.73V11.977h-3.73V24z",
      fill: "#FFF"
    })));
  },
      S = function S(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "RSS"), n.createElement("g", {
      id: "share-rss",
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("circle", {
      className: "path-foreground",
      fill: "#FFF",
      cx: 11.453,
      cy: 21.052,
      r: 2.453
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M9 6v3.184c7.909 0 14.321 6.412 14.321 14.321h3.184C26.505 13.841 18.664 6 9 6zm0 6.367v3.184c4.387 0 7.954 3.566 7.954 7.954h3.183c0-6.154-4.983-11.137-11.137-11.137z",
      fill: "#FFF",
      fillRule: "nonzero"
    })));
  },
      C = function C(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "Twitter"), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M12.29 24c7.547 0 11.675-5.771 11.675-10.776 0-.164 0-.327-.012-.49A8.024 8.024 0 0 0 26 10.774a8.73 8.73 0 0 1-2.357.596c.857-.474 1.498-1.218 1.804-2.095a8.65 8.65 0 0 1-2.605.919c-1.272-1.248-3.293-1.554-4.93-.745-1.637.808-2.483 2.53-2.063 4.2-3.3-.153-6.373-1.592-8.457-3.958-1.09 1.73-.533 3.945 1.27 5.056a4.335 4.335 0 0 1-1.862-.474v.048c0 1.803 1.377 3.356 3.292 3.713a4.429 4.429 0 0 1-1.853.065c.538 1.542 2.078 2.6 3.834 2.63-1.453 1.054-3.248 1.626-5.096 1.624-.327 0-.653-.018-.977-.054a12.334 12.334 0 0 0 6.29 1.698",
      fill: "#FFF"
    })));
  },
      O = function O(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "WhatsApp"), n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M21.582 16.985c-.249-.124-1.472-.723-1.7-.806-.228-.082-.394-.123-.56.124-.166.248-.643.806-.788.971-.145.166-.29.186-.54.062-.248-.124-1.05-.385-2-1.229-.74-.656-1.24-1.467-1.384-1.715-.145-.248-.016-.382.109-.506.112-.11.249-.289.373-.433.124-.145.166-.248.249-.414.083-.165.041-.31-.02-.433-.063-.124-.56-1.343-.768-1.84-.202-.482-.407-.416-.56-.424a10.027 10.027 0 00-.477-.009.916.916 0 00-.663.31c-.228.248-.871.847-.871 2.066 0 1.219.891 2.396 1.016 2.561.124.166 1.754 2.667 4.25 3.74.594.255 1.058.407 1.419.521.596.189 1.138.162 1.567.098.478-.07 1.472-.599 1.68-1.177.207-.579.207-1.074.145-1.178-.062-.103-.228-.165-.477-.289m-4.54 6.17h-.004a8.294 8.294 0 01-4.212-1.149l-.302-.178-3.133.817.836-3.04-.197-.31a8.189 8.189 0 01-1.265-4.385c.002-4.541 3.715-8.236 8.28-8.236a8.24 8.24 0 015.852 2.416 8.168 8.168 0 012.422 5.827c-.002 4.542-3.715 8.237-8.277 8.237m7.044-15.248A9.917 9.917 0 0017.042 5c-5.49 0-9.956 4.446-9.959 9.91 0 1.747.458 3.451 1.33 4.954L7 25l5.279-1.378a9.987 9.987 0 004.759 1.206h.004c5.488 0 9.956-4.446 9.958-9.91a9.827 9.827 0 00-2.914-7.012",
      fill: "#FFF"
    })));
  },
      A = function A(e) {
    return n.createElement("svg", i({
      viewBox: "-1 -1 34 34",
      width: 32,
      height: 32
    }, e), n.createElement("title", null, "YouTube"), n.createElement("g", {
      id: "share-youtube",
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("circle", {
      className: "path-background",
      fill: "#333",
      cx: 16,
      cy: 16,
      r: 16
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M25.582 11.186C26 12.746 26 16 26 16s0 3.254-.418 4.814a2.504 2.504 0 0 1-1.768 1.768C22.254 23 16 23 16 23s-6.254 0-7.814-.418a2.504 2.504 0 0 1-1.768-1.768C6 19.254 6 16 6 16s0-3.254.418-4.814c.23-.86.908-1.538 1.768-1.768C9.746 9 16 9 16 9s6.254 0 7.814.418c.86.23 1.538.908 1.768 1.768zm-11.515 7.772l5.196-3-5.196-3v6z",
      fill: "#FFF"
    })));
  },
      F = function F(e) {
    var t = e.height,
        l = e.inverse,
        a = e.width,
        r = o(e, ["height", "inverse", "width"]);
    return n.createElement("svg", i({
      width: a,
      height: t,
      viewBox: "0 0 336 39"
    }, r), n.createElement("g", {
      fill: l ? "#FFF" : "#E3120B",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M280.146 38.087c-2.883-.101-5.07-.202-6.512-.202-1.393 0-3.431.1-6.166.202l.1-1.215c2.635-.404 2.933-.91 2.933-5.414v-7.692c0-6.274-1.094-8.5-4.176-8.5-1.84 0-3.73 1.214-4.524 2.934-.25.607-.498 1.215-.647 1.923-.05.253-.1.455-.1.557v10.778c0 4.504.3 5.01 2.934 5.414l.1 1.215c-2.636-.101-4.624-.202-5.967-.202-1.293 0-3.232.1-5.817.202l.1-1.215c2.635-.404 2.933-.91 2.933-5.414v-7.692c0-6.274-1.094-8.5-4.176-8.5-1.89 0-3.58 1.112-4.525 2.934-.397.81-.745 1.974-.745 2.48v10.778c0 4.504.298 5.01 2.933 5.414l.1 1.215c-2.735-.101-4.823-.202-6.215-.202-1.442 0-3.58.1-6.464.202l.1-1.215c3.33 0 3.828-.657 3.828-5.414v-11.74c0-4.706-.497-5.363-3.828-5.414l-.1-1.164c4.425-.253 5.42-.405 9.198-1.214l.249 4.554c2.834-3.188 5.021-4.403 7.955-4.403 3.38 0 5.37 1.417 6.861 4.807 3.033-3.542 5.27-4.807 8.303-4.807 4.723 0 7.408 3.239 7.408 8.906v10.475c0 .405-.05.81-.05 1.215 0 3.238.895 4.2 3.878 4.2l.1 1.214M290.31 6.882c-1.889 0-3.33-1.467-3.33-3.441 0-1.923 1.49-3.441 3.33-3.441s3.331 1.569 3.331 3.441c0 1.923-1.442 3.441-3.33 3.441zm7.06 31.171c-3.082-.101-5.32-.202-6.86-.202-1.492 0-3.73.1-6.763.202l.1-1.214c3.331 0 3.779-.658 3.828-5.415l.05-3.188v-5.313l-.05-3.239c-.05-4.705-.497-5.363-3.828-5.414l-.1-1.164c4.575-.303 5.619-.455 9.646-1.214v16.344l.05 3.188c.049 4.757.447 5.415 3.828 5.415l.1 1.214zM307.809 38.814c-1.84 0-3.58-.404-6.762-1.467l-.199-5.161 2.536-.102c1.143 3.897 1.89 4.656 4.524 4.656 2.287 0 3.779-1.215 3.779-3.036 0-1.72-1.044-3.036-4.176-5.212-1.591-1.114-2.685-1.873-3.282-2.328-1.293-1.013-2.237-2.227-2.734-3.593-.299-.759-.448-1.67-.448-2.733 0-4.604 3.083-7.59 7.756-7.59 1.74 0 2.735.152 6.762 1.113l.1 5.111-2.536.101c-.597-3.39-1.64-4.554-3.978-4.554-2.237 0-3.828 1.316-3.828 3.188 0 1.771.795 2.834 3.38 4.504 2.338 1.568 4.227 2.935 5.42 4.098 1.442 1.316 2.188 3.087 2.188 5.061 0 4.503-3.729 7.944-8.502 7.944M335.927 37.213c-1.69.96-4.028 1.518-6.413 1.518-2.188 0-4.275-1.265-5.171-3.138-.744-1.569-.994-3.137-.994-6.578V16.061h-3.183v-2.328c3.93-.303 5.469-2.024 6.612-7.287h2.24v6.832h6.263l-.697 2.783h-5.567v12.448c0 6.224.795 7.691 4.177 7.691.795 0 1.54-.1 2.733-.455v1.468M30.229 9.777l-1.79.101c-.15-4.807-1.144-5.465-8.303-5.465h-1.541v27.68c0 3.795.944 4.807 4.624 4.908l.1 1.316c-3.481-.05-6.116-.05-7.856-.05-1.79 0-4.525 0-8.105.05l.1-1.316c3.68-.1 4.624-1.113 4.624-4.908V4.413h-1.79c-7.358 0-8.353.658-8.452 5.465L0 9.778l.2-7.844c6.76.05 11.782.101 15.163.101 3.232 0 8.154-.05 14.667-.101l.199 7.843M61.871 38.192c-2.884-.102-5.071-.202-6.513-.202-1.392 0-3.43.1-6.166.202l.1-1.215c2.635-.405 2.934-.91 2.934-5.414V23.87c0-6.375-1.094-8.501-4.376-8.501-1.84 0-3.729 1.164-4.524 2.935-.298.607-.497 1.265-.696 1.923-.05.253-.05.455-.05.556v10.779c0 4.504.298 5.01 2.934 5.414l.099 1.215c-2.784-.102-4.823-.202-6.215-.202-1.442 0-3.629.1-6.463.202l.1-1.215c3.33 0 3.828-.658 3.828-5.414V8.438c0-4.757-.497-5.415-3.829-5.415l-.099-1.214c4.524-.254 5.569-.405 9.645-1.164V16.33c2.635-2.985 4.873-4.15 7.806-4.15 4.873 0 7.557 3.139 7.557 8.907v10.475c0 4.756.498 5.414 3.828 5.414l.1 1.215M75.441 14.019c-2.982 0-4.524 2.53-5.021 8.046 4.574-.101 5.966-.202 10.59-.708-.596-4.909-2.436-7.338-5.569-7.338zm-4.872 9.969c.2 7.691 2.934 12.043 7.508 12.043 2.734 0 5.021-1.265 7.458-4.15l.745 1.418c-3.082 3.896-6.115 5.515-10.093 5.515-6.91 0-11.584-5.161-11.584-12.802 0-8.147 4.823-13.764 11.783-13.764 3.829 0 6.513 1.417 8.353 4.504 1.243 2.125 1.59 3.592 1.64 7.236H70.57zM121.994 29.544l-1.143 8.502-3.829.05-12.18-.101-8.254.05.15-1.315c3.628-.102 4.573-1.114 4.573-4.909V7.886c0-3.795-.945-4.807-4.573-4.908l-.15-1.316 7.707.101 12.13-.151 3.183.05.199 7.439-1.99.152c-.347-4.606-1.192-5.111-8.352-5.111h-1.093l-.498.05v13.764c.945 0 1.69.051 2.138.051.795.05 1.542.1 2.287.1 3.978 0 4.873-.86 4.922-4.705h1.69c-.148 3.087-.148 4.655-.148 6.173 0 1.215 0 2.935.05 5.213h-1.592c-.199-3.644-.994-4.352-4.822-4.403l-2.685-.05-1.89.1v10.678c0 4.3.249 4.503 4.425 4.503 5.619 0 7.26-1.264 7.757-6.173l1.988.101M145.964 34.665c-2.834 2.986-5.171 4.15-8.452 4.15-6.564 0-10.84-5.213-10.84-13.157.001-8.198 4.525-13.41 11.685-13.41 1.89 0 3.828.354 6.811 1.164l.1 6.072-2.238.152c-.894-4.554-1.79-5.617-4.673-5.617-3.729 0-5.668 3.39-5.668 9.918 0 7.692 2.336 11.993 6.563 11.993 2.187 0 4.027-.962 5.966-3.087l.746 1.822M161.325 14.17c-3.63 0-5.469 3.19-5.469 9.514 0 .76.05 1.518.1 2.277.547 7.236 2.834 11.133 6.662 11.133 3.58 0 5.718-3.795 5.718-10.171 0-7.49-2.934-12.752-7.01-12.752zm.597 24.644c-7.11 0-11.883-4.857-12.131-12.296v-.759c0-8.552 4.524-13.511 12.28-13.511 7.21 0 12.28 5.465 12.28 13.309 0 7.944-4.921 13.257-12.43 13.257zM206.011 38.087c-2.883-.101-5.071-.202-6.513-.202-1.392 0-3.48.1-6.215.202l.1-1.215c2.635-.404 2.883-.91 2.933-5.414l.05-3.188v-4.504c0-6.375-1.144-8.5-4.375-8.5-1.94 0-3.58 1.062-4.575 2.934-.397.76-.745 1.974-.745 2.48v10.778c0 4.504.298 5.01 2.933 5.414l.15 1.215c-2.785-.101-4.873-.202-6.265-.202-1.442 0-3.58.1-6.464.202l.1-1.215c3.331 0 3.828-.657 3.828-5.414v-11.74c0-4.706-.497-5.363-3.828-5.414l-.1-1.164c4.425-.253 5.42-.405 9.198-1.214l.25 4.554c2.833-3.239 5.02-4.403 8.054-4.403 4.822 0 7.557 3.188 7.557 8.906v10.475c-.05.405-.05.81-.05 1.215 0 3.238.845 4.2 3.878 4.2l.1 1.214M220.545 14.17c-3.63 0-5.469 3.19-5.469 9.514 0 .76.05 1.518.1 2.277.546 7.236 2.833 11.133 6.662 11.133 3.58 0 5.717-3.795 5.717-10.171 0-7.49-2.933-12.752-7.01-12.752zm.597 24.644c-7.11 0-11.883-4.857-12.132-12.296v-.759c0-8.552 4.525-13.511 12.281-13.511 7.209 0 12.28 5.465 12.28 13.309 0 7.944-4.922 13.257-12.43 13.257z"
    })));
  };

  F.defaultProps = {
    height: 39,
    inverse: !1,
    width: 336
  }, F.propTypes = {
    height: l.number,
    inverse: l.bool,
    width: l.number
  };

  var _ = function _(e) {
    var t = e.height,
        l = e.width,
        a = o(e, ["height", "width"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 304 92"
    }, a), n.createElement("g", {
      fill: "#FFF",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M138.855 1.227l.206 8.319-1.948.101c-.154-5.09-1.233-5.786-9.011-5.786h-1.664v29.14c0 4.026 1.028 5.093 5.014 5.204l.1 1.39c-3.774-.048-6.634-.048-8.451-.048-1.91 0-4.875 0-8.763.049l.1-1.391c3.995-.111 5.026-1.178 5.026-5.204V3.861h-1.946c-7.99 0-9.07.696-9.172 5.786l-1.937-.101.192-8.319c7.293.05 12.75.115 16.41.115 3.427 0 8.764-.065 15.844-.115M142.086 38.308c3.617 0 4.105-.696 4.158-5.738V8.264c-.053-5.051-.54-5.751-4.158-5.751l-.108-1.287c4.916-.263 6.042-.43 10.48-1.226v16.525c2.858-3.063 5.183-4.297 8.372-4.297 5.282 0 8.203 3.222 8.203 9.341V32.57c.053 5.042.54 5.738 4.148 5.738l.093 1.288c-3.106-.101-5.481-.214-7.047-.214-1.521 0-3.735.113-6.7.214l.111-1.288c2.854-.425 3.129-.953 3.181-5.738v-8.055c0-6.76-1.18-9.007-4.746-9.007-1.896 0-3.943 1.224-4.806 3.108-.325.645-.541 1.334-.759 2.032-.05.28-.05.485-.05.594V32.57c0 4.785.325 5.313 3.174 5.738l.116 1.288c-3.022-.101-5.246-.214-6.75-.214-1.566 0-3.944.113-7.02.214l.108-1.288M181.965 22.54c4.96-.11 6.47-.23 11.392-.76-.65-5.203-2.614-7.674-5.947-7.674-3.237 0-4.912 2.57-5.445 8.434m17.114 11.796c-3.35 4.137-6.636 5.86-10.864 5.86-7.494 0-12.566-5.477-12.566-13.485 0-8.63 5.235-14.484 12.786-14.484 4.059 0 6.98 1.496 8.975 4.67 1.347 2.259 1.72 3.81 1.771 7.678H182.12c.226 8.05 3.185 12.662 8.118 12.662 2.906 0 5.386-1.344 8.036-4.397l.806 1.496M.175 89.201c4.38-.11 5.515-1.299 5.515-5.766V55.499c0-4.462-1.135-5.649-5.515-5.773L0 48.286l9.181.115 14.517-.182 3.821.068.239 8.637-2.396.18c-.413-5.407-1.43-6.003-9.947-6.003h-1.322l-.597.052v16.083c1.126 0 2.039.063 2.58.063.945.06 1.847.11 2.755.11 4.683 0 5.762-1.001 5.812-5.424h2.043c-.18 3.54-.18 5.375-.18 7.156 0 1.432 0 3.443.06 6.119h-1.923c-.235-4.267-1.198-5.105-5.692-5.158l-3.241-.067-2.274.12v12.45c0 5.064.297 5.297 5.331 5.297 6.661 0 8.642-1.489 9.231-7.16l2.397.127-1.378 9.882-4.61.065-14.56-.118L0 90.751l.175-1.55M60.633 86.532c-3.41 3.511-6.125 4.88-10.07 4.88-7.894 0-12.954-6.127-12.954-15.363 0-9.639 5.343-15.674 13.97-15.674 2.273 0 4.57.417 8.115 1.371l.1 7.035-2.692.18c-1-5.251-2.052-6.501-5.523-6.501-4.484 0-6.817 3.881-6.817 11.554 0 8.951 2.801 14.007 7.895 14.007 2.634 0 4.746-1.134 7.085-3.63l.89 2.14M74.356 76.398c.595 8.407 3.41 12.984 8.019 12.984 4.307 0 6.889-4.455 6.889-11.85 0-8.799-3.545-14.896-8.445-14.896-4.366 0-6.588 3.653-6.588 11.091 0 .894 0 1.784.125 2.67m-7.328.662v-.904c0-10.045 5.44-15.78 14.69-15.78 8.582 0 14.683 6.333 14.683 15.545 0 9.242-5.927 15.493-14.862 15.493-8.527 0-14.209-5.713-14.511-14.354M103.473 89.327c3.904 0 4.498-.775 4.498-6.362V69.256c0-5.426-.594-6.202-4.498-6.262l-.12-1.364c5.22-.3 6.426-.48 10.964-1.434l.307 5.271c3.41-3.72 6.043-5.092 9.593-5.092 5.815 0 9.1 3.754 9.1 10.377v12.213c-.055.468-.055.95-.055 1.427 0 3.806 1.015 4.935 4.67 4.935l.117 1.424c-3.47-.113-6.106-.236-7.843-.236-1.672 0-4.188.123-7.379.236l.106-1.424c3.085-.48 3.439-1.067 3.439-6.362l.066-3.648v-5.302c0-7.488-1.38-9.886-5.168-9.886-2.34 0-4.315 1.192-5.51 3.35-.48.892-.895 2.31-.895 2.913v12.573c.06 5.295.36 5.882 3.53 6.362l.184 1.424c-3.354-.113-5.867-.236-7.542-.236-1.744 0-4.3.123-7.684.236l.12-1.424M150.515 76.398c.604 8.407 3.408 12.984 7.922 12.984 4.31 0 6.885-4.455 6.885-11.85 0-8.799-3.529-14.896-8.403-14.896-4.303 0-6.518 3.653-6.518 11.091 0 .894 0 1.784.114 2.67m-7.422.662v-.904c0-10.045 5.454-15.78 14.695-15.78 8.678 0 14.774 6.333 14.774 15.545 0 9.242-5.923 15.493-14.955 15.493-8.469 0-14.212-5.713-14.514-14.354M179.259 89.327c4.019 0 4.618-.775 4.618-6.362V69.256c0-5.426-.6-6.202-4.618-6.262l-.121-1.364c5.328-.3 6.538-.48 11.051-1.434l.269 5.271c3.367-3.66 6.007-5.092 9.536-5.092 4.07 0 6.458 1.67 8.157 5.557 3.657-4.073 6.344-5.557 10-5.557 5.649 0 8.812 3.81 8.812 10.377v12.213c0 .468-.061.95-.061 1.427 0 3.806 1.084 4.935 4.67 4.935l.13 1.424c-3.477-.113-6.109-.236-7.795-.236-1.622 0-4.085.123-7.373.236l.12-1.424c3.168-.48 3.47-1.067 3.528-6.362v-8.95c0-7.37-1.302-9.886-5.025-9.886-2.213 0-4.492 1.338-5.449 3.35-.3.707-.594 1.428-.775 2.261-.06.295-.123.533-.123.652v12.573c0 5.295.359 5.882 3.528 6.362l.13 1.424c-3.173-.113-5.505-.236-7.09-.236-1.55 0-3.891.123-7.006.236l.126-1.424c3.172-.48 3.471-1.067 3.522-6.362v-8.95c0-7.37-1.31-9.886-5.028-9.886-2.263 0-4.302 1.245-5.441 3.35-.482.947-.868 2.31-.868 2.913v12.573c.06 5.295.329 5.882 3.503 6.362l.12 1.424c-3.294-.113-5.712-.236-7.38-.236-1.746 0-4.313.123-7.788.236l.12-1.424M240.73 50.27a3.945 3.945 0 013.959-3.948c2.221 0 4.01 1.833 4.01 3.948 0 2.252-1.73 4.044-4.01 4.044-2.271 0-3.959-1.729-3.959-4.044m7.669 9.926v19.12l.056 3.65c0 5.585.548 6.359 4.61 6.359l.127 1.426c-3.718-.113-6.41-.234-8.262-.234-1.792 0-4.419.12-8.04.234l.113-1.426c3.951 0 4.516-.774 4.516-6.36l.055-3.648v-6.249l-.055-3.81c0-5.428-.565-6.204-4.516-6.263l-.114-1.366c5.409-.355 6.658-.538 11.51-1.433M260.4 89.686l-.236-6.078 3.047-.11c1.378 4.581 2.28 5.47 5.456 5.47 2.747 0 4.548-1.424 4.548-3.564 0-2.031-1.253-3.507-5.034-6.028-1.911-1.309-3.224-2.21-3.941-2.739-1.563-1.188-2.7-2.622-3.299-4.222-.366-.895-.542-1.961-.542-3.212 0-5.308 3.722-8.828 9.34-8.828 2.093 0 3.292.178 8.04 1.31l.131 5.91-3.043.123c-.678-3.888-1.893-5.258-4.702-5.258-2.695 0-4.615 1.55-4.615 3.647 0 2.08.964 3.33 4.075 5.293 2.808 1.85 4.96 3.51 6.422 4.82 1.678 1.603 2.64 3.625 2.64 5.876 0 5.26-4.443 9.316-10.14 9.316-2.21 0-4.307-.49-8.148-1.726M285.026 62.106c4.721-.36 6.508-2.377 7.862-8.573h2.692v8.036h7.547l-.843 3.271h-6.704v14.536c0 7.22.962 8.938 5.03 8.938.954 0 1.849-.117 3.293-.528v1.72c-2.032 1.133-4.845 1.784-7.714 1.784-2.65 0-5.103-1.482-6.132-3.688-.9-1.846-1.193-3.688-1.193-7.634V64.84h-3.838v-2.734"
    })));
  };

  _.defaultProps = {
    height: 92,
    width: 304
  }, _.propTypes = {
    height: l.number,
    width: l.number
  };

  var U = function U(e) {
    var t = e.height,
        l = e.width,
        a = e.id,
        r = o(e, ["height", "width", "id"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 784 152",
      role: "img",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }, r), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "1843 Magazine - long reads and life"), n.createElement("path", {
      d: "M317.64 117.413v1.51a411.543 411.543 0 00-15.402-.302c-5.588 0-11.93.15-15.704.302v-1.51l4.68-.755c2.87-.453 4.681-2.719 4.681-8.607V71.206c0-12.985-2.869-20.687-14.496-20.687-6.19 0-10.72 2.718-14.345 7.097v50.435c0 5.888 1.661 8.154 4.681 8.607l4.681.755v1.51a411.602 411.602 0 00-15.402-.302c-5.587 0-11.929.15-15.704.302v-1.51l4.681-.755c2.87-.453 4.681-2.719 4.681-8.607V63.053c0-8.608-.303-10.118-9.21-12.382v-.756c8.153-1.963 14.042-4.228 21.592-7.248v13.591c3.322-7.55 10.117-12.835 19.328-12.835 11.476 0 17.97 5.284 20.536 14.496 3.776-8.306 10.721-14.496 20.688-14.496 15.401 0 21.894 9.512 21.894 25.518v39.11c0 5.888 1.661 8.154 4.682 8.607l4.681.755v1.51a411.662 411.662 0 00-15.403-.302c-5.587 0-11.928.15-15.704.302v-1.51l4.682-.755c2.868-.453 4.68-2.719 4.68-8.607V71.206c0-12.985-2.869-20.687-14.496-20.687-7.7 0-12.23 4.078-15.402 8.456.755 3.02 1.058 6.342 1.058 9.966v39.11c0 5.888 1.66 8.154 4.68 8.607l4.681.755zM400.084 109.712c0-6.342.302-22.65.453-24.915-1.36-.151-3.322-.151-4.983-.151-12.533 0-20.99 6.493-20.99 16.912 0 8.909 5.437 13.439 12.08 13.439 5.89 0 10.419-1.51 13.44-5.285M413.22 67.13c0 11.777-.604 25.519-.604 40.77 0 7.097 2.416 9.362 11.023 9.362v.755c-1.963 1.057-5.89 2.718-12.08 2.718-7.248 0-11.023-3.775-11.326-9.664h-.15c-3.322 6.039-9.211 9.664-19.178 9.664-9.966 0-18.723-6.795-18.723-17.818 0-13.288 11.928-20.386 30.955-20.386 1.812 0 5.587 0 7.55.152v-13.44c0-14.043-5.89-20.083-17.063-20.083-6.645 0-11.477 1.36-16.007 4.077l-.302-.906c4.078-4.982 12.685-8.908 20.99-8.908 17.063 0 24.915 9.36 24.915 23.707",
      fill: "#B6B6B6"
    }), n.createElement("path", {
      d: "M452.177 45.839c-10.569 0-13.892 10.419-13.892 22.046 0 13.288 4.38 22.952 14.345 22.952 10.42 0 13.893-11.627 13.893-22.952 0-11.93-4.229-22.046-14.346-22.046m5.738 72.027l-15.099-1.057c-6.343 3.02-9.967 7.248-9.967 15.855 0 9.363 9.664 16.006 22.197 16.006 13.137 0 23.254-6.795 23.254-18.573 0-7.248-7.248-11.325-20.385-12.231m4.984-72.631h23.102v2.114h-19.328c6.04 2.869 12.232 10.267 12.232 20.234 0 13.59-11.779 25.67-26.425 25.67-2.719 0-6.796-.453-8.456-.906-4.077 1.66-5.89 4.077-5.89 7.399 0 3.624 3.171 6.04 10.117 6.493l16.611 1.207c15.552 1.058 23.707 8.306 23.707 18.876 0 13.742-18.574 25.519-39.412 25.519-14.647 0-27.029-6.19-27.029-17.818 0-9.211 10.721-16.006 19.177-17.516-7.097-.906-11.325-6.191-11.325-12.08 0-6.192 5.135-11.477 12.986-12.382-8.154-2.114-17.214-8.76-17.214-24.01 0-13.59 11.627-24.612 26.728-24.612 4.982 0 8.304.905 10.42 1.812",
      fill: "#B6B6B6"
    }), n.createElement("path", {
      d: "M524.355 109.712c0-6.342.302-22.65.452-24.915-1.358-.151-3.32-.151-4.982-.151-12.533 0-20.99 6.493-20.99 16.912 0 8.909 5.437 13.439 12.081 13.439 5.888 0 10.418-1.51 13.44-5.285m13.136-42.582c0 11.777-.605 25.519-.605 40.77 0 7.097 2.416 9.362 11.024 9.362v.755c-1.963 1.057-5.889 2.718-12.08 2.718-7.248 0-11.024-3.775-11.326-9.664h-.15c-3.322 6.039-9.212 9.664-19.178 9.664-9.966 0-18.723-6.795-18.723-17.818 0-13.288 11.928-20.386 30.955-20.386 1.811 0 5.587 0 7.55.152v-13.44c0-14.043-5.889-20.083-17.064-20.083-6.644 0-11.476 1.36-16.006 4.077l-.302-.906c4.078-4.982 12.685-8.908 20.99-8.908 17.062 0 24.915 9.36 24.915 23.707M565.274 116.809h20.838c10.872 0 15.855-6.04 18.573-13.137l2.568-6.795h1.208c-1.51 6.644-2.87 15.402-3.474 22.348a996.269 996.269 0 00-23.707-.302h-30.35v-2.114l41.072-69.46h-25.067c-7.399 0-10.419 6.493-12.986 12.533l-1.208 2.869h-1.208a165.365 165.365 0 001.963-18.121c6.191.453 16.46.605 24.915.605h27.18v2.114l-40.317 69.46zM622.048 63.053c0-8.607-.303-10.117-9.212-12.382v-.756c8.154-1.963 14.043-4.227 21.595-7.248v65.384c0 5.889 1.66 8.154 4.68 8.607l4.68.755v1.51a422.736 422.736 0 00-15.553-.302c-5.587 0-11.778.15-15.552.302v-1.51l4.68-.755c2.87-.453 4.682-2.718 4.682-8.607V63.053zM670.066 56.258c3.473-7.701 10.872-12.835 20.687-12.835 15.402 0 21.744 9.513 21.744 25.519v39.109c0 5.889 1.661 8.154 4.681 8.607l4.681.755v1.51a413.727 413.727 0 00-15.402-.302c-5.587 0-11.929.15-15.704.302v-1.51l4.681-.755c2.87-.453 4.681-2.718 4.681-8.607V71.206c0-12.985-2.718-20.686-14.345-20.686-6.19 0-12.08 2.717-15.704 7.096v50.435c0 5.889 1.661 8.154 4.681 8.607l4.681.755v1.51a413.774 413.774 0 00-15.402-.302c-5.587 0-11.93.15-15.704.302v-1.51l4.681-.755c2.87-.453 4.681-2.718 4.681-8.607V63.053c0-8.607-.303-10.117-9.212-12.382v-.756c8.155-1.963 14.044-4.227 21.594-7.248v13.59zM754.17 45.839c-11.777 0-17.666 12.382-18.27 25.972h31.559c2.567 0 3.17-.907 3.17-3.021 0-13.891-6.492-22.951-16.458-22.951zm27.18 62.665c-4.227 4.832-12.23 12.23-27.03 12.23-19.327 0-31.71-15.401-31.71-38.957 0-23.858 12.836-38.354 32.165-38.354 19.932 0 28.992 12.835 28.992 26.576 0 1.359-.151 3.02-.302 3.926h-47.716c-.151 1.057-.151 2.265-.151 3.473 0 20.536 7.096 36.089 26.123 36.089 7.852 0 13.892-1.963 19.026-5.587l.604.604z",
      fill: "#B6B6B6"
    }), n.createElement("path", {
      d: "M187.382 26.867c-1.47 0-3.3-.029-5.22-.029-.989 0-2.79.03-3.388.06v-.87l1.138-.21c.781-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.448-2.22-1.23-2.37l-1.138-.21V8.18c.75.03 2.19.06 3.63.06 1.349 0 3.029-.03 3.779-.06v.87l-1.5.21c-.81.12-1.23.51-1.23 2.37v12.268c0 1.111.18 1.62 2.52 1.62h2.19c1.08 0 1.5-.36 1.8-1.17l.6-1.77h1.05c-.24 1.53-.54 3.69-.57 4.41-1.11-.059-2.7-.12-3.66-.12M215.492 17.658c0-5.31-2.16-8.55-6.33-8.55-3.84 0-5.879 3.81-5.879 8.43 0 4.77 2.25 8.46 6.3 8.46 3.87 0 5.91-3.72 5.91-8.34m-14.82.15c0-5.31 3.12-9.99 8.64-9.99 5.64 0 8.76 4.11 8.76 9.54 0 5.28-3.12 9.96-8.64 9.96-5.67 0-8.76-4.17-8.76-9.51M227.763 26.027l1.2-.21c.81-.149 1.23-.689 1.23-2.49V11.628c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.75.03 1.47.03 2.43.03.69 0 1.5 0 2.4-.03l10.469 15.3v-11.73c0-1.8-.42-2.34-1.23-2.49l-1.26-.21v-.87c.75.03 1.8.06 3.24.06 1.35 0 2.31-.03 3.06-.06v.87l-1.02.21c-.78.15-1.23.69-1.23 2.49v15.39h-1.77l-11.16-16.23v12.42c0 1.8.45 2.34 1.23 2.49l1.14.21v.87c-.75-.03-1.74-.09-3.09-.09-1.44 0-2.52.06-3.27.09v-.87zM255.963 17.778c0-5.61 3.81-9.96 9.3-9.96 2.28 0 3.96.42 5.31.9.03 1.38.06 2.7.18 4.29h-1.17c-.181-2.31-1.62-3.9-4.38-3.9-4.05 0-6.63 3.48-6.63 8.46 0 5.01 2.55 8.46 6.6 8.46 1.2 0 2.67-.15 3.57-.69v-3.39c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.75.03 1.95.09 3.63.09 1.35 0 2.34-.06 3.09-.09v.87l-.93.18c-.841.18-1.11.66-1.11 2.37v4.38c-1.08.45-3.72 1.02-6.21 1.02-5.52 0-8.88-3.84-8.88-9.54M307.953 13.188c0-2.4-1.5-3.72-4.021-3.72-.81 0-1.74 0-2.43.06v7.53c.69.06 1.14.09 2.16.09 2.67 0 4.29-1.59 4.29-3.96m.42 12.18c-.99-1.14-2.73-3.6-4.56-6.87-.96 0-1.59 0-2.31-.06v5.01c0 1.86.42 2.25 1.23 2.37l1.56.21v.87c-.75-.03-2.49-.09-3.84-.09-1.41 0-2.82.06-3.63.09v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.75.03 1.95.03 3.15.03 1.32 0 2.73-.09 4.5-.09 3.42 0 6.03 1.56 6.03 4.92 0 2.28-1.8 4.56-4.23 5.13 1.47 2.61 3.24 4.92 4.56 6.36.78.84 1.86 1.59 2.94 1.59v.78c-.33.15-.87.24-1.38.24-1.74 0-3.12-.69-4.02-1.77M332.191 26.867l-6.119-.029c-.99 0-2.79.03-3.39.06v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21V8.18c.6.03 2.4.06 3.39.06.78 0 3.3-.03 5.55-.03 2.04 0 3.99-.09 3.96-.12 0 1.38.06 3.09.12 4.02h-1.02l-.3-1.32c-.15-.69-.54-1.2-1.62-1.2l-5.4-.03v7.02h4.11c1.05 0 1.2-.272 1.29-.78l.3-1.44h.93c-.03.75-.09 1.8-.09 2.76 0 .81.06 2.158.09 2.908h-.93l-.27-1.29c-.09-.51-.27-.869-1.32-.869h-4.11v6.03c0 1.11.181 1.62 2.52 1.62h3.09c1.08 0 1.53-.36 1.8-1.17l.6-1.77h1.05c-.24 1.53-.48 3.15-.57 4.41a82.529 82.529 0 00-3.66-.12M357.03 18.558l-2.818-8.04-2.701 8.04h5.52zm-11.52 7.47l.783-.18c1.019-.21 1.439-1.2 1.859-2.4l5.55-15.27 1.8-.36 5.789 15.6c.63 1.71 1.02 2.25 1.89 2.46l.66.15v.87c-.75-.03-1.92-.09-3.18-.09-1.29 0-3.12.06-3.87.09v-.87l1.32-.18c.51-.061.9-.48.9-1.11 0-.241-.06-.6-.18-.93l-1.35-3.96h-6.42l-1.29 3.84c-.15.48-.27.9-.27 1.29 0 .36.09.84.66.9l1.32.15v.87c-.75-.03-2.28-.09-3.36-.09-1.05 0-1.86.06-2.61.09v-.87zM387.511 17.448c0-4.08-1.86-7.95-7.32-7.95-.84 0-1.53.03-2.369.09v14.13c0 1.17.18 1.89 2.43 1.89 4.618 0 7.26-3.03 7.26-8.16m-11.22 9.39c-1.08 0-2.1.03-3.15.06v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.9.03 1.95.06 3.15.06 1.32 0 2.998-.09 4.62-.09 6.03 0 9.208 3.78 9.208 8.88 0 5.79-3.9 9.9-9.839 9.9-1.59 0-2.82-.09-3.99-.09M400.142 26.537c0-1.619-.09-2.399-.24-4.229h1.17c.21 2.46 1.44 3.69 4.2 3.69 2.43 0 3.93-1.44 3.93-3.66 0-4.68-9.06-2.88-9.06-9.51 0-2.91 2.67-5.01 5.85-5.01 1.83 0 3.75.42 4.92.81-.032 1.471 0 2.61.12 4.05h-1.142c-.148-2.16-1.318-3.57-3.988-3.57-1.95 0-3.54 1.26-3.54 3.21 0 4.89 9.09 3.48 9.09 9.51 0 2.97-2.64 5.49-6.36 5.49-1.74 0-3.66-.45-4.95-.78M444.66 18.558l-2.818-8.04-2.702 8.04h5.52zm-11.52 7.47l.782-.18c1.019-.21 1.439-1.2 1.859-2.4l5.549-15.27 1.8-.36 5.79 15.6c.63 1.71 1.02 2.25 1.89 2.46l.66.15v.87c-.75-.03-1.92-.09-3.18-.09-1.29 0-3.12.06-3.87.09v-.87l1.32-.18c.51-.061.9-.48.9-1.11 0-.241-.06-.6-.18-.93l-1.35-3.96h-6.42l-1.29 3.84c-.148.48-.27.9-.27 1.29 0 .36.09.84.66.9l1.32.15v.87c-.75-.03-2.278-.09-3.358-.09-1.051 0-1.862.06-2.612.09v-.87zM460.71 26.027l1.202-.21c.809-.149 1.229-.689 1.229-2.49V11.628c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.75.03 1.47.03 2.43.03.69 0 1.5 0 2.4-.03l10.469 15.3v-11.73c0-1.8-.42-2.34-1.23-2.49l-1.26-.21v-.87c.75.03 1.8.06 3.24.06 1.35 0 2.31-.03 3.06-.06v.87l-1.02.21c-.78.15-1.23.69-1.23 2.49v15.39h-1.77l-11.16-16.23v12.42c0 1.8.45 2.34 1.232 2.49l1.138.21v.87c-.75-.03-1.738-.09-3.09-.09-1.44 0-2.52.06-3.27.09v-.87zM504.63 17.448c0-4.08-1.858-7.95-7.32-7.95-.84 0-1.53.03-2.368.09v14.13c0 1.17.178 1.89 2.428 1.89 4.62 0 7.26-3.03 7.26-8.16m-11.219 9.39c-1.08 0-2.099.03-3.15.06v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.9.03 1.95.06 3.15.06 1.32 0 3-.09 4.62-.09 6.03 0 9.209 3.78 9.209 8.88 0 5.79-3.899 9.9-9.84 9.9-1.59 0-2.818-.09-3.988-.09M540.18 26.867c-1.472 0-3.3-.029-5.22-.029-.99 0-2.79.03-3.39.06v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21V8.18c.75.03 2.19.06 3.63.06 1.35 0 3.03-.03 3.78-.06v.87l-1.5.21c-.81.12-1.23.51-1.23 2.37v12.268c0 1.111.18 1.62 2.52 1.62h2.188c1.08 0 1.5-.36 1.801-1.17l.6-1.77h1.05c-.24 1.53-.54 3.69-.57 4.41a82.529 82.529 0 00-3.66-.12M553.5 26.027l1.14-.21c.78-.149 1.229-.51 1.229-2.37V11.628c0-1.86-.45-2.22-1.228-2.37l-1.141-.21v-.87a103.914 103.914 0 007.049 0v.87l-1.14.21c-.78.15-1.23.51-1.23 2.37v11.82c0 1.86.45 2.22 1.23 2.37l1.14.21v.87c-.75-.03-2.22-.09-3.42-.09-1.408 0-2.88.06-3.63.09v-.87zM570.449 26.027l1.14-.21c.78-.149 1.23-.51 1.23-2.37V11.628c0-1.86-.45-2.22-1.23-2.37l-1.14-.21v-.87c.602.03 2.4.06 3.39.06 1.92 0 4.47 0 6.24-.03 1.92-.03 2.52-.09 3.27-.12 0 1.38.06 3.15.12 4.08h-1.05l-.27-1.38c-.15-.69-.54-1.2-1.62-1.2l-5.4-.03v7.5h4.17c1.05 0 1.2-.27 1.29-.78l.299-1.44h.932c-.031.75-.09 1.8-.09 2.76 0 .81.059 2.16.09 2.91h-.932l-.27-1.29c-.09-.51-.27-.87-1.32-.87h-4.17v5.1c0 1.86.452 2.28 1.23 2.37l1.802.21v.87c-.75-.03-2.731-.09-4.08-.09-1.41 0-2.881.06-3.631.09v-.87zM602.548 26.867l-6.119-.029c-.99 0-2.788.03-3.39.06v-.87l1.14-.21c.78-.15 1.23-.51 1.23-2.37v-11.82c0-1.86-.45-2.22-1.23-2.37l-1.14-.21V8.18c.601.03 2.4.06 3.39.06.78 0 3.302-.03 5.552-.03 2.038 0 3.987-.09 3.958-.12 0 1.38.06 3.09.12 4.02h-1.02l-.3-1.32c-.15-.69-.54-1.2-1.62-1.2l-5.4-.03v7.02h4.11c1.05 0 1.2-.272 1.29-.78l.3-1.44h.93c-.03.75-.09 1.8-.09 2.76 0 .81.06 2.158.09 2.908h-.93l-.269-1.29c-.091-.51-.271-.869-1.32-.869h-4.112v6.03c0 1.11.183 1.62 2.522 1.62h3.09c1.08 0 1.53-.36 1.798-1.17l.6-1.77h1.05c-.24 1.53-.48 3.15-.57 4.41a82.529 82.529 0 00-3.66-.12",
      fill: "#121212"
    }), n.createElement("path", {
      d: "M5.113 117.959c4.092-.17 12.615-.341 21.308-.341 10.058 0 16.535.171 20.455.341v-.341c-12.955-.511-15.512-1.704-15.512-9.887V39.377C24.546 43.468 17.217 44.831 0 44.32v.341c17.217 1.194 20.454 2.899 20.454 11.421v51.649c0 7.671-2.556 9.376-15.341 9.887v.341z",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M75.684 119.834c21.82 0 35.797-12.955 35.797-31.875 0-22.161-17.728-30.173-33.24-37.332C64.263 44.149 51.65 37.501 51.65 23.354 51.65 10.568 60.854.341 75.684.341c12.785 0 21.65 9.546 21.65 26.421 0 10.228-4.945 20.627-14.66 27.103h.34c16.534-7.841 23.694-16.364 23.694-28.467C106.708 10.739 94.435 0 76.025 0c-20.285 0-33.41 12.273-33.41 27.614 0 18.922 15.171 26.934 29.66 33.241 15.682 6.819 30.171 15 30.171 32.046 0 13.807-8.864 26.592-26.592 26.592-15.34 0-24.546-10.909-24.546-29.148 0-12.615 5.114-23.354 18.24-32.047h-.34C49.773 66.991 40.91 76.879 40.91 90.174c0 16.705 13.295 29.66 34.774 29.66",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M138.585 150.006c4.09-.17 12.614-.341 21.479-.341 7.84 0 12.783.17 16.022.34v-.34c-9.205-.341-10.91-1.705-10.91-9.887V118.3h18.922v-5.114h-18.921V66.139h-.341c-2.898 5.114-6.818 8.18-10.57 9.887v37.16h-43.978l-.512.853c17.728-17.046 28.468-37.843 28.468-55.741 0-13.637-5.454-21.818-12.956-21.818-4.431 0-7.841 3.237-7.841 8.352 0 10.568 15.002 7.67 15.002 25.228 0 11.422-7.161 31.535-28.638 48.24h50.456v21.478c0 7.67-2.726 9.375-15.682 9.887v.34z",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M199.44 150.689c21.648 0 39.717-16.023 39.717-35.968 0-16.023-13.808-23.523-34.264-23.523-.34 0-.51 0 0-.341.682-.513 2.558-1.534 5.967-3.069 12.102-5.284 21.99-13.468 21.99-25.398 0-13.127-10.058-21.65-27.104-21.65-18.24 0-30.682 10.569-30.682 22.843 0 8.01 5.283 13.806 14.318 13.806 8.182 0 12.955-5.965 12.955-9.376 0-.17-.17-.34-.34-.34s-3.58 2.216-9.035 2.216c-6.479 0-11.592-3.75-11.592-12.102 0-9.206 7.33-15.684 18.751-15.684 12.444 0 20.967 7.672 20.967 22.331 0 12.956-7.16 22.502-20.115 27.785-9.034 3.75-13.978 4.945-13.978 8.355 0 1.362 1.364 3.067 3.41 3.067 5.624 0 6.988-12.103 14.318-12.103 16.365 0 21.82 13.126 21.82 25.91 0 17.218-9.717 32.898-26.422 32.898-12.274 0-17.046-5.624-18.58-17.215-.512-3.751-2.217-6.648-5.796-6.648-2.727 0-4.773 1.703-4.773 5.624 0 11.08 12.614 18.582 28.467 18.582",
      fill: "#B30000"
    }));
  };

  U.defaultProps = {
    height: 77,
    width: 400,
    id: "ds-wordmark-1843"
  }, U.propTypes = {
    height: l.number,
    width: l.number,
    id: l.string
  };

  var P = function P(e) {
    var t = e.height,
        l = e.width,
        a = e.id,
        r = o(e, ["height", "width", "id"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 443 90",
      role: "img",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }, r), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "1843 magazine"), n.createElement("path", {
      d: "M179.483 68.847v.879c-2.147-.059-5.482-.176-8.703-.176-3.165 0-6.725.059-8.872.176v-.88l2.656-.468c1.639-.293 2.656-1.582 2.656-5.039V41.777c0-7.617-1.639-12.129-8.194-12.129-3.504 0-6.047 1.582-8.082 4.16V63.34c0 3.457.961 4.805 2.656 5.039l2.656.469v.879c-2.147-.059-5.481-.176-8.702-.176-3.165 0-6.725.059-8.873.176v-.88l2.656-.468c1.639-.293 2.656-1.582 2.656-5.039V36.972c0-5.039-.169-5.918-5.199-7.265v-.47c4.182-1.054 8.251-2.518 12.207-4.276v7.968c1.865-4.394 5.708-7.5 10.907-7.5 6.499 0 10.172 3.106 11.585 8.496 2.147-4.863 6.047-8.496 11.698-8.496 8.703 0 12.376 5.567 12.376 14.942v22.91c0 3.456.961 4.804 2.656 5.038l2.656.47v.878c-2.147-.058-5.482-.176-8.703-.176-3.221 0-6.725.059-8.872.176v-.879l2.656-.469c1.639-.293 2.656-1.582 2.656-5.038V41.776c0-7.617-1.639-12.129-8.194-12.129-4.352 0-6.895 2.402-8.703 4.98.452 1.934.621 3.868.565 5.86v22.91c0 3.457.961 4.804 2.656 5.039l2.543.41ZM233.509 39.375c0 6.913-.339 14.94-.339 23.906 0 4.16 1.356 5.507 6.216 5.507v.469c-2.091 1.113-4.464 1.64-6.838 1.582-4.069 0-6.216-2.227-6.386-5.683h-.056c-1.865 3.515-5.199 5.683-10.851 5.683-5.651 0-10.567-3.984-10.567-10.43 0-7.792 6.725-11.953 17.518-11.953 1.018 0 3.165 0 4.239.118v-7.969c0-8.203-3.334-11.777-9.664-11.777-3.73 0-6.499.82-9.042 2.402l-.169-.527c2.317-2.93 7.177-5.215 11.867-5.215 9.664 0 14.072 5.45 14.072 13.887Zm-7.403 24.96c0-3.691.169-13.3.282-14.59-.791-.117-1.865-.117-2.825-.117-7.064 0-11.868 3.809-11.868 9.903 0 5.214 3.052 7.851 6.838 7.851 3.278 0 5.877-.879 7.573-3.047Z",
      fill: "#B3B3B3"
    }), n.createElement("path", {
      d: "M261.595 26.543h13.055v1.23h-10.907c4.295 2.285 6.951 6.856 6.894 11.836 0 7.969-6.668 15.058-14.919 15.058-1.582 0-3.221-.175-4.803-.527-2.317.996-3.335 2.402-3.335 4.336 0 2.11 1.809 3.516 5.708 3.808l9.381.703c8.759.587 13.393 4.864 13.393 11.075 0 8.027-10.511 14.94-22.265 14.94-8.251 0-15.259-3.632-15.259-10.429 0-5.39 6.047-9.375 10.851-10.253-4.013-.528-6.386-3.633-6.386-7.09 0-3.633 2.882-6.738 7.346-7.266-4.577-1.23-9.72-5.156-9.72-14.062 0-7.969 6.556-14.414 15.089-14.414a14.348 14.348 0 0 1 5.877 1.055ZM258.77 69.08l-8.534-.644c-3.56 1.758-5.651 4.218-5.651 9.316 0 5.508 5.482 9.375 12.546 9.375 7.403 0 13.167-3.984 13.167-10.898 0-4.22-4.069-6.621-11.528-7.149Zm-3.221-42.187c-5.991 0-7.856 6.094-7.856 12.89 0 7.794 2.487 13.477 8.138 13.477 5.877 0 7.855-6.797 7.855-13.476-.056-6.973-2.43-12.89-8.137-12.89Z",
      fill: "#B3B3B3"
    }), n.createElement("path", {
      d: "M303.754 39.375c0 6.913-.339 14.94-.339 23.906 0 4.16 1.356 5.507 6.216 5.507v.469c-2.091 1.113-4.465 1.64-6.838 1.582-4.069 0-6.216-2.227-6.386-5.683h-.056c-1.865 3.515-5.2 5.683-10.851 5.683-5.651 0-10.568-3.984-10.568-10.43 0-7.792 6.725-11.953 17.463-11.953 1.017 0 3.164 0 4.238.118v-7.969c0-8.203-3.334-11.777-9.663-11.777-3.73 0-6.499.82-9.042 2.402l-.17-.527c2.317-2.93 7.177-5.215 11.868-5.215 9.663 0 14.128 5.45 14.128 13.887Zm-7.403 24.96c0-3.691.169-13.3.282-14.59-.791-.117-1.865-.117-2.826-.117-7.064 0-11.867 3.809-11.867 9.903 0 5.214 3.052 7.851 6.838 7.851 3.278 0 5.877-.879 7.573-3.047ZM319.464 68.495h11.755c6.159 0 8.929-3.515 10.511-7.675l1.469-3.985h.678c-.904 4.336-1.582 8.672-1.978 13.066-3.164-.058-8.589-.175-13.393-.175h-17.18v-1.23l23.227-40.723h-14.185c-4.182 0-5.877 3.809-7.346 7.324l-.678 1.7h-.679c.565-3.516.961-7.032 1.131-10.606 3.503.293 9.324.352 14.071.352h15.372v1.23l-22.775 40.722ZM351.563 36.972c0-5.039-.17-5.918-5.199-7.265v-.469c4.182-1.055 8.251-2.52 12.207-4.277v38.32c0 3.456.96 4.804 2.656 5.039l2.656.468v.88c-2.148-.06-5.539-.177-8.816-.177-3.165 0-6.669.059-8.76.176v-.879l2.656-.468c1.639-.293 2.657-1.582 2.657-5.04l-.057-26.308ZM378.689 32.988c1.978-4.512 6.16-7.5 11.698-7.5 8.703 0 12.263 5.566 12.263 14.941v22.91c0 3.457.961 4.805 2.656 5.039l2.656.469v.879c-2.147-.059-5.481-.176-8.702-.176-3.222 0-6.725.059-8.873.176v-.88l2.656-.468c1.639-.293 2.656-1.582 2.656-5.039V41.777c0-7.617-1.526-12.129-8.081-12.129a11.612 11.612 0 0 0-8.872 4.16V63.34c0 3.457.96 4.805 2.656 5.039l2.656.469v.879c-2.148-.059-5.482-.176-8.703-.176-3.221 0-6.725.059-8.873.176v-.88l2.657-.468c1.638-.293 2.656-1.582 2.656-5.039V36.972c0-5.039-.17-5.918-5.2-7.265v-.47c4.182-1.054 8.251-2.518 12.207-4.276v8.027h-.113ZM441.587 63.573c-2.373 2.813-6.894 7.149-15.258 7.149-10.907 0-17.915-9.024-17.915-22.851 0-14.004 7.234-22.5 18.197-22.5 11.246 0 16.389 7.5 16.389 15.585 0 .762-.057 1.524-.17 2.286h-27.012c-.057.703-.113 1.347-.113 2.05 0 12.012 4.012 21.152 14.749 21.152 4.408 0 7.855-1.171 10.738-3.28l.395.41Zm-15.371-36.679c-6.669 0-10.003 7.266-10.342 15.234h17.858c1.469 0 1.808-.527 1.808-1.757-.056-8.203-3.673-13.477-9.324-13.477Z",
      fill: "#B3B3B3"
    }), n.createElement("path", {
      d: "M2.882 69.14c2.317-.117 7.12-.176 12.037-.176 5.651 0 9.325.117 11.585.176v-.176c-7.346-.293-8.76-.996-8.76-5.8V23.085C13.903 25.488 9.778 26.308 0 25.956v.235c9.72.703 11.585 1.7 11.585 6.68v30.292c0 4.512-1.47 5.508-8.646 5.801v.176h-.057Z",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M42.78 70.253c12.32 0 20.231-7.617 20.231-18.691 0-13.008-10.003-17.695-18.762-21.855-7.912-3.809-15.032-7.676-15.032-15.996 0-7.5 5.199-13.477 13.563-13.477 7.233 0 12.263 5.567 12.263 15.469 0 6.387-3.108 12.363-8.25 15.879h.169c9.324-4.57 13.393-9.61 13.393-16.7C60.355 6.27 53.404 0 43.005 0 31.535 0 24.132 7.207 24.132 16.172c0 11.074 8.59 15.761 16.784 19.453 8.872 3.984 17.066 8.788 17.066 18.75 0 8.085-5.03 15.585-15.032 15.585-8.646 0-13.902-6.386-13.902-17.11 0-7.382 2.882-13.651 10.286-18.749h-.17C28.2 39.2 23.17 45 23.17 52.792c-.057 9.903 7.46 17.461 19.61 17.461Z",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M78.326 87.948c2.317-.117 7.12-.234 12.15-.234 4.408 0 7.234.117 9.042.234v-.234c-5.2-.176-6.16-.996-6.16-5.8V69.315h10.681v-2.989h-10.68V38.79h-.17c-1.357 2.52-3.448 4.57-5.99 5.8v21.797H62.332l-.283.469c10.003-9.961 16.106-22.149 16.106-32.637 0-7.968-3.108-12.773-7.346-12.773-2.487 0-4.408 1.875-4.408 4.863 0 6.211 8.477 4.512 8.477 14.766 0 6.68-4.07 18.457-16.163 28.242h28.539v12.597c0 4.512-1.526 5.508-8.873 5.8l-.056.235Z",
      fill: "#B30000"
    }), n.createElement("path", {
      d: "M112.742 88.3c12.207 0 22.435-9.375 22.435-21.094 0-9.375-7.798-13.77-19.383-13.77-.17 0-.283 0 0-.175 1.073-.703 2.204-1.289 3.39-1.816 6.838-3.106 12.433-7.91 12.433-14.883 0-7.676-5.708-12.715-15.315-12.715-10.285 0-17.349 6.211-17.349 13.36 0 4.687 2.995 8.085 8.081 8.085 4.634 0 7.29-3.515 7.29-5.507 0-.117-.113-.176-.169-.176-1.583.879-3.334 1.289-5.086 1.289-3.674 0-6.556-2.227-6.556-7.09 0-5.39 4.126-9.199 10.625-9.199 7.007 0 11.867 4.512 11.867 13.066 0 7.617-4.069 13.184-11.359 16.29-5.086 2.226-7.912 2.87-7.912 4.862.057.997.848 1.817 1.865 1.817 3.165 0 3.956-7.09 8.082-7.09 9.268 0 12.319 7.676 12.319 15.176 0 10.078-5.481 19.277-14.919 19.277-6.951 0-9.664-3.281-10.511-10.078-.283-2.227-1.243-3.867-3.278-3.867-1.526 0-2.713.996-2.713 3.28.057 6.622 7.178 11.016 16.163 10.958Z",
      fill: "#B30000"
    }));
  };

  P.defaultProps = {
    height: 90,
    width: 443,
    id: "ds-wordmark-1843-plain"
  }, P.propTypes = {
    height: l.number,
    width: l.number,
    id: l.string
  };

  var V = function V(e) {
    var t = e.height,
        l = e.width,
        a = e.id,
        r = o(e, ["height", "width", "id"]);
    return n.createElement("svg", i({
      width: l,
      height: t,
      viewBox: "0 0 592 103",
      role: "img",
      id: a,
      "aria-labelledby": "".concat(a, "-title")
    }, r), n.createElement("title", {
      id: "".concat(a, "-title")
    }, "The World Ahead"), n.createElement("path", {
      d: "M140.474 73.211V37.158h-12.366v-7.382h33.038v7.382h-12.551V73.21zM165.934 73.211V27.253h7.32V45.71c1.97-2.46 5.477-4.245 9.352-4.245 4.184 0 7.26 1.6 8.675 5.045 1.047 2.522 1.353 5.23 1.353 9.783V73.21h-7.381V56.538c0-2.584 0-4.676-.555-6.029-.738-1.908-2.337-2.645-4.676-2.645-2.83 0-5.168 1.476-6.767 3.752v21.595h-7.321zM219.164 54.447c0-3.938-1.292-7.199-6.09-7.199-4.246 0-7.075 3.138-7.199 7.2h13.289zm-4.798 19.502c-10.028 0-16.12-6.09-16.12-16.304 0-9.843 6.092-16.18 14.827-16.18 9.229 0 13.228 6.276 13.228 15.319v2.585h-20.487c.246 5.783 4.245 8.242 10.028 8.242 3.138 0 7.198-1.23 10.151-3.506v6.891c-3.383 1.846-6.952 2.953-11.627 2.953zM254.54 73.211L241.93 29.776h8.428c6.214 22.026 7.383 26.27 8.798 31.807 1.415-5.413 2.522-9.29 9.72-31.807h6.585c7.26 22.456 8.674 26.948 9.965 31.93 1.046-4.738 2.338-10.027 8.49-31.93h8.183L289.3 73.21h-7.198c-7.937-24.24-8.982-27.81-10.15-32.178-1.232 4.492-2.278 7.754-10.153 32.178h-7.26zM317.346 47.802c-4.614 0-7.875 3.446-7.875 10.029 0 6.336 3.014 9.78 7.75 9.78 4.86 0 7.814-3.26 7.814-9.903 0-6.46-2.83-9.906-7.69-9.906m-.123 26.147c-9.352 0-15.135-6.46-15.135-16.058 0-9.536 6.09-16.427 15.32-16.427 9.228 0 14.889 6.522 14.889 16.058 0 10.09-5.846 16.427-15.074 16.427M338.228 73.211V42.265h7.135v4.306c1.539-3.384 4.369-5.106 8.06-5.106 1.23 0 2.523.185 3.753.738v6.584c-1.353-.863-2.89-1.232-4.43-1.232-3.014 0-5.658 1.601-7.196 4.923V73.21h-7.322zM361.54 73.212h7.321V27.254h-7.322zM396.6 50.078c-1.044-1.661-3.26-2.707-6.029-2.707-4.615 0-8.305 3.446-8.305 10.644 0 7.444 3.69 10.028 7.444 10.028 2.83 0 5.598-1.476 6.89-3.138V50.078zm.184 23.133v-2.953c-2.091 2.399-5.413 3.691-9.227 3.691-7.875 0-12.859-6.151-12.859-15.503 0-9.845 5.291-16.92 14.642-16.92 2.953 0 5.785.801 7.26 2.339V27.253h7.384v45.958h-7.2zM447.482 55.246c-3.937-10.52-4.614-12.612-5.476-15.257-.86 2.645-1.598 4.737-5.475 15.257h10.95zm-25.964 17.965l16.611-43.435h7.631l16.672 43.435h-8.367l-4.368-11.074h-15.319l-4.246 11.074h-8.614zM466.634 73.211V27.253h7.322V45.71c1.968-2.46 5.475-4.245 9.35-4.245 4.184 0 7.26 1.6 8.676 5.045 1.045 2.522 1.354 5.23 1.354 9.783V73.21h-7.384V56.538c0-2.584 0-4.676-.554-6.029-.738-1.908-2.338-2.645-4.675-2.645-2.83 0-5.168 1.476-6.767 3.752v21.595h-7.322zM519.865 54.447c0-3.938-1.292-7.199-6.09-7.199-4.247 0-7.076 3.138-7.2 7.2h13.29zm-4.798 19.502c-10.028 0-16.12-6.09-16.12-16.304 0-9.843 6.092-16.18 14.828-16.18 9.228 0 13.226 6.276 13.226 15.319v2.585h-20.486c.246 5.783 4.245 8.242 10.027 8.242 3.14 0 7.198-1.23 10.153-3.506v6.891c-3.385 1.846-6.953 2.953-11.628 2.953zM549.168 59.183c-4.614.308-7.32.86-9.166 1.969-1.231.74-1.784 1.908-1.784 3.2 0 2.03 1.23 3.998 4.797 3.998 2.523 0 4.432-.922 6.153-2.336v-6.83zm.187 14.029v-3.078c-2.155 2.277-4.678 3.691-8.615 3.691-5.783 0-9.537-4.059-9.537-9.104 0-3.076 1.354-5.661 3.877-7.2 3.323-1.968 7.875-2.766 14.088-3.137v-.983c0-1.416-.183-2.646-.922-3.754-.86-1.291-2.522-1.783-4.554-1.783-3.813 0-7.627 1.292-10.58 3.691V45.28c3.014-2.522 7.504-3.815 11.38-3.815 4.553 0 8.553 1.17 10.583 5.353.924 1.908 1.23 4.738 1.23 8.306v18.089h-6.95zM583.863 50.078c-1.045-1.661-3.26-2.707-6.03-2.707-4.613 0-8.305 3.446-8.305 10.644 0 7.444 3.692 10.028 7.445 10.028 2.83 0 5.598-1.476 6.89-3.138V50.078zm.184 23.133v-2.953c-2.09 2.399-5.413 3.691-9.227 3.691-7.876 0-12.86-6.151-12.86-15.503 0-9.845 5.293-16.92 14.643-16.92 2.952 0 5.784.801 7.26 2.339V27.253h7.384v45.958h-7.2zM65.88 95.24c3.788-4.152 7.037-9.939 9.477-17.165h13.626c-5.6 7.946-13.715 14.003-23.103 17.166zM13.446 78.076H27.07c1.079 3.163 2.26 6.146 3.699 8.86 1.72 3.253 3.698 6.056 5.779 8.409-9.298-3.266-17.414-9.323-23.103-17.269zM36.639 7.226c-2.08 2.263-4.059 5.066-5.78 8.41-1.528 2.803-2.799 5.876-3.878 9.219H13.176A47.205 47.205 0 0136.639 7.226zm52.614 17.629H75.447c-2.26-6.956-5.419-12.833-9.207-17.166l-.45-.45c9.567 3.15 17.774 9.477 23.463 17.616zM53.693 97.31V78.075h16.515C66.24 88.915 60.19 95.961 53.693 97.311zm-4.867-19.236v19.249c-5.06-1.08-9.837-5.516-13.626-12.743-1.079-1.993-1.99-4.243-2.89-6.506h16.516zM27.88 53.67h20.843V73.19H30.68c-1.618-5.966-2.62-12.563-2.8-19.519zm-4.777 0c.18 6.867 1.079 13.463 2.62 19.519H10.466c-3.159-5.876-5.15-12.472-5.509-19.519h18.146zm0-4.873H5.06c.36-6.866 2.26-13.373 5.24-19.159h15.346c-1.554 5.966-2.453 12.473-2.543 19.159zm25.723-19.069v19.159H27.97c.18-6.776 1.079-13.283 2.71-19.159h18.146zm0-24.572v19.699H32.13c.899-2.443 1.9-4.783 3.07-6.956 3.788-7.24 8.565-11.663 13.625-12.743zm21.472 19.699H53.603V5.156c6.678 1.44 12.816 8.667 16.695 19.699zm21.664 48.334h-38.36V53.67h39.619L80.854 66.143l3.429 3.433 18.133-18.156-18.12-18.169-3.43 3.433 12.098 12.113H53.693V29.638h43.959C89.534 12.112 71.748 0 51.175 0 22.923 0 0 22.952 0 51.227c0 9.76 2.71 18.889 7.487 26.655v.18h.09c9.028 14.633 25.183 24.392 43.586 24.392s34.558-9.76 43.586-24.392l.09-.18c.899-1.53 1.72-3.073 2.53-4.603h-5.42v-.09h.013z"
    }));
  };

  V.defaultProps = {
    height: 70,
    width: 400,
    id: "ds-wordmark-world-ahead"
  }, V.propTypes = {
    height: l.number,
    width: l.number,
    id: l.string
  };

  var R = function R(e, t, l) {
    return t in e ? Object.defineProperty(e, t, {
      value: l,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = l, e;
  },
      B = r(function (e) {
    /*!
    	  Copyright (c) 2017 Jed Watson.
    	  Licensed under the MIT License (MIT), see
    	  http://jedwatson.github.io/classnames
    	*/
    !function () {
      var t = {}.hasOwnProperty;

      function l() {
        for (var e = [], n = 0; n < arguments.length; n++) {
          var a = arguments[n];

          if (a) {
            var r = typeof a;
            if ("string" === r || "number" === r) e.push(a);else if (Array.isArray(a) && a.length) {
              var i = l.apply(null, a);
              i && e.push(i);
            } else if ("object" === r) for (var c in a) {
              t.call(a, c) && a[c] && e.push(c);
            }
          }
        }

        return e.join(" ");
      }

      e.exports ? (l.default = l, e.exports = l) : window.classNames = l;
    }();
  }),
      H = {
    "ds-actioned-link": "ds-actioned-link",
    "ds-actioned-link--disabled": "ds-actioned-link--disabled",
    "ds-actioned-link--complete": "ds-actioned-link--complete",
    "ds-actioned-link--toggled": "ds-actioned-link--toggled",
    "ds-actioned-link--minor": "ds-actioned-link--minor",
    "ds-actioned-link--add": "ds-actioned-link--add",
    "ds-actioned-link--download": "ds-actioned-link--download",
    "ds-actioned-link--edit": "ds-actioned-link--edit",
    "ds-actioned-link--listen": "ds-actioned-link--listen",
    "ds-actioned-link--remove": "ds-actioned-link--remove",
    "ds-actioned-link--reuse-this-content": "ds-actioned-link--reuse-this-content",
    "ds-actioned-link--the-trust-project": "ds-actioned-link--the-trust-project",
    "ds-actioned-link--watch": "ds-actioned-link--watch",
    "ds-actioned-link--copy": "ds-actioned-link--copy",
    "ds-actioned-link--check": "ds-actioned-link--check",
    "ds-actioned-link--apple-podcasts": "ds-actioned-link--apple-podcasts",
    "ds-actioned-link--google-podcasts": "ds-actioned-link--google-podcasts",
    "ds-actioned-link--user": "ds-actioned-link--user",
    "ds-actioned-link--gift": "ds-actioned-link--gift",
    "ds-actioned-link--share": "ds-actioned-link--share",
    "ds-actioned-link--bin": "ds-actioned-link--bin",
    "ds-actioned-link--saved": "ds-actioned-link--saved",
    "ds-actioned-link--save": "ds-actioned-link--save",
    "ds-actioned-link--apple-podcasts-coloured": "ds-actioned-link--apple-podcasts-coloured",
    "ds-actioned-link--google-podcasts-coloured": "ds-actioned-link--google-podcasts-coloured",
    "ds-actioned-link--spotify": "ds-actioned-link--spotify",
    "ds-actioned-link--rss": "ds-actioned-link--rss",
    "ds-actioned-link--indicator": "ds-actioned-link--indicator",
    rotate: "rotate"
  },
      Y = function Y(e) {
    var t,
        l = e.as,
        a = e.text,
        r = e.minor,
        c = e.className,
        s = e.icon,
        d = e.disabled,
        m = e.complete,
        u = e.toggled,
        h = o(e, ["as", "text", "minor", "className", "icon", "disabled", "complete", "toggled"]),
        g = l;
    return n.createElement(g, i({
      className: B([H["ds-actioned-link"], c, (t = {}, R(t, H["ds-actioned-link--minor"], r), R(t, H["ds-actioned-link--".concat(s)], s), R(t, H["ds-actioned-link--disabled"], d), R(t, H["ds-actioned-link--complete"], m), R(t, H["ds-actioned-link--toggled"], u), t)]),
      disabled: d
    }, h), n.createElement("span", null, a));
  };

  Y.defaultProps = {
    as: "a",
    text: "",
    minor: !1,
    disabled: !1,
    complete: !1,
    toggled: !1,
    className: ""
  }, Y.propTypes = {
    as: l.oneOf(["a", "button"]),
    text: l.string,
    minor: l.bool,
    disabled: l.bool,
    className: l.string,
    complete: l.bool,
    toggled: l.bool,
    icon: l.oneOf(["add", "download", "edit", "listen", "remove", "reuse-this-content", "the-trust-project", "watch", "check", "copy", "apple-podcasts", "google-podcasts", "indicator", "user", "gift", "share", "bin", "save", "saved", "apple-podcasts-coloured", "google-podcasts-coloured", "spotify", "rss"]).isRequired
  };

  var Q = {
    "ds-badge": "ds-badge",
    "ds-badge--brand": "ds-badge--brand",
    "ds-badge--sub-brand": "ds-badge--sub-brand",
    "ds-badge--report": "ds-badge--report"
  },
      Z = function Z(e) {
    var t = e.text,
        l = e.variant,
        a = o(e, ["text", "variant"]);
    return n.createElement("span", i({
      className: B(Q["ds-badge"], R({}, Q["ds-badge--".concat(l)], l))
    }, a), t);
  };

  Z.defaultProps = {
    text: "",
    variant: null
  }, Z.propTypes = {
    text: l.string,
    variant: l.oneOf(["brand", "sub-brand", "report"])
  };
  var q = "ds-control-close",
      G = "path-background",
      W = "path-background--disabled",
      X = "ds-control-close--inverse",
      K = "ds-control-close--full-screen",
      J = t.forwardRef(function (e, t) {
    var l,
        a = e.ariaLabel,
        r = e.disabled,
        c = e.fullScreen,
        s = e.handleClick,
        d = e.inverse,
        m = e.className,
        u = o(e, ["ariaLabel", "disabled", "fullScreen", "handleClick", "inverse", "className"]);
    return n.createElement("button", i({
      className: B(q, (l = {}, R(l, K, c), R(l, X, d), l), m),
      onClick: s,
      "aria-label": a,
      disabled: r,
      type: "button",
      ref: t
    }, u), n.createElement("svg", {
      width: "100%",
      viewBox: "5 5 14 14",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("path", {
      className: B(G, R({}, W, r)),
      d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    })));
  });
  J.displayName = "ControlClose", J.defaultProps = {
    ariaLabel: "Close",
    disabled: !1,
    fullScreen: !1,
    handleClick: null,
    inverse: !1,
    className: ""
  }, J.propTypes = {
    ariaLabel: l.string,
    disabled: l.bool,
    fullScreen: l.bool,
    handleClick: l.func,
    inverse: l.bool,
    className: l.string
  };

  var $ = {
    "ds-banner-alert": "ds-banner-alert",
    "ds-control-close": "ds-control-close",
    "ds-banner-alert-inner": "ds-banner-alert-inner",
    "ds-banner-alert--error": "ds-banner-alert--error",
    "ds-banner-alert--success": "ds-banner-alert--success",
    "ds-banner-alert--warning": "ds-banner-alert--warning",
    "ds-banner-alert-button": "ds-banner-alert-button"
  },
      ee = function ee(e) {
    var t = e.button,
        l = e.closable,
        a = e.description,
        r = e.handleClose,
        c = e.isClosed,
        s = e.text,
        d = e.variant,
        m = o(e, ["button", "closable", "description", "handleClose", "isClosed", "text", "variant"]);
    return c ? null : n.createElement("div", i({
      className: B($["ds-banner-alert"], R({}, $["ds-banner-alert--".concat(d)], d))
    }, m), n.createElement("div", {
      className: $["ds-banner-alert-inner"]
    }, n.createElement("p", {
      className: $["ds-banner-alert__text"]
    }, n.createElement("strong", null, s), " ", a), t && n.createElement("div", {
      className: $["ds-banner-alert-button"]
    }, t)), l && n.createElement(J, {
      onClick: r
    }));
  };

  ee.defaultProps = {
    button: null,
    closable: !0,
    description: "",
    handleClose: null,
    isClosed: !1,
    text: "",
    variant: null
  }, ee.propTypes = {
    button: l.node,
    closable: l.bool,
    description: l.string,
    handleClose: l.func,
    isClosed: l.bool,
    text: l.string,
    variant: l.oneOf(["error", "success", "warning"])
  };

  var te = function te(e) {
    var t = e.text;
    return n.createElement("blockquote", null, t);
  };

  te.defaultProps = {
    text: ""
  }, te.propTypes = {
    text: l.string
  };

  var le = "ds-breadcrumb",
      ne = "ds-breadcrumb__item",
      ae = "ds-breadcrumb__link",
      re = "ds-breadcrumb__link--current",
      ie = function ie(e) {
    var t = e.items;
    return n.createElement("nav", {
      className: le,
      "aria-label": "breadcrumb"
    }, n.createElement("ol", null, t.map(function (e, l) {
      var a = e.href,
          r = e.name,
          i = e.id;
      return n.createElement("li", {
        className: ne,
        key: i
      }, l + 1 === t.length ? function (e, t) {
        return n.createElement("a", {
          href: e,
          className: "".concat(ae, " ").concat(re),
          "aria-current": "page"
        }, n.createElement("span", null, t));
      }(a, r) : function (e, t) {
        return n.createElement("a", {
          href: e,
          className: ae
        }, n.createElement("span", null, t));
      }(a, r));
    })));
  };

  ie.defaultProps = {
    items: {
      href: ""
    }
  }, ie.propTypes = {
    items: l.arrayOf(l.shape({
      href: l.string.isRequired,
      name: l.string.isRequired,
      id: l.string
    }))
  };

  var ce = "ds-button",
      oe = "ds-button--inverse",
      se = "ds-button--secondary",
      de = "ds-button--icon",
      me = function me(e) {
    var t,
        l = e.children,
        a = e.type,
        r = e.className,
        c = e.secondary,
        s = e.icon,
        d = e.inverse,
        m = e.disabled,
        u = o(e, ["children", "type", "className", "secondary", "icon", "inverse", "disabled"]);
    return n.createElement("button", i({
      className: B(ce, (t = {}, R(t, se, c), R(t, oe, d), R(t, de, s), t), r),
      type: a,
      disabled: m
    }, u), l);
  };

  me.defaultProps = {
    type: "button",
    className: "",
    secondary: !1,
    icon: !1,
    inverse: !1,
    disabled: !1
  }, me.propTypes = {
    children: l.node.isRequired,
    type: l.oneOf(["button", "reset", "submit"]),
    className: l.string,
    secondary: l.bool,
    icon: l.bool,
    inverse: l.bool,
    disabled: l.bool
  };

  var ue = "ds-call-to-action",
      he = "ds-call-to-action--inverse",
      ge = "ds-call-to-action--secondary",
      ve = function ve(e) {
    var t,
        l = e.href,
        a = e.text,
        r = e.inverse,
        c = e.secondary,
        s = o(e, ["href", "text", "inverse", "secondary"]);
    return n.createElement("a", i({
      className: B(ue, (t = {}, R(t, ge, c), R(t, he, r), t)),
      href: l
    }, s), a);
  };

  ve.defaultProps = {
    inverse: !1,
    secondary: !1,
    href: ""
  }, ve.propTypes = {
    href: l.string,
    text: l.string.isRequired,
    inverse: l.bool,
    secondary: l.bool
  };

  var pe = "ds-call-to-action-with-arrow",
      fe = "ds-call-to-action-with-arrow--inverse",
      be = "ds-call-to-action-with-arrow--secondary",
      Ee = function Ee(e) {
    var t,
        l = e.href,
        a = e.text,
        r = e.inverse,
        c = e.secondary,
        s = o(e, ["href", "text", "inverse", "secondary"]);
    return n.createElement("a", i({
      className: B(pe, (t = {}, R(t, be, c), R(t, fe, r), t)),
      href: l
    }, s), n.createElement("span", null, a));
  };

  Ee.defaultProps = {
    href: "",
    inverse: !1,
    secondary: !1
  }, Ee.propTypes = {
    href: l.string,
    inverse: l.bool,
    secondary: l.bool,
    text: l.string.isRequired
  };

  var we = {
    "ds-section-headline": "ds-section-headline",
    "ds-section-headline--inverse": "ds-section-headline--inverse",
    "ds-section-headline--heavy": "ds-section-headline--heavy",
    "ds-section-headline--rule-emphasised": "ds-section-headline--rule-emphasised",
    "ds-section-headline--rule-accent": "ds-section-headline--rule-accent",
    "ds-section-headline--rule-heavy": "ds-section-headline--rule-heavy",
    "ds-section-subheadline": "ds-section-subheadline",
    "ds-section-subheadline--inverse": "ds-section-subheadline--inverse",
    "ds-section-subheadline--heavy": "ds-section-subheadline--heavy",
    "ds-section-headline-link": "ds-section-headline-link",
    "ds-section-headline-link--inverse": "ds-section-headline-link--inverse"
  },
      Me = function Me(e) {
    var t,
        l,
        a = e.type,
        r = e.headline,
        i = e.subheadline,
        c = e.heavy,
        o = e.inverse,
        s = e.rule,
        d = e.href,
        m = a;
    return n.createElement(m, {
      className: B(we["ds-section-headline"], (t = {}, R(t, we["ds-section-headline--heavy"], c), R(t, we["ds-section-headline--inverse"], o), R(t, we["ds-section-headline--rule-".concat(s)], s), t))
    }, d ? n.createElement("a", {
      href: d,
      className: B(we["ds-section-headline-link"], R({}, we["ds-section-headline-link--inverse"], o))
    }, r) : r, i && n.createElement(n.Fragment, null, " ", n.createElement("span", {
      className: B(we["ds-section-subheadline"], (l = {}, R(l, we["ds-section-subheadline--heavy"], c), R(l, we["ds-section-subheadline--inverse"], o), l))
    }, i)));
  };

  Me.defaultProps = {
    headline: "",
    subheadline: "",
    heavy: !1,
    inverse: !1,
    type: "h1",
    rule: null,
    href: null
  }, Me.propTypes = {
    type: l.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "strong"]),
    headline: l.string,
    subheadline: l.string,
    heavy: l.bool,
    inverse: l.bool,
    rule: l.oneOf(["accent", "emphasised", "heavy"]),
    href: l.string
  };
  var ye = "ds-link-with-arrow",
      ke = "ds-link-with-arrow--minor",
      Ne = "ds-link-with-arrow--serif",
      xe = "ds-link-with-arrow--selected",
      Le = "ds-link-with-arrow--left",
      Te = n.forwardRef(function (e, t) {
    var l,
        a = e.minor,
        r = e.serif,
        c = e.text,
        s = e.selected,
        d = e.className,
        m = e.direction,
        u = o(e, ["minor", "serif", "text", "selected", "className", "direction"]);
    return n.createElement("a", i({
      ref: t,
      className: B(ye, (l = {}, R(l, ke, a), R(l, Ne, r), R(l, xe, s), R(l, Le, "left" === m), l), d)
    }, u), n.createElement("span", null, c));
  });
  Te.displayName = "LinkWithArrow", Te.defaultProps = {
    minor: !1,
    serif: !1,
    text: "",
    className: null,
    selected: !1,
    direction: "right"
  }, Te.propTypes = {
    minor: l.bool,
    serif: l.bool,
    text: l.string,
    className: l.string,
    selected: l.bool,
    direction: l.oneOf(["left", "right"])
  };

  var ze = {
    "ds-rule": "ds-rule",
    "ds-rule--inverse": "ds-rule--inverse",
    "ds-rule--emphasised": "ds-rule--emphasised",
    "ds-rule--heavy": "ds-rule--heavy",
    "ds-rule--accent": "ds-rule--accent"
  },
      je = function je(e) {
    var t,
        l = e.className,
        a = e.rule,
        r = e.inverse,
        c = o(e, ["className", "rule", "inverse"]);
    return n.createElement("hr", i({
      className: B(l, ze["ds-rule"], (t = {}, R(t, ze["ds-rule--inverse"], r), R(t, ze["ds-rule--".concat(a)], a), t))
    }, c));
  };

  je.propTypes = {
    className: l.string,
    rule: l.oneOf(["emphasised", "heavy", "accent"]),
    inverse: l.bool
  }, je.defaultProps = {
    className: null,
    rule: null,
    inverse: !1
  };

  var De = "ds-chapter-list",
      Ie = "ds-chapter-list__item",
      Se = function Se(e) {
    var t = e.indexUrl,
        l = e.sectionHeadline,
        a = e.sectionSubheadline,
        r = e.chapterList,
        i = e.selected,
        c = e.headlineType,
        o = e.ruleType;
    return n.createElement("div", {
      className: De
    }, n.createElement(Me, {
      headline: l,
      subheadline: a,
      rule: o,
      type: c,
      href: t
    }), r && n.createElement("ul", null, r.slice(0, 8).map(function (e, t) {
      var l = e.text,
          a = e.href,
          r = e.id;
      return n.createElement("li", {
        className: Ie,
        key: r
      }, n.createElement(Te, {
        text: l,
        href: a,
        selected: i === t,
        minor: !0
      }));
    })));
  };

  Se.defaultProps = {
    sectionSubheadline: "",
    selected: null,
    indexUrl: null,
    headlineType: "strong",
    ruleType: "accent"
  }, Se.propTypes = {
    sectionHeadline: l.string.isRequired,
    sectionSubheadline: l.string,
    chapterList: l.arrayOf(l.shape({
      text: l.string,
      href: l.string,
      id: l.string
    })).isRequired,
    selected: l.number,
    indexUrl: l.string,
    headlineType: l.string,
    ruleType: l.oneOf(["accent", "emphasised", "heavy"])
  };

  var Ce = "ds-card",
      Oe = function Oe(e) {
    var t = e.children,
        l = e.className,
        a = o(e, ["children", "className"]);
    return n.createElement("div", i({
      className: B([Ce, l])
    }, a), t);
  };

  Oe.defaultProps = {
    className: ""
  }, Oe.propTypes = {
    children: l.node.isRequired,
    className: l.string
  };

  var Ae = "ds-card-image",
      Fe = function Fe(e) {
    var t = e.imgUrl,
        l = e.className,
        a = e.alt,
        r = o(e, ["imgUrl", "className", "alt"]);
    return n.createElement("img", i({
      className: B([Ae, l]),
      src: t,
      alt: a
    }, r));
  };

  Fe.defaultProps = {
    imgUrl: null,
    alt: "",
    className: ""
  }, Fe.propTypes = {
    imgUrl: l.string,
    alt: l.string,
    className: l.string
  };

  var _e = "ds-card-headline",
      Ue = function Ue(e) {
    var t = e.as,
        l = e.children,
        a = e.className,
        r = o(e, ["as", "children", "className"]);
    return n.createElement(t, i({
      className: B([_e, a])
    }, r), l);
  };

  Ue.defaultProps = {
    as: "h3",
    children: null,
    className: ""
  }, Ue.propTypes = {
    as: l.oneOf(["h1", "h2", "h3", "h4", "h5", "h6"]),
    children: l.node,
    className: l.string
  };

  var Pe = "ds-card-subheadline",
      Ve = "ds-card-subheadline__tagline",
      Re = function Re(e) {
    var t = e.as,
        l = e.children,
        a = e.className,
        r = e.tagline,
        c = o(e, ["as", "children", "className", "tagline"]);
    return n.createElement(t, i({
      className: B([Pe, a])
    }, c), r && n.createElement(n.Fragment, null, n.createElement("span", {
      className: Ve
    }, r), " |", " "), l);
  };

  Re.defaultProps = {
    as: "p",
    children: null,
    className: "",
    tagline: ""
  }, Re.propTypes = {
    as: l.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "p", "span"]),
    children: l.node,
    className: l.string,
    tagline: l.string
  };

  var Be = "ds-card-description",
      He = function He(e) {
    var t = e.as,
        l = e.children,
        a = e.className,
        r = o(e, ["as", "children", "className"]);
    return n.createElement(t, i({
      className: B([Be, a])
    }, r), l);
  };

  He.defaultProps = {
    as: "p",
    children: null,
    className: ""
  }, He.propTypes = {
    as: l.oneOf(["p", "span"]),
    children: l.node,
    className: l.string
  };

  var Ye = "ds-card-action",
      Qe = function Qe(e) {
    var t = e.children,
        l = e.className,
        a = o(e, ["children", "className"]);
    return n.createElement("div", i({
      className: B([Ye, l])
    }, a), t);
  };

  Qe.defaultProps = {
    children: null,
    className: ""
  }, Qe.propTypes = {
    children: l.node,
    className: l.string
  };

  var Ze = "ds-card-content",
      qe = function qe(e) {
    var t = e.children,
        l = e.className,
        a = o(e, ["children", "className"]);
    return n.createElement("div", i({
      className: B([Ze, l])
    }, a), t);
  };

  qe.defaultProps = {
    children: null,
    className: ""
  }, qe.propTypes = {
    children: l.node,
    className: l.string
  };

  var Ge = "ds-card-link",
      We = function We(e) {
    var t = e.children,
        l = e.className,
        a = o(e, ["children", "className"]);
    return n.createElement("a", i({
      className: B([Ge, l])
    }, a), t);
  };

  We.defaultProps = {
    children: null,
    className: ""
  }, We.propTypes = {
    children: l.node,
    className: l.string
  }, Oe.Headline = Ue, Oe.SubHeadline = Re, Oe.Description = He, Oe.Image = Fe, Oe.Action = Qe, Oe.Content = qe, Oe.Link = We;

  var Xe = function Xe(e) {
    if (Array.isArray(e)) return e;
  };

  var Ke = function Ke(e, t) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
      var l = [],
          n = !0,
          a = !1,
          r = void 0;

      try {
        for (var i, c = e[Symbol.iterator](); !(n = (i = c.next()).done) && (l.push(i.value), !t || l.length !== t); n = !0) {
          ;
        }
      } catch (e) {
        a = !0, r = e;
      } finally {
        try {
          n || null == c.return || c.return();
        } finally {
          if (a) throw r;
        }
      }

      return l;
    }
  };

  var Je = function Je(e, t) {
    (null == t || t > e.length) && (t = e.length);

    for (var l = 0, n = new Array(t); l < t; l++) {
      n[l] = e[l];
    }

    return n;
  };

  var $e = function $e(e, t) {
    if (e) {
      if ("string" == typeof e) return Je(e, t);
      var l = Object.prototype.toString.call(e).slice(8, -1);
      return "Object" === l && e.constructor && (l = e.constructor.name), "Map" === l || "Set" === l ? Array.from(e) : "Arguments" === l || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? Je(e, t) : void 0;
    }
  };

  var et = function et() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  };

  var tt = function tt(e, t) {
    return Xe(e) || Ke(e, t) || $e(e, t) || et();
  },
      lt = "ds-control-check__icon",
      nt = "ds-control-check__icon--complete",
      at = "ds-control-check__label-text",
      rt = function rt(e) {
    var l = e.label,
        a = e.id,
        r = e.handleClick,
        c = e.complete,
        s = o(e, ["label", "id", "handleClick", "complete"]),
        d = t.useState(!1),
        m = tt(d, 2),
        u = m[0],
        h = m[1];
    return n.createElement("div", {
      className: "ds-control-check"
    }, c ? n.createElement("span", {
      className: B(lt, nt),
      "aria-label": l
    }) : n.createElement(n.Fragment, null, n.createElement("input", i({
      type: "checkbox",
      onChange: function onChange(e) {
        return function (e) {
          h(e.target.checked), r();
        }(e);
      },
      checked: u,
      id: a
    }, s)), n.createElement("label", {
      className: lt,
      htmlFor: a
    }, n.createElement("span", {
      className: at
    }, l))));
  };

  rt.defaultProps = {
    complete: !1,
    handleClick: function handleClick() {}
  }, rt.propTypes = {
    label: l.string.isRequired,
    id: l.string.isRequired,
    complete: l.bool,
    handleClick: l.func
  };

  var it = "ds-control-collapse",
      ct = "path-background",
      ot = "path-background--disabled",
      st = "ds-control-collapse--disc",
      dt = function dt(e) {
    var t = e.ariaLabel,
        l = e.disabled,
        a = e.disc,
        r = e.handleClick,
        c = o(e, ["ariaLabel", "disabled", "disc", "handleClick"]);
    return n.createElement("button", i({
      className: B(it, R({}, st, a)),
      onClick: r,
      "aria-label": t,
      disabled: l,
      type: "button"
    }, c), n.createElement("svg", {
      viewBox: "5 5 14 14",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("path", {
      className: B(ct, R({}, ot, l)),
      d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    })));
  };

  dt.defaultProps = {
    ariaLabel: "Collapse",
    disabled: !1,
    disc: !1,
    handleClick: null
  }, dt.propTypes = {
    ariaLabel: l.string,
    disabled: l.bool,
    disc: l.bool,
    handleClick: l.func
  };

  var mt = {
    "ds-control-drag": "ds-control-drag",
    "path-background": "path-background",
    "path-background--disabled": "path-background--disabled",
    "ds-control-drag--inverse": "ds-control-drag--inverse"
  },
      ut = function ut(e) {
    var t,
        l,
        a = e.ariaLabel,
        r = e.disabled,
        c = e.horizontal,
        s = e.inverse,
        d = e.handleClick,
        m = o(e, ["ariaLabel", "disabled", "horizontal", "inverse", "handleClick"]);
    return n.createElement("button", i({
      className: B(mt["ds-control-drag"], R({}, mt["ds-control-drag--inverse"], s)),
      onClick: d,
      "aria-label": a,
      disabled: r,
      type: "button"
    }, m), c ? n.createElement("svg", {
      id: "iconVertical",
      width: "12",
      height: "14",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("path", {
      className: B(mt["path-background"], (t = {}, R(t, mt["path-background--disabled"], r), R(t, mt["path-background--inverse"], s), t)),
      d: "M5 14h2V0H5zM0 14h2V0H0zM10 0v14h2V0z"
    })) : n.createElement("svg", {
      id: "iconHorizontal",
      width: "14",
      height: "12",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("path", {
      className: B(mt["path-background"], (l = {}, R(l, mt["path-background--disabled"], r), R(l, mt["path-background--inverse"], s), l)),
      d: "M0 12h14v-2H0v2zm0-5h14V5H0v2zm0-7v2h14V0H0z"
    })));
  };

  ut.defaultProps = {
    ariaLabel: "Drag",
    disabled: !1,
    horizontal: !1,
    inverse: !1,
    handleClick: null
  }, ut.propTypes = {
    ariaLabel: l.string,
    disabled: l.bool,
    horizontal: l.bool,
    inverse: l.bool,
    handleClick: l.func
  };

  var ht = "ds-control-drag-handle",
      gt = "ds-control-drag-handle__thumb",
      vt = "ds-control-drag-handle--horizontal",
      pt = "ds-control-drag-handle--disabled",
      ft = "ds-control-drag-handle--inverse",
      bt = function bt(e) {
    var t,
        l = e.disabled,
        a = e.horizontal,
        r = e.inverse,
        c = o(e, ["disabled", "horizontal", "inverse"]);
    return n.createElement("div", {
      className: B(ht, (t = {}, R(t, ft, r), R(t, vt, a), R(t, pt, l), t))
    }, n.createElement("span", {
      className: B(gt)
    }, n.createElement(ut, i({
      inverse: r,
      disabled: l,
      horizontal: a
    }, c))));
  };

  bt.defaultProps = {
    disabled: !1,
    horizontal: !1,
    inverse: !1
  }, bt.propTypes = {
    disabled: l.bool,
    horizontal: l.bool,
    inverse: l.bool
  };

  var Et = "ds-control-expand",
      wt = "path-background",
      Mt = "path-background--disabled",
      yt = "ds-control-expand--disc",
      kt = function kt(e) {
    var t = e.ariaLabel,
        l = e.disabled,
        a = e.disc,
        r = e.handleClick,
        c = o(e, ["ariaLabel", "disabled", "disc", "handleClick"]);
    return n.createElement("button", i({
      className: B(Et, R({}, yt, a)),
      onClick: r,
      "aria-label": t,
      disabled: l,
      type: "button"
    }, c), n.createElement("svg", {
      viewBox: "5 5 14 14",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("path", {
      className: B(wt, R({}, Mt, l)),
      d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    })));
  };

  kt.defaultProps = {
    ariaLabel: "Expand",
    disabled: !1,
    disc: !1,
    handleClick: null
  }, kt.propTypes = {
    ariaLabel: l.string,
    disabled: l.bool,
    disc: l.bool,
    handleClick: l.func
  };

  var Nt = "ds-control-label",
      xt = "ds-control-label--inverse",
      Lt = function Lt(e) {
    var t = e.inverse,
        l = e.text,
        a = o(e, ["inverse", "text"]);
    return n.createElement("div", i({
      className: B(Nt, R({}, xt, t))
    }, a), l);
  };

  Lt.defaultProps = {
    inverse: !1,
    text: ""
  }, Lt.propTypes = {
    inverse: l.bool,
    text: l.string
  };

  var Tt = {
    "ds-control-media": "ds-control-media",
    "path-background": "path-background",
    "path-background--disabled": "path-background--disabled",
    "ds-control-media--inverse": "ds-control-media--inverse"
  },
      zt = "play",
      jt = "pause",
      Dt = "stop",
      It = function It(e) {
    var t,
        l,
        a,
        r,
        c = e.ariaLabel,
        s = e.controlType,
        d = e.disabled,
        m = e.handleClick,
        u = e.inverse,
        h = o(e, ["ariaLabel", "controlType", "disabled", "handleClick", "inverse"]);
    return n.createElement("button", i({
      className: B(Tt["ds-control-media"], R({}, Tt["ds-control-media--inverse"], u)),
      onClick: m,
      "aria-label": c || s,
      disabled: d,
      type: "button"
    }, h), s === zt && n.createElement("svg", {
      id: "iconPlay",
      height: "32",
      width: "32"
    }, n.createElement("polygon", {
      className: B(Tt["path-background"], (t = {}, R(t, Tt["path-background--disabled"], d), R(t, Tt["path-background--inverse"], u), t)),
      points: "12,7 12,25 24,16"
    })), s === jt && n.createElement("svg", {
      id: "iconPause",
      width: "24",
      height: "24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", null, n.createElement("rect", {
      height: "14",
      width: "4",
      y: "5",
      x: "6",
      className: B(Tt["path-background"], (l = {}, R(l, Tt["path-background--disabled"], d), R(l, Tt["path-background--inverse"], u), l))
    }), n.createElement("rect", {
      height: "14",
      width: "4",
      y: "5",
      x: "14",
      className: B(Tt["path-background"], (a = {}, R(a, Tt["path-background--disabled"], d), R(a, Tt["path-background--inverse"], u), a))
    }))), s === Dt && n.createElement("svg", {
      id: "iconStop",
      width: "12",
      height: "12",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("rect", {
      className: B(Tt["path-background"], (r = {}, R(r, Tt["path-background--disabled"], d), R(r, Tt["path-background--inverse"], u), r)),
      height: "100%",
      width: "100%"
    })));
  };

  It.defaultProps = {
    ariaLabel: null,
    controlType: zt,
    disabled: !1,
    handleClick: null,
    inverse: !1
  }, It.propTypes = {
    ariaLabel: l.string,
    controlType: l.oneOf([zt, jt, Dt]),
    disabled: l.bool,
    handleClick: l.func,
    inverse: l.bool
  };
  var St = {
    "ds-emphasised-link": "ds-emphasised-link",
    "ds-emphasised-link--secondary": "ds-emphasised-link--secondary",
    "ds-emphasised-link--inverse": "ds-emphasised-link--inverse"
  },
      Ct = n.forwardRef(function (e, t) {
    var l,
        a = e.text,
        r = e.href,
        c = e.className,
        s = e.variant,
        d = e.inverse,
        m = o(e, ["text", "href", "className", "variant", "inverse"]);
    return n.createElement("a", i({
      ref: t,
      className: B(St["ds-emphasised-link"], (l = {}, R(l, St["ds-emphasised-link--inverse"], d), R(l, St["ds-emphasised-link--".concat(s)], s), l), c),
      href: r
    }, m), n.createElement("span", null, a));
  });
  Ct.displayName = "EmphasisedLink", Ct.defaultProps = {
    className: "",
    inverse: !1,
    href: "",
    variant: null
  }, Ct.propTypes = {
    href: l.string,
    text: l.string.isRequired,
    className: l.string,
    variant: l.oneOf(["secondary"]),
    inverse: l.bool
  };

  var Ot = {
    "ds-navigation-link": "ds-navigation-link",
    "is-selected": "is-selected",
    "ds-navigation-link--selected": "ds-navigation-link--selected",
    "ds-navigation-link--inverse": "ds-navigation-link--inverse",
    "ds-navigation-link--secondary": "ds-navigation-link--secondary",
    "ds-navigation-link--major": "ds-navigation-link--major",
    "ds-navigation-link--minor": "ds-navigation-link--minor",
    "ds-navigation-link--icon": "ds-navigation-link--icon",
    "ds-navigation-link--icon-account": "ds-navigation-link--icon-account",
    "ds-navigation-link--icon-search": "ds-navigation-link--icon-search"
  },
      At = function At(e) {
    var t,
        l = e.text,
        a = e.secondary,
        r = e.major,
        c = e.minor,
        s = e.inverse,
        d = e.selected,
        m = e.className,
        u = o(e, ["text", "secondary", "major", "minor", "inverse", "selected", "className"]);
    return n.createElement("a", i({
      className: B(m, Ot["ds-navigation-link"], (t = {}, R(t, Ot["ds-navigation-link--secondary"], a), R(t, Ot["ds-navigation-link--major"], r), R(t, Ot["ds-navigation-link--minor"], c), R(t, Ot["ds-navigation-link--inverse"], s), R(t, Ot["ds-navigation-link--selected"], d), t))
    }, u), n.createElement("span", null, l));
  };

  At.defaultProps = {
    className: null,
    text: "",
    secondary: !1,
    major: !1,
    minor: !1,
    inverse: !1,
    selected: !1
  }, At.propTypes = {
    className: l.string,
    text: l.string,
    secondary: l.bool,
    major: l.bool,
    minor: l.bool,
    inverse: l.bool,
    selected: l.bool
  };

  var Ft = "ds-footer",
      _t = "ds-footer-cols-alpha",
      Ut = "ds-footer-cols-alpha__lead",
      Pt = "ds-footer-cols-lambda",
      Vt = "ds-footer-cols-lambda__group",
      Rt = "ds-footer-cols-omega",
      Bt = "ds-footer__link-list",
      Ht = "ds-footer-cols-share",
      Yt = "ds-footer__header",
      Qt = "ds-footer__copyright",
      Zt = "ds-footer__mission-statement",
      qt = function qt(e) {
    var t = e.links,
        l = e.secondary,
        a = e.major,
        r = e.minor,
        c = e.inverse;
    return n.createElement("ul", {
      className: Bt
    }, t.map(function (e) {
      var t = e.url,
          s = e.id,
          d = e.name,
          m = (e.amp, o(e, ["url", "id", "name", "amp"]));
      return n.createElement("li", {
        key: t,
        id: s
      }, n.createElement(At, i({
        href: t,
        text: d,
        secondary: l,
        major: a,
        minor: r,
        inverse: c
      }, m)));
    }));
  };

  qt.defaultProps = {
    secondary: !1,
    major: !1,
    minor: !1,
    inverse: !1
  }, qt.propTypes = {
    links: l.arrayOf(l.shape({
      url: l.string.isRequired,
      name: l.string.isRequired,
      id: l.string
    })).isRequired,
    secondary: l.bool,
    major: l.bool,
    minor: l.bool,
    inverse: l.bool
  };

  var Gt = "ds-share-link",
      Wt = "ds-share-link--inverse",
      Xt = function Xt(e) {
    var t = e.href,
        l = e.icon,
        a = e.inverse,
        r = o(e, ["href", "icon", "inverse"]);
    return n.createElement("a", i({
      className: B(Gt, R({}, Wt, a)),
      href: t
    }, r), l);
  };

  function Kt(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function Jt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Kt(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : Kt(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  Xt.defaultProps = {
    href: null,
    inverse: !1
  }, Xt.propTypes = {
    icon: l.node.isRequired,
    inverse: l.bool,
    href: l.string
  };

  var $t = {
    economist: "https://www.economist.com",
    weeklyEdition: "https://www.economist.com/weeklyedition",
    search: "https://www.economist.com/search",
    theWorldInBrief: "https://www.economist.com/the-world-in-brief",
    subscribe: "https://subscription.economist.com/DE/EngCore/Ecom/Masthead",
    subscribeFooter: "https://www.economist.com/subscribe",
    myEconomist: "https://my.economist.com",
    cookiePolicy: "https://www.economistgroup.com/results_and_governance/governance/Cookies_information.html",
    cookieManage: "https://l3.evidon.com/site/2254/668/6?lang=en-gb"
  },
      el = l.shape(Object.keys($t).reduce(function (e, t) {
    return Jt(Jt({}, e), {}, R({}, t, l.string));
  }, {})),
      tl = {
    "account-logged-in": [{
      name: "My Economist",
      url: "/my-economist"
    }, {
      name: "Saved stories",
      url: "/saved-stories"
    }, {
      name: "Admin account",
      url: ""
    }, {
      name: "My subscription",
      url: ""
    }, {
      name: "Personal information",
      url: ""
    }, {
      name: "Billing",
      url: ""
    }, {
      name: "Newsletters & preferences",
      url: ""
    }, {
      name: "Gift subscriptions",
      url: ""
    }, {
      name: "Help",
      url: ""
    }, {
      name: "Log out",
      url: ""
    }],
    "account-logged-in-main": [{
      name: "Saved stories",
      url: "/saved-stories"
    }, {
      name: "Admin account",
      url: ""
    }, {
      name: "Account",
      url: "/my-economist"
    }, {
      name: "Log out",
      url: ""
    }],
    "account-logged-out": [{
      name: "Log in",
      url: ""
    }]
  },
      ll = function ll() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.baseUrl,
        l = void 0 === t ? $t.economist : t,
        n = e.amp,
        a = void 0 !== n && n;
    return {
      customerLinks: [{
        name: "Subscribe",
        url: "".concat(l, "/subscribe")
      }, {
        name: "Group subscriptions",
        url: "".concat(l, "/group-subscriptions/")
      }, {
        name: "Reuse our content",
        url: "https://rights.economist.com/"
      }, {
        name: "The Trust Project",
        url: "".concat(l, "/frequently-asked-questions")
      }, {
        name: "Help and contact us",
        url: "https://myaccount.economist.com/s/help"
      }],
      economistGroupLinks: [{
        name: "The Economist Group",
        url: "https://www.economistgroup.com/"
      }, {
        name: "Economist Intelligence",
        url: "https://www.eiu.com/n/"
      }, {
        name: "Economist Impact",
        url: "https://impact.economist.com/"
      }, {
        name: "Economist Events",
        url: "https://events.economist.com/?RefID=e.com-home&utm_source=e.com&utm_medium=website&utm_campaign=group-aff&utm_content=footer-link"
      }, {
        name: "Working Here",
        url: "https://www.economistgroup.com/careers"
      }, {
        name: "Economist Education Courses",
        url: "https://education.economist.com"
      }, {
        name: "Which MBA?",
        url: "https://whichmba.economist.com/"
      }, {
        name: "Executive Jobs",
        url: "http://jobs.economist.com/"
      }, {
        name: "Executive Education Navigator",
        url: "https://execed.economist.com"
      }],
      minorLinks: [{
        id: "footer-terms-of-use",
        name: "Terms of Use",
        url: "https://www.economistgroup.com/terms-of-use"
      }, {
        id: "footer-privacy",
        name: "Privacy",
        url: "https://www.economistgroup.com/privacy-policy"
      }, {
        id: "footer-cookie-policy",
        name: "Cookie Policy",
        url: "https://www.economistgroup.com/cookies-policy"
      }, {
        id: "footer-manage-cookies",
        name: "Manage Cookies",
        url: "#privacy-manager",
        amp: !1,
        className: "js-cmp-manage-cookies"
      }, {
        id: "footer-manage-cookies",
        name: "Manage Cookies",
        on: "tap:evidon-amp-consent.prompt()",
        amp: !0,
        url: "#footer-manage-cookies"
      }, {
        id: "footer-accessibility",
        name: "Accessibility",
        url: "https://www.economistgroup.com/accessibility-policy"
      }, {
        id: "footer-modern-slavery-statement",
        name: "Modern Slavery Statement",
        url: "https://www.economistgroup.com/esg/modern-slavery-act-statement"
      }, {
        id: "sitemap",
        name: "Sitemap",
        url: "https://www.economist.com/sitemap"
      }, {
        id: "footer-ccpa",
        name: "California: Do Not Sell My Personal Information",
        url: "https://www.economist.com/privacyportal"
      }].filter(function (e) {
        return void 0 === e.amp || e.amp === a;
      }),
      socialLinks: {
        FACEBOOK_LINK: "https://www.facebook.com/theeconomist",
        INSTAGRAM_LINK: "https://www.instagram.com/theeconomist",
        TWITTER_LINK: "https://www.twitter.com/theeconomist",
        LINKEDIN_LINK: "https://www.linkedin.com/company/the-economist",
        YOUTUBE_LINK: "https://www.youtube.com/user/economistmagazine",
        RSS_LINK: "https://www.economist.com/rss"
      },
      theEconomistLinks: [{
        name: "About",
        url: "https://www.economistgroup.com/about-us"
      }, {
        name: "Advertise",
        url: "https://impact.economist.com/"
      }, {
        name: "Press centre",
        url: "https://www.economistgroup.com/group-news"
      }]
    };
  },
      nl = {
    TAB: 9,
    ESC: 27,
    SPACE: 32,
    ENTER: 13
  },
      al = "Tab",
      rl = "Escape",
      il = (l.oneOfType([l.object, l.shape({
    current: l.instanceOf(t.Element)
  })]), "ds-layout-grid");

  function cl(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function ol(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? cl(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : cl(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  var sl = n.createElement("p", {
    className: Zt
  }, "Published since September 1843 to take part in", " ", n.createElement("em", null, "“a severe contest between intelligence, which presses forward, and an unworthy, timid ignorance obstructing our progress.”"), " "),
      dl = function dl(e) {
    var t = e.subscribeUrl,
        l = e.overrideUrls,
        a = ol(ol({}, $t), l),
        r = ll(),
        i = r.customerLinks,
        c = r.socialLinks,
        o = r.theEconomistLinks,
        s = r.economistGroupLinks,
        d = r.minorLinks,
        m = c.FACEBOOK_LINK,
        u = c.INSTAGRAM_LINK,
        h = c.TWITTER_LINK,
        g = c.LINKEDIN_LINK,
        v = c.YOUTUBE_LINK,
        p = c.RSS_LINK,
        f = new Date().getFullYear();
    return i.find(function (e) {
      return "Subscribe" === e.name;
    }).url = t || a.subscribe, n.createElement("footer", {
      itemType: "http://schema.org/WPFooter",
      className: Ft,
      role: "contentinfo"
    }, n.createElement("div", {
      className: "".concat(il, " ").concat(_t)
    }, n.createElement("div", {
      id: "ds-footer-customer-links",
      className: Ut
    }, n.createElement(qt, {
      links: i,
      secondary: !0,
      major: !0,
      inverse: !0
    })), n.createElement("div", {
      className: Ht
    }, n.createElement("h2", {
      className: Yt
    }, "Keep updated"), n.createElement("ul", {
      className: Bt
    }, n.createElement("li", {
      id: "ds-footer-facebook-icon"
    }, n.createElement(Xt, {
      href: m,
      inverse: !0,
      icon: n.createElement(j, null)
    })), n.createElement("li", {
      id: "ds-footer-instagram-icon"
    }, n.createElement(Xt, {
      href: u,
      inverse: !0,
      icon: n.createElement(D, null)
    })), n.createElement("li", {
      id: "ds-footer-twitter-icon"
    }, n.createElement(Xt, {
      href: h,
      inverse: !0,
      icon: n.createElement(C, null)
    })), n.createElement("li", {
      id: "ds-footer-linkedin-icon"
    }, n.createElement(Xt, {
      href: g,
      inverse: !0,
      icon: n.createElement(I, null)
    })), n.createElement("li", {
      id: "ds-footer-youtube-icon"
    }, n.createElement(Xt, {
      href: v,
      inverse: !0,
      icon: n.createElement(A, null)
    })), n.createElement("li", {
      id: "ds-footer-rss-icon"
    }, n.createElement(Xt, {
      href: p,
      inverse: !0,
      icon: n.createElement(S, null)
    })))), sl), n.createElement("nav", {
      className: "".concat(il, " ").concat(Pt)
    }, n.createElement("div", {
      id: "ds-footer-the-economist",
      className: Vt
    }, n.createElement("h2", {
      className: Yt
    }, "The Economist"), n.createElement(qt, {
      links: o,
      inverse: !0,
      secondary: !0
    })), n.createElement("div", {
      id: "ds-footer-the-economist-group",
      className: Vt
    }, n.createElement("h2", {
      className: Yt
    }, "The Economist Group"), n.createElement(qt, {
      links: s,
      inverse: !0,
      secondary: !0
    }))), n.createElement("div", {
      className: Rt
    }, n.createElement(qt, {
      links: d,
      inverse: !0,
      secondary: !0,
      minor: !0
    }), n.createElement("p", {
      id: "ds-footer-copyright",
      className: Qt
    }, "Copyright © The Economist Newspaper Limited ", f, ". All rights reserved.")));
  };

  dl.defaultProps = {
    overrideUrls: {},
    subscribeUrl: null
  }, dl.propTypes = {
    overrideUrls: el,
    subscribeUrl: l.string
  };
  var ml = "ds-footer-secondary",
      ul = "ds-footer-secondary-cols-alpha",
      hl = "ds-footer-secondary-cols-alpha__lead",
      gl = "ds-footer-secondary-cols-omega",
      vl = "ds-footer-secondary__copyright";

  function pl(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function fl(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? pl(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : pl(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  var bl = function bl(e) {
    var t = e.amp,
        l = e.subscribeUrl,
        a = e.overrideUrls,
        r = ll({
      amp: t
    }),
        i = r.customerLinks,
        c = r.minorLinks,
        o = new Date().getFullYear(),
        s = fl(fl({}, $t), a);
    return i.find(function (e) {
      return "Subscribe" === e.name;
    }).url = l || s.subscribeFooter, n.createElement("footer", {
      itemType: "http://schema.org/WPFooter",
      className: ml,
      role: "contentinfo"
    }, n.createElement("div", {
      className: "".concat(ul)
    }, n.createElement("div", {
      id: "ds-footer-secondary-customer-links",
      className: hl
    }, n.createElement(qt, {
      links: i,
      secondary: !0,
      major: !0,
      inverse: !0
    }))), n.createElement("div", {
      className: gl
    }, n.createElement(qt, {
      links: c,
      inverse: !0,
      secondary: !0,
      minor: !0
    }), n.createElement("p", {
      id: "ds-footer-secondary-copyright",
      className: vl
    }, "Copyright © The Economist Newspaper Limited ", o, ". All rights reserved.")));
  };

  bl.defaultProps = {
    amp: !1,
    overrideUrls: {},
    subscribeUrl: null
  }, bl.propTypes = {
    amp: l.bool,
    overrideUrls: el,
    subscribeUrl: l.string
  };

  var El = "ds-form-checkbox__box",
      wl = "ds-form-checkbox",
      Ml = "ds-form-checkbox--indeterminate",
      yl = "ds-form-check-label",
      kl = "ds-form-check-label--disabled",
      Nl = function Nl(e) {
    var t = e.isDisabled,
        l = o(e, ["isDisabled"]);
    return n.createElement("label", i({
      className: B(yl, R({}, kl, t))
    }, l));
  };

  Nl.defaultProps = {
    isDisabled: !1
  }, Nl.propTypes = {
    isDisabled: l.bool
  };

  var xl = function xl(e) {
    var t = e.labelText,
        l = e.isIndeterminate,
        a = o(e, ["labelText", "isIndeterminate"]);
    return n.createElement("div", {
      className: B(wl, R({}, Ml, l && !a.defaultChecked))
    }, n.createElement("input", i({
      type: "checkbox"
    }, a)), n.createElement("div", {
      className: El
    }), n.createElement(Nl, {
      isDisabled: a.disabled,
      htmlFor: a.id
    }, t));
  };

  xl.defaultProps = {
    isIndeterminate: !1
  }, xl.propTypes = {
    isIndeterminate: l.bool,
    labelText: l.string.isRequired
  };
  var Ll = "ds-form-input",
      Tl = "ds-form-input--inverse",
      zl = "ds-form-input--invalid",
      jl = "ds-number-input",
      Dl = "ds-date-input",
      Il = "ds-text-area",
      Sl = "ds-form-field-select",
      Cl = "ds-form-input--slim",
      Ol = t.forwardRef(function (e, t) {
    var l,
        a = e.ariaLabel,
        r = e.disabled,
        c = e.error,
        s = e.id,
        d = e.inverse,
        m = e.max,
        u = e.maxLength,
        h = e.min,
        g = e.name,
        v = e.onBlur,
        p = e.onChange,
        f = e.placeholder,
        b = e.slim,
        E = e.step,
        w = e.type,
        M = e.value,
        y = o(e, ["ariaLabel", "disabled", "error", "id", "inverse", "max", "maxLength", "min", "name", "onBlur", "onChange", "placeholder", "slim", "step", "type", "value"]);
    return n.createElement("input", i({
      "aria-label": a,
      className: B(Ll, (l = {}, R(l, zl, !!c), R(l, Cl, b), R(l, Tl, d), R(l, jl, "number" === w), R(l, Dl, "date" === w), l)),
      disabled: r,
      id: s,
      max: m,
      maxLength: u,
      min: h,
      name: g,
      onBlur: v,
      onChange: p,
      placeholder: f,
      ref: t,
      step: E,
      type: w,
      value: M
    }, y));
  });
  Ol.displayName = "FormInput", Ol.defaultProps = {
    ariaLabel: null,
    disabled: !1,
    error: "",
    id: "",
    inverse: null,
    name: "",
    max: null,
    maxLength: null,
    min: null,
    onBlur: null,
    onChange: null,
    placeholder: null,
    slim: null,
    step: null,
    type: "text",
    value: ""
  }, Ol.propTypes = {
    ariaLabel: l.string,
    disabled: l.bool,
    error: l.oneOfType([l.string, l.number]),
    id: l.string,
    inverse: l.bool,
    max: l.string,
    maxLength: l.number,
    min: l.string,
    name: l.string,
    onBlur: l.func,
    onChange: l.func,
    placeholder: l.string,
    slim: l.bool,
    step: l.string,
    type: l.oneOf(["text", "number", "date", "email", "password"]),
    value: l.string
  };

  var Al = "ds-form-label",
      Fl = "ds-form-label--inverse",
      _l = function _l(e) {
    var t = e.children,
        l = e.htmlFor,
        a = e.tag,
        r = e.inverse,
        i = e.text;
    return n.createElement("label", {
      className: B(Al, R({}, Fl, r)),
      htmlFor: l
    }, n.createElement("span", null, i), a && n.createElement("span", {
      className: "ds-form-tag"
    }, a), t);
  };

  _l.defaultProps = {
    children: null,
    tag: null,
    htmlFor: null,
    inverse: !1,
    text: ""
  }, _l.propTypes = {
    children: l.node,
    tag: l.string,
    htmlFor: l.string,
    inverse: l.bool,
    text: l.string
  };

  var Ul = "ds-form-notice",
      Pl = "ds-form-notice--inverse",
      Vl = function Vl(e) {
    var t = e.inverse,
        l = e.text;
    return n.createElement("span", {
      className: B(Ul, R({}, Pl, t))
    }, l);
  };

  Vl.defaultProps = {
    inverse: !1
  }, Vl.propTypes = {
    inverse: l.bool,
    text: l.string.isRequired
  };

  var Rl = "ds-slim-button",
      Bl = "ds-slim-button--inverse",
      Hl = "ds-slim-button--secondary",
      Yl = "ds-slim-button--icon",
      Ql = function Ql(e) {
    var t,
        l = e.children,
        a = e.type,
        r = e.className,
        c = e.icon,
        s = e.secondary,
        d = e.inverse,
        m = e.disabled,
        u = o(e, ["children", "type", "className", "icon", "secondary", "inverse", "disabled"]);
    return n.createElement("button", i({
      className: B(Rl, (t = {}, R(t, Hl, s), R(t, Bl, d), R(t, Yl, c), t), r),
      type: a,
      disabled: m
    }, u), l);
  };

  Ql.defaultProps = {
    type: "button",
    className: "",
    icon: !1,
    secondary: !1,
    inverse: !1,
    disabled: !1
  }, Ql.propTypes = {
    children: l.node.isRequired,
    type: l.oneOf(["button", "reset", "submit"]),
    className: l.string,
    icon: l.bool,
    secondary: l.bool,
    inverse: l.bool,
    disabled: l.bool
  };

  var Zl = "ds-form-field-layout",
      ql = "ds-form-field-layout--adjacent",
      Gl = "ds-form-field-combined-input",
      Wl = function Wl(e) {
    var l = e.adjacent,
        a = e.buttonLabel,
        r = e.buttonType,
        c = e.disabled,
        s = e.error,
        d = e.id,
        m = e.icon,
        u = e.inverse,
        h = e.labelText,
        g = e.maxLength,
        v = e.name,
        p = e.onBlur,
        f = e.onButtonClick,
        b = e.onChange,
        E = e.placeholder,
        w = e.slim,
        M = e.value,
        y = e.focusInput,
        k = o(e, ["adjacent", "buttonLabel", "buttonType", "disabled", "error", "id", "icon", "inverse", "labelText", "maxLength", "name", "onBlur", "onButtonClick", "onChange", "placeholder", "slim", "value", "focusInput"]),
        N = t.useRef();
    return t.useEffect(function () {
      y && N.current.focus();
    }, [y]), n.createElement("div", {
      className: B(R({}, "".concat(Zl, " ").concat(ql), l))
    }, n.createElement(_l, {
      inverse: u,
      text: h,
      htmlFor: d
    }), n.createElement("div", {
      className: B(Gl)
    }, n.createElement(Ol, i({
      disabled: c,
      error: s,
      id: d,
      inverse: u,
      maxLength: g,
      name: v,
      onBlur: p,
      onChange: b,
      placeholder: E,
      slim: w,
      value: M,
      ref: N
    }, k)), w ? n.createElement(Ql, {
      disabled: c,
      onClick: f,
      type: r,
      inverse: u,
      secondary: u,
      icon: m
    }, a) : n.createElement(me, {
      disabled: c,
      onClick: f,
      inverse: u,
      secondary: u,
      type: r,
      icon: m
    }, a)), s && n.createElement(Vl, {
      text: s
    }));
  };

  Wl.defaultProps = {
    adjacent: !1,
    buttonType: null,
    disabled: !1,
    error: null,
    id: "",
    icon: !1,
    inverse: null,
    maxLength: null,
    name: "",
    onBlur: null,
    onButtonClick: null,
    onChange: null,
    onClick: null,
    placeholder: null,
    slim: !1,
    value: "",
    focusInput: !1
  }, Wl.propTypes = {
    adjacent: l.bool,
    buttonLabel: l.oneOfType([l.node, l.string]).isRequired,
    buttonType: l.oneOf(["button", "reset", "submit"]),
    disabled: l.bool,
    error: l.string,
    icon: l.bool,
    id: l.string,
    inverse: l.bool,
    labelText: l.string.isRequired,
    maxLength: l.number,
    name: l.string,
    onBlur: l.func,
    onButtonClick: l.func,
    onChange: l.func,
    onClick: l.func,
    placeholder: l.string,
    slim: l.bool,
    value: l.string,
    focusInput: l.bool
  };

  var Xl = "ds-form-helper-text",
      Kl = "ds-form-helper-text--inverse",
      Jl = function Jl(e) {
    var t = e.inverse,
        l = e.text;
    return n.createElement("p", {
      className: B(Xl, R({}, Kl, t))
    }, l);
  };

  Jl.defaultProps = {
    inverse: !1
  }, Jl.propTypes = {
    inverse: l.bool,
    text: l.string.isRequired
  };

  var $l = function $l(e) {
    var t = e.adjacent,
        l = e.disabled,
        a = e.error,
        r = e.helperText,
        i = e.id,
        c = e.labelTag,
        o = e.labelText,
        s = e.min,
        d = e.max,
        m = e.name,
        u = e.onBlur,
        h = e.onChange,
        g = e.slim,
        v = e.step,
        p = e.value;
    return n.createElement("div", {
      className: B(R({}, "".concat(Zl, " ").concat(ql), t))
    }, n.createElement(_l, {
      text: o,
      tag: c,
      htmlFor: i
    }), r && n.createElement(Jl, {
      text: r
    }), n.createElement(Ol, {
      disabled: l,
      error: a,
      id: i,
      max: d,
      min: s,
      name: m,
      onBlur: u,
      onChange: h,
      slim: g,
      step: v,
      type: "date",
      value: p
    }), a && n.createElement(Vl, {
      text: a
    }));
  };

  $l.defaultProps = {
    adjacent: !1,
    disabled: !1,
    error: null,
    helperText: null,
    id: "",
    labelTag: null,
    max: null,
    min: null,
    name: "",
    onBlur: null,
    onChange: null,
    slim: null,
    step: null,
    value: ""
  }, $l.propTypes = {
    adjacent: l.bool,
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string,
    labelTag: l.string,
    labelText: l.string.isRequired,
    max: l.string,
    min: l.string,
    name: l.string,
    onBlur: l.func,
    onChange: l.func,
    slim: l.bool,
    step: l.string,
    value: l.string
  };

  var en = function en(e) {
    var t = e.fields,
        l = e.helperText,
        a = e.labelText,
        r = e.notice,
        c = e.onBlur,
        s = e.onChange,
        d = o(e, ["fields", "helperText", "labelText", "notice", "onBlur", "onChange"]);
    return n.createElement("div", null, n.createElement(_l, {
      text: a
    }), l && n.createElement(Jl, {
      text: l
    }), Object.keys(t).map(function (e) {
      return n.createElement(Ol, i({
        ariaLabel: t[e].ariaLabel,
        disabled: t[e].disabled,
        error: t[e].error,
        id: e,
        key: e,
        name: t[e].name,
        onBlur: c,
        onChange: s,
        placeholder: t[e].placeholder,
        type: t[e].type,
        value: t[e].value
      }, d));
    }), r && n.createElement(Vl, {
      text: r
    }));
  };

  en.defaultProps = {
    helperText: null,
    labelText: "",
    notice: "",
    onBlur: null
  }, en.propTypes = {
    helperText: l.string,
    labelText: l.string,
    fields: l.shape({
      id: l.shape({
        ariaLabel: l.string,
        disabled: l.bool,
        error: l.string,
        id: l.string,
        name: l.string,
        placeholder: l.string,
        type: Ol.propTypes.type,
        value: l.string
      })
    }).isRequired,
    notice: l.string,
    onBlur: l.func,
    onChange: l.func.isRequired
  };

  var tn = "ds-form-field-number",
      ln = "ds-form-field-number__button",
      nn = "ds-form-field-number__button--down",
      an = "ds-form-field-number--slim",
      rn = function rn(e) {
    var l = e.adjacent,
        a = e.disabled,
        r = e.error,
        i = e.helperText,
        c = e.id,
        o = e.labelTag,
        s = e.labelText,
        d = e.min,
        m = e.max,
        u = e.name,
        h = e.onBlur,
        g = e.onChange,
        v = e.placeholder,
        p = e.slim,
        f = e.step,
        b = e.value,
        E = t.createRef(),
        w = parseInt(f, 10) || 1;
    return n.createElement("div", {
      className: B(R({}, "".concat(Zl, " ").concat(ql), l))
    }, n.createElement(_l, {
      text: s,
      tag: o,
      htmlFor: c
    }), i && n.createElement(Jl, {
      text: i
    }), n.createElement("div", {
      className: B(tn, R({}, an, p))
    }, n.createElement(Ol, {
      disabled: a,
      error: r,
      id: c,
      max: m,
      min: d,
      name: u,
      onBlur: h,
      onChange: g,
      placeholder: v,
      ref: E,
      slim: p,
      step: f,
      type: "number",
      value: b
    }), n.createElement("button", {
      disabled: a,
      onClick: function onClick() {
        var e = (parseInt(E.current.value, 10) || 0) + w;
        (!m || m >= e) && (E.current.value = e);
      },
      "aria-label": "Increase number",
      type: "button",
      className: B(ln)
    }), n.createElement("button", {
      disabled: a,
      onClick: function onClick() {
        var e = (parseInt(E.current.value, 10) || 0) - w;
        (!d || d <= e) && (E.current.value = e);
      },
      "aria-label": "Decrease number",
      type: "button",
      className: B(ln, nn)
    })), r && n.createElement(Vl, {
      text: r
    }));
  };

  rn.defaultProps = {
    adjacent: !1,
    disabled: !1,
    error: null,
    helperText: null,
    id: "",
    labelTag: null,
    max: null,
    min: null,
    name: "",
    onBlur: null,
    onChange: null,
    placeholder: null,
    slim: null,
    step: null,
    value: ""
  }, rn.propTypes = {
    adjacent: l.bool,
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string,
    labelTag: l.string,
    labelText: l.string.isRequired,
    max: l.string,
    min: l.string,
    name: l.string,
    onBlur: l.func,
    onChange: l.func,
    placeholder: l.string,
    slim: l.bool,
    step: l.string,
    value: l.string
  };

  var cn = "ds-form-password-meter",
      on = function on(e) {
    var t = e.label,
        l = e.low,
        a = e.high,
        r = e.max,
        i = e.optimum,
        c = e.value;
    return n.createElement("div", {
      className: B(cn)
    }, n.createElement("span", null, t), n.createElement("meter", {
      low: l,
      high: a,
      max: r,
      optimum: i,
      value: c
    }));
  };

  on.defaultProps = {
    label: "Strength",
    low: 8,
    high: 12,
    max: 13,
    optimum: 13,
    value: 0
  }, on.propTypes = {
    label: l.string,
    low: l.number,
    high: l.number,
    max: l.number,
    optimum: l.number,
    value: l.number
  };

  var sn = "ds-form-field-password",
      dn = "ds-form-field-password__button",
      mn = "ds-form-field-password__button--slim",
      un = "ds-form-field-password__button--off",
      hn = function hn(e) {
    var l,
        a = e.disabled,
        r = e.error,
        c = e.helperText,
        s = e.id,
        d = e.labelTag,
        m = e.labelText,
        u = e.maxLength,
        h = e.meterLabel,
        g = e.meterHigh,
        v = e.meterLow,
        p = e.meterMax,
        f = e.meterOptimum,
        b = e.meterValue,
        E = e.name,
        w = e.onBlur,
        M = e.onChange,
        y = e.onFocus,
        k = e.placeholder,
        N = e.slim,
        x = e.value,
        L = o(e, ["disabled", "error", "helperText", "id", "labelTag", "labelText", "maxLength", "meterLabel", "meterHigh", "meterLow", "meterMax", "meterOptimum", "meterValue", "name", "onBlur", "onChange", "onFocus", "placeholder", "slim", "value"]),
        T = t.useState(!1),
        z = tt(T, 2),
        j = z[0],
        D = z[1],
        I = t.useState(!1),
        S = tt(I, 2),
        C = S[0],
        O = S[1];
    return n.createElement(n.Fragment, null, n.createElement("div", {
      className: B(sn)
    }, n.createElement(_l, {
      text: m,
      tag: d,
      htmlFor: s
    }), c && n.createElement(Jl, {
      text: c
    }), n.createElement(Ol, i({
      disabled: a,
      error: r,
      id: s,
      maxLength: u,
      name: E,
      onBlur: function onBlur(e) {
        x.length || O(!1), w && w(e);
      },
      onChange: M,
      onFocus: function onFocus(e) {
        "number" == typeof b && O(!0), y && y(e);
      },
      placeholder: k,
      slim: N,
      type: j ? "text" : "password",
      value: x
    }, L)), n.createElement("button", {
      disabled: a,
      onClick: function onClick() {
        D(!j);
      },
      "aria-label": "Toggle visibility",
      type: "button",
      className: B(dn, (l = {}, R(l, un, j), R(l, mn, N), l))
    })), C && n.createElement(on, {
      label: h,
      low: v,
      high: g,
      optimum: f,
      max: p,
      value: b
    }));
  };

  hn.defaultProps = {
    disabled: !1,
    error: null,
    helperText: null,
    id: null,
    maxLength: null,
    meterHigh: 12,
    meterLabel: "Strength",
    meterLow: 8,
    meterMax: 13,
    meterOptimum: 13,
    meterValue: null,
    name: null,
    onBlur: null,
    onFocus: null,
    placeholder: null,
    labelTag: null,
    slim: null,
    value: void 0
  }, hn.propTypes = {
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string,
    labelTag: l.string,
    labelText: l.string.isRequired,
    maxLength: l.number,
    meterHigh: l.number,
    meterLabel: l.string,
    meterLow: l.number,
    meterMax: l.number,
    meterOptimum: l.number,
    meterValue: l.number,
    name: l.string,
    onBlur: l.func,
    onChange: l.func.isRequired,
    onFocus: l.func,
    placeholder: l.string,
    slim: l.bool,
    value: l.string
  };

  var gn = function gn(e) {
    var t = e.adjacent,
        l = e.disabled,
        a = e.id,
        r = e.inverse,
        c = e.labelText,
        s = e.maxLength,
        d = e.name,
        m = e.onChange,
        u = e.placeholder,
        h = e.slim,
        g = e.value,
        v = o(e, ["adjacent", "disabled", "id", "inverse", "labelText", "maxLength", "name", "onChange", "placeholder", "slim", "value"]);
    return n.createElement(n.Fragment, null, n.createElement(Wl, i({
      adjacent: t,
      buttonLabel: n.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        role: "img",
        "aria-labelledby": "".concat(a, "-icon")
      }, n.createElement("title", {
        id: "".concat(a, "-icon")
      }, "Search"), n.createElement("path", {
        d: "M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
      })),
      disabled: l,
      id: a,
      icon: !0,
      inverse: r,
      labelText: c,
      maxLength: s,
      name: d,
      onChange: m,
      placeholder: u,
      slim: h,
      value: g
    }, v)));
  };

  gn.defaultProps = {
    adjacent: null,
    disabled: !1,
    id: "search",
    inverse: null,
    maxLength: null,
    name: "",
    onChange: null,
    placeholder: " ",
    slim: null,
    value: ""
  }, gn.propTypes = {
    adjacent: l.bool,
    disabled: l.bool,
    id: l.string,
    inverse: l.bool,
    labelText: l.string.isRequired,
    maxLength: l.number,
    name: l.string,
    onChange: l.func,
    placeholder: l.string,
    slim: l.bool,
    value: l.string
  };

  var vn = function vn(e) {
    var t,
        l = e.adjacent,
        a = e.disabled,
        r = e.error,
        c = e.helperText,
        s = e.id,
        d = e.labelTag,
        m = e.labelText,
        u = e.options,
        h = e.slim,
        g = e.value,
        v = e.defaultValue,
        p = o(e, ["adjacent", "disabled", "error", "helperText", "id", "labelTag", "labelText", "options", "slim", "value", "defaultValue"]);
    return n.createElement("div", {
      className: B(R({}, "".concat(Zl, " ").concat(ql), l))
    }, n.createElement(_l, {
      text: m,
      tag: d,
      htmlFor: s
    }), c && n.createElement(Jl, {
      text: c
    }), n.createElement("select", i({
      id: s,
      disabled: a,
      defaultValue: v || g,
      className: B(Ll, (t = {}, R(t, zl, r), R(t, Cl, h), t), Sl)
    }, p), u.map(function (e) {
      return n.createElement("option", {
        key: e.value,
        "aria-selected": g === e.value,
        value: e.value
      }, e.label);
    })), r && n.createElement(Vl, {
      text: r
    }));
  };

  vn.defaultProps = {
    adjacent: !1,
    disabled: !1,
    error: "",
    helperText: null,
    options: [],
    labelTag: null,
    slim: null,
    value: "",
    defaultValue: void 0
  }, vn.propTypes = {
    adjacent: l.bool,
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string.isRequired,
    labelTag: l.string,
    labelText: l.string.isRequired,
    options: l.arrayOf(l.shape({
      value: l.string,
      label: l.string
    })),
    slim: l.bool,
    value: l.string,
    defaultValue: l.string
  };

  var pn = function pn(e) {
    var t = e.adjacent,
        l = e.disabled,
        a = e.error,
        r = e.helperText,
        c = e.id,
        s = e.labelTag,
        d = e.labelText,
        m = e.maxLength,
        u = e.name,
        h = e.onBlur,
        g = e.onChange,
        v = e.placeholder,
        p = e.slim,
        f = e.value,
        b = o(e, ["adjacent", "disabled", "error", "helperText", "id", "labelTag", "labelText", "maxLength", "name", "onBlur", "onChange", "placeholder", "slim", "value"]);
    return n.createElement("div", {
      className: B(R({}, "".concat(Zl, " ").concat(ql), t))
    }, n.createElement(_l, {
      text: d,
      tag: s,
      htmlFor: c
    }), r && n.createElement(Jl, {
      text: r
    }), n.createElement(Ol, i({
      disabled: l,
      error: a,
      id: c,
      maxLength: m,
      name: u,
      onBlur: h,
      onChange: g,
      placeholder: v,
      slim: p,
      value: f
    }, b)), a && n.createElement(Vl, {
      text: a
    }));
  };

  pn.defaultProps = {
    adjacent: !1,
    disabled: !1,
    error: null,
    helperText: null,
    id: "",
    maxLength: null,
    name: "",
    onBlur: null,
    onChange: null,
    placeholder: null,
    labelTag: null,
    slim: null,
    value: ""
  }, pn.propTypes = {
    adjacent: l.bool,
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string,
    labelTag: l.string,
    labelText: l.string.isRequired,
    maxLength: l.number,
    name: l.string,
    onBlur: l.func,
    onChange: l.func,
    placeholder: l.string,
    slim: l.bool,
    value: l.string
  };

  var fn = function fn(e) {
    var t = e.disabled,
        l = e.error,
        a = e.helperText,
        r = e.id,
        i = e.labelTag,
        c = e.labelText,
        o = e.name,
        s = e.onBlur,
        d = e.onChange,
        m = e.placeholder,
        u = e.value,
        h = e.cols,
        g = e.rows,
        v = e.maxLength;
    return n.createElement("div", null, n.createElement(_l, {
      text: c,
      tag: i,
      htmlFor: r
    }), a && n.createElement(Jl, {
      text: a
    }), n.createElement("textarea", {
      className: B(Ll, Il, R({}, zl, l)),
      disabled: t,
      id: r,
      name: o,
      onBlur: s,
      onChange: d,
      placeholder: m,
      cols: h,
      rows: g,
      value: u,
      maxLength: v
    }), l && n.createElement(Vl, {
      text: l
    }));
  };

  fn.defaultProps = {
    disabled: !1,
    id: null,
    error: "",
    helperText: null,
    name: "",
    onBlur: null,
    onChange: null,
    placeholder: null,
    labelTag: null,
    value: "",
    rows: null,
    cols: null,
    maxLength: null
  }, fn.propTypes = {
    disabled: l.bool,
    error: l.string,
    helperText: l.string,
    id: l.string,
    labelTag: l.string,
    labelText: l.string.isRequired,
    name: l.string,
    onBlur: l.func,
    onChange: l.func,
    placeholder: l.string,
    value: l.string,
    rows: l.string,
    cols: l.string,
    maxLength: l.number
  };

  var bn = "ds-form-radio-button__box",
      En = "ds-form-radio-button",
      wn = function wn(e) {
    var t = e.labelText,
        l = o(e, ["labelText"]);
    return n.createElement("div", {
      className: B(En)
    }, n.createElement("input", i({
      type: "radio"
    }, l)), n.createElement("div", {
      className: bn
    }), n.createElement(Nl, {
      isDisabled: l.disabled,
      htmlFor: l.id
    }, t));
  };

  wn.defaultProps = {}, wn.propTypes = {
    labelText: l.string.isRequired
  };
  var Mn = {
    "bagehots-notebook": function bagehotsNotebook(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#B51915",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("circle", {
        fill: "#FFF",
        cx: "50",
        cy: "50",
        r: "30.2"
      }), n.createElement("path", {
        d: "M47.7 49.7c.4-.9 1.3-1.3 2.1-1.5l4-7.5c-.4-.8-.4-2.1.3-2.7.3-.3 1.2-.9 1.6-1.7l1.9-2.5c.5-.8 1.5-.7.9 1.1 0 0-.7 2-.9 2.5-.1.4-.3.9-.3 1.3v1.1c0 .8-.7 1.6-1.7 1.9l-3.9 7.6.3.5h11.7c.8-.9 2-.9 2.7-.7l.8.3c.3.1.8.3 1.2.3l3.2.3c1.3.1 2.7.3 3.5.4 1.1.1 1.2 1.2-.1 1.3-.3 0-5.3.4-6.4.5-.5 0-.9.1-1.2.3l-.8.3c-.8.3-1.9.3-2.7-.7H52c-.7 1.2-2.1 1.6-3.3 1.1-1.1-.7-1.6-2.1-1-3.5z",
        fill: "#0D0D0D"
      })));
    },
    "bartlebys-notebook": function bartlebysNotebook(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#FF8874",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M23.6 40.7c0-6.2 3.5-9.6 9.7-9.6h5.2c2.4-.2 2.5-1.4 2.6-3.2v-1.8h-2.9c-1.8 0-3.3-1.4-3.3-3.1 0-1.7 1.5-3.1 3.3-3.1h23.6c1.8 0 3.3 1.4 3.3 3.1 0 1.7-1.5 3.1-3.3 3.1h-2.4c0 .5-.1 1.2 0 1.8.1 1.8.7 3.2 2.6 3.2h5.4c6.2 0 9 3.3 9 9.5v30.2c0 6.2-3 9.3-9.2 9.3H32.6c-6.2 0-9-3.6-9-9.8V40.7z",
        fill: "#0E0340"
      }), n.createElement("path", {
        d: "M34.8 43.2c0-1.8 1.8-3.2 4-3.2H60c2.2 0 4 1.4 4 3.2 0 1.8-1.8 3.2-4 3.2H38.8c-2.2 0-4-1.4-4-3.2z",
        fill: "#FF8374"
      })));
    },
    "buttonwoods-notebook": function buttonwoodsNotebook(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#BEE7F0",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M84 59.8c-19.5-3.6-23.2-18.6-36.6-25.2-8.9-4.3-20.2-3.8-30.4 3.5 2.2 12.2 4.8 22 18.6 27.5C49.5 71 73.9 67.1 84 59.8z",
        fill: "#3B7323"
      })));
    },
    "charlemagnes-notebook": function charlemagnesNotebook(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#FFD836",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M19.8 71.4C40 85.2 60.5 56.8 80.2 70.1V28.5C59 12.5 40 43 19.8 28.5v42.9z",
        fill: "#004388"
      })));
    },
    "democracy-in-america": function democracyInAmerica(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#004388",
        fillRule: "nonzero",
        cx: "50",
        cy: "50.8",
        r: "50"
      }), n.createElement("path", {
        d: "M75 7.5c0 41.8-57.3 40-57.8 81 8.8 7.6 20.2 12.3 32.8 12.3 27.6 0 50-22.4 50-50 0-18.5-10.1-34.7-25-43.3z",
        fill: "#E10814"
      }), n.createElement("path", {
        d: "M50 64.4L34.4 75.7c-2.3 1.7-4.5 0-3.6-2.6l6-18.1-15.6-11.3c-2.3-1.7-1.5-4.3 1.5-4.3h19.2l6-18.1c.9-2.8 3.6-2.8 4.5 0l6 18.1h19.2c2.8 0 3.6 2.6 1.5 4.3L63.4 55l6 18.1c.9 2.8-1.3 4.3-3.6 2.6L50 64.4z",
        fill: "#FFF"
      })));
    },
    erasmus: function erasmus(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#BD902D",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M66 16.1h-1.2v-.6c-.4-.5-1.1-.8-1.8-.8-.6 0-1.3.3-1.7.8v.6H38.1v-.6c-.4-.5-1.1-.8-1.8-.8-.6 0-1.2.2-1.6.6v.8h-1.3c-1.1.3-1.9 1.1-1.9 2.2v9.1c0 1 .8 1.8 1.9 2.1h1.3v.8c.4.4 1 .7 1.6.7.7 0 1.3-.4 1.8-.8v-.8h8.6l-.8 44-.1 9.5c0 1.3 1.1 2.3 2.5 2.3H51c1.3 0 2.5-1 2.5-2.3l-.1-10.5-.5-42.9h8.5v.7c.4.5 1 .8 1.7.8.8 0 1.4-.4 1.8-.9v-.5h1.2c1.3-.1 2.5-1.1 2.5-2.3v-9.1c-.2-1.1-1.3-2.1-2.6-2.1z",
        fill: "#0D0D0D"
      })));
    },
    "free-exchange": function freeExchange(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fillRule: "nonzero",
        fill: "none"
      }, n.createElement("circle", {
        fill: "#695F4B",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M43.1 37.5c.7.2 1 .8 1.2 1.4 0 0 2.7 10 3.3 13.4.2 1.2-.1 2-.7 2.4h6.5c-.7-.3-1-1.1-.7-2.4.7-3.4 3.3-13.4 3.3-13.4.2-.6.6-1.2 1.2-1.4H43.1zM14.6 70.3c0-.2 0-.5.1-.7.7-3.4 3.3-13.4 3.3-13.4.3-.8.7-1.6 2.2-1.6h6.2c-.7-.3-1-1.1-.7-2.4.7-3.4 3.3-13.4 3.3-13.4.3-.8.7-1.6 2.2-1.6h8.9c-.9-.2-1.6-1-1.2-2.6.7-3.4 3.3-13.4 3.3-13.4.3-.8.7-1.6 2.2-1.6h10.9c1.4 0 1.8.7 2.2 1.6 0 0 2.7 10 3.3 13.4.3 1.6-.3 2.3-1.2 2.6h9.5c1.4 0 1.8.7 2.2 1.6 0 0 2.7 10 3.3 13.4.2 1.2-.1 2-.7 2.4H80c1.4 0 1.8.7 2.2 1.6 0 0 2.7 10 3.3 13.4.1.2.1.5.1.7H63.3c0-.2 0-.5.1-.7.7-3.4 3.3-13.4 3.3-13.4.2-.5.4-.9.8-1.2H56.8c.4.3.7.7.8 1.2 0 0 2.7 10 3.3 13.4.1.2.1.5.1.7H38.9c0-.2 0-.5.1-.7.7-3.4 3.3-13.4 3.3-13.4.2-.5.4-.9.8-1.2H32.4c.4.3.7.7.8 1.2 0 0 2.7 10 3.3 13.4.1.2.1.5.1.7h-22z",
        fill: "#D3B029"
      })));
    },
    "game-theory": function gameTheory(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#5E9732",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("circle", {
        fill: "#0D0D0D",
        cx: "50",
        cy: "50",
        r: "30.2"
      }), n.createElement("path", {
        d: "M48.5 61.4l-7.1-4.3-6.7 4-.2 2.9-.4 3.4c1 1 2.2 1.8 3.5 2.7.6.4 1.2.8 1.9 1.1.5.2 1 .5 1.5.7 1 .4 2 .8 3.2 1.1.5.1 1.1.3 1.6.4l1.2-1 2.3-2.1-.3-4.5-.5-4.4zM66.7 58.3L59 55.6l-6 5.2.2 1.4.4 4.2.3 3.4 2.4 1.5.8.5.8.5 1.5-.6c1-.4 1.9-.9 2.8-1.4.9-.5 1.7-1.1 2.6-1.7.8-.6 1.5-1.3 2.3-2 .4-.4.7-.7 1-1.1l-1-4.9-.4-2.3zM62.4 36.1l-5 7.4 3.3 7.7 7.1 2.4 1.6-.9 1.6-.9 2.9-1.7c0-.9 0-1.8-.1-2.8-.1-1-.3-2-.5-3.1-.2-1-.5-1.9-.9-3-.7-1.9-1.7-3.7-2.9-5.3h-4l-3.1.2zM32.7 39.8l-4.9 1.7c-.3.8-.6 1.6-.8 2.6-.5 2.1-.7 4.5-.6 6.7 0 .5.1.9.1 1.4 0 .3.1.5.1.8 0 .3.1.5.1.8l3.3 1.6 2.3 1.3 6.8-4.1 1.9-8.5-6-5.4-2.3 1.1zM38.3 35.5l6.5 5.8 9-.8 2.4-3.8 2.4-3.7-2.1-6.2c-.3-.1-.7-.2-1-.3-.7-.2-1.4-.3-2.1-.4-1.8-.2-3.7-.3-5.6-.1-2.6.3-5 .9-7.2 1.9-.7.3-1.4.7-2.1 1.1v2.8l-.2 3.7z",
        fill: "#FFF"
      })));
    },
    "graphic-detail": function graphicDetail(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#5F90B3",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("ellipse", {
        fill: "#F6B51B",
        cx: "50.1",
        cy: "50",
        rx: "30.1",
        ry: "30"
      }), n.createElement("path", {
        d: "M50 19.9c-16.6 0-30.2 13.5-30.2 30v.1h30.3L34.7 75.8c4.5 2.7 9.8 4.2 15.4 4.2 16.6 0 30-13.5 30-30S66.6 19.9 50 19.9z",
        fill: "#F3913E"
      }), n.createElement("path", {
        d: "M50.1 50H20c0-11 5.9-20.6 14.7-25.8",
        fill: "#F5E001"
      })));
    },
    gulliver: function gulliver(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#5AC5C4",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M44.8 14.9l4.8 2.4 4.8-2.5 4.6 4.3-5.5 5.6 3.6 49.8v.1l-6.9 10.6c-.1.2-.3.2-.4 0l-7.3-10.1v-.2l3.1-50.3-5.2-5.6 4.4-4.1z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M43.6 57.6l-23-19.5c-.1-.1-.2-.3-.2-.4v-6.6c0-.4.3-.6.7-.4l23.5 11.1-1 15.8zM54.9 42.7l24-11.3c.3-.2.7.1.7.4v6.6c0 .1-.1.3-.2.4L56 58.6l-1.1-15.9z",
        fill: "#077678"
      })));
    },
    kaffeeklatsch: function kaffeeklatsch(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#F1B500",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M78.8 90.8C67.5 76.3 64.6 50 64 46.2c2.9-.9 12.4-.2 21.1-.6C71.7 40.7 55.8 30.3 51 27.9c-3.8-1.9-11.3-.7-13.7 2.8-5.1-2.2-9.6-2.8-13.1-2.1-2.2.5-4 1.4-5.2 2.9-1.3 1.4-2 3.2-2.1 5.6-.1 3.6 1.2 6.4 2.3 9.6 10-3.6 21.4.5 21.6 2v.7c2.3 16.6-4.3 34.5-15.9 43.9 7.4 4.3 15.9 6.7 25 6.8h.1c10.8-.1 20.7-3.5 28.8-9.3z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M42.9 32.6s1.2-1.5 3.3-1.5c2.8 0 4.9 1.4 4.9 1.4l-2.9 1.7c-.1 0-1.6-2.3-5.3-1.6z",
        fill: "#FAB913"
      })));
    },
    "open-future-2018": function openFuture2018(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fillRule: "nonzero",
        fill: "none"
      }, n.createElement("circle", {
        fill: "#19D2B9",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M32.498 25v16.31c4.848.832 8.714 2.733 11.54 5.704 2.824 2.971 4.222 6.655 4.222 11.111 0 4.665-1.665 8.646-4.996 11.943C39.874 73.366 35.829 75 31.1 75c-4.817 0-8.862-1.812-12.163-5.407C15.665 65.879 14 61.453 14 56.224c0-4.575.833-9.031 2.498-13.399 1.636-4.307 3.985-8.05 7.019-11.29 2.052-2.198 5.026-4.366 8.981-6.535zm37.889 0v16.31c4.817.743 8.624 2.615 11.45 5.615C84.601 49.985 86 53.7 86 58.095c0 4.665-1.636 8.646-4.937 11.944-3.3 3.297-7.316 4.931-12.074 4.931-4.907 0-9.011-1.812-12.283-5.407-3.3-3.654-4.936-8.08-4.936-13.31 0-4.485.802-8.882 2.438-13.19a36.13 36.13 0 0 1 6.81-11.111c2.41-2.525 5.532-4.813 9.369-6.952z",
        fill: "#142680"
      })));
    },
    "open-future-2019": function openFuture2019(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fillRule: "nonzero",
        fill: "none"
      }, n.createElement("circle", {
        fill: "#E75A36",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M32.498 25v16.31c4.848.832 8.714 2.733 11.54 5.704 2.824 2.971 4.222 6.655 4.222 11.111 0 4.665-1.665 8.646-4.996 11.943C39.874 73.366 35.829 75 31.1 75c-4.817 0-8.862-1.812-12.163-5.407C15.665 65.879 14 61.453 14 56.224c0-4.575.833-9.031 2.498-13.399 1.636-4.307 3.985-8.05 7.019-11.29 2.052-2.198 5.026-4.366 8.981-6.535zm37.889 0v16.31c4.817.743 8.624 2.615 11.45 5.615C84.601 49.985 86 53.7 86 58.095c0 4.665-1.636 8.646-4.937 11.944-3.3 3.297-7.316 4.931-12.074 4.931-4.907 0-9.011-1.812-12.283-5.407-3.3-3.654-4.936-8.08-4.936-13.31 0-4.485.802-8.882 2.438-13.19a36.13 36.13 0 016.81-11.111c2.41-2.525 5.532-4.813 9.369-6.952z",
        fill: "#0A1757"
      })));
    },
    prospero: function prospero(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#ECE8E1",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M68.2 47.4c-5.8-8.1-11-18.1-14.5-26.9-.5-1.1-2.2-.8-2.2.4v22.4c1.9.7 3.2 2.6 2.9 4.8-.3 1.8-1.6 3.2-3.4 3.6-2.8.6-5.3-1.6-5.3-4.3 0-1.9 1.2-3.5 2.9-4.1V21c0-1.2-1.7-1.6-2.2-.4-3.5 8.8-8.7 18.6-14.6 26.9 6.9 15.5 6.7 32.8 6.7 32.8h23c0-.1-.2-17.4 6.7-32.9z",
        fill: "#E20713"
      })));
    },
    "the-economist-explains": function theEconomistExplains(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("circle", {
        fill: "#916CAF",
        fillRule: "nonzero",
        cx: "50",
        cy: "50",
        r: "50"
      }), n.createElement("path", {
        d: "M50 85.3v-8.6c-8.7-.5-16.6-3.4-22-8.6-5.5-5.2-8.2-11.7-8.2-19.5 0-8.2 3-15 8.8-20.6 5.8-5.5 13.1-8.2 21.7-8.2 8.4 0 15.4 2.7 21.2 8.3 5.7 5.6 8.6 12.5 8.6 20.7C80.2 74.3 60 83.7 50 85.3z",
        fill: "#0D0D0D"
      })));
    }
  },
      yn = (Object.keys(Mn).filter(function (e) {
    return "__filemeta" !== e;
  }), function (e) {
    var t = e.className,
        l = e.height,
        a = e.ident,
        r = e.width,
        i = Mn[a];
    return n.createElement("span", {
      className: B("ds-ident-columns", "ds-ident-columns--".concat(a), t)
    }, n.createElement(i, {
      width: r,
      height: l,
      className: "ds-ident-columns__svg"
    }));
  });

  function kn(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function Nn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? kn(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : kn(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  yn.propTypes = {
    className: l.string,
    height: l.number,
    width: l.number,
    ident: l.oneOf(["bagehots-notebook", "bartlebys-notebook", "buttonwoods-notebook", "charlemagnes-notebook", "democracy-in-america", "erasmus", "free-exchange", "game-theory", "graphic-detail", "gulliver", "kaffeeklatsch", "open-future-2018", "open-future-2019", "prospero", "the-economist-explains"]).isRequired
  }, yn.defaultProps = {
    className: "",
    height: 112,
    width: 112
  };

  var xn = function xn() {
    return Math.floor(36 * Math.random()).toString(36);
  },
      Ln = function Ln(e) {
    var t,
        l = (t = 8, Array.from({
      length: t
    }, xn).join("")),
        n = {
      defId: "".concat(e, "_def_").concat(l),
      maskId: "".concat(e, "_mask_").concat(l)
    };
    return Nn(Nn({}, n), {}, {
      defSelector: "#".concat(n.defId),
      maskSelector: "url(#".concat(n.maskId, ")")
    });
  },
      Tn = {
    "checks-and-balance": function checksAndBalance(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_cab");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F6423C",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M84.68 3.696L37.185 88.688l5.768 1.113L91.07 3.696zm12.776 0L49.058 90.193l6.438-.068 48.36-86.429zm12.799 0l-48.41 86.557 6.128.464 48.67-87.021zm12.774 0L74.265 90.743l5.095 2.329 50.069-89.376z"
      }), n.createElement("path", {
        fill: "#2E3C85",
        mask: r.maskSelector,
        d: "M9.795 48.319l24.949 44.753H79.39L54.441 48.319z"
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M20.568 52.27l3.47 3.96h4.074l-1.929 2.449 3.47 3.96-4.662-2.448-1.929 2.449-.952-3.961-4.663-2.448h4.074zm13.664 0l3.47 3.96h4.074l-1.929 2.449 3.47 3.96-4.662-2.448-1.93 2.449-.952-3.961-4.662-2.448h4.074zm13.664 0l3.47 3.96h4.074l-1.929 2.449 3.47 3.96-4.662-2.448-1.93 2.449-.952-3.961-4.662-2.448h4.073zm-20.04 13.098l3.47 3.961H35.4l-1.93 2.448 3.47 3.961-4.661-2.448-1.93 2.448-.952-3.96-4.662-2.449h4.073zm14.028 0l3.47 3.961h4.074l-1.93 2.448 3.471 3.961-4.662-2.448-1.93 2.448-.952-3.96-4.662-2.449h4.074zm13.482 0l3.47 3.961h4.073l-1.928 2.448 3.47 3.961-4.663-2.448-1.929 2.448-.952-3.96-4.663-2.449h4.074zM35.325 78.649l3.47 3.96h4.074l-1.929 2.449 3.47 3.96-4.662-2.447-1.93 2.448-.952-3.961-4.662-2.448h4.074zm13.665 0l3.47 3.96h4.073l-1.929 2.449 3.47 3.96-4.662-2.447-1.93 2.448-.952-3.961-4.662-2.448h4.074zm13.48 0l3.471 3.96h4.074l-1.93 2.449 3.471 3.96-4.662-2.447-1.93 2.448-.952-3.961-4.662-2.448h4.073z"
      }), n.createElement("path", {
        fill: "#F6423C",
        mask: r.maskSelector,
        d: "M91.044 3.696L60.261 58.752l3.19 5.707L97.427 3.696zm12.754 0L66.637 70.042l3.19 5.696L110.18 3.696zm12.754 0L73.014 81.498l3.19 5.701 46.728-83.503z"
      })));
    },
    "cover-story": function coverStory(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_cs");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#2E45B8",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        fill: "#2E45B8",
        mask: r.maskSelector,
        d: "M9.034 112.223h96.485V-.448H9.034z"
      }), n.createElement("path", {
        fillOpacity: .3,
        fill: "#F5F4F4",
        mask: r.maskSelector,
        d: "M54.315 86.886h57.68V26.458h-57.68z"
      }), n.createElement("path", {
        fillOpacity: .3,
        fill: "#F5F4F4",
        mask: r.maskSelector,
        d: "M-.263 78.07h79.632V16.775H-.263z"
      }), n.createElement("path", {
        fill: "#F5F4F4",
        mask: r.maskSelector,
        d: "M20.72 112.336h70.336V35.952H20.72z"
      }), n.createElement("path", {
        fill: "#E3120C",
        mask: r.maskSelector,
        d: "M24.08 54.432h30.24v-15.12H24.08z"
      })));
    },
    "drum-tower": function drumTower(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        xmlns: "http://www.w3.org/2000/svg",
        width: l,
        height: t,
        viewBox: "0 0 112 112",
        fill: "none"
      }, a), n.createElement("circle", {
        cx: "56",
        cy: "56",
        r: "56",
        fill: "#F6423C"
      }), n.createElement("path", {
        d: "M61.6022 86.9945V78.6698C61.6022 75.573 59.0932 73.0615 55.9977 73.0615C52.9021 73.0615 50.3931 75.5742 50.3931 78.6698V86.9945H28.1305L30.5099 66.4333H81.4855L83.8648 86.9945H61.6022V86.9945Z",
        fill: "#F9C31F"
      }), n.createElement("path", {
        d: "M88.6667 63.5488H23.3334L35.1463 54.1659L36.628 46.3228H75.3709L76.8489 54.1659L88.6667 63.5488Z",
        fill: "#F9C31F"
      }), n.createElement("path", {
        d: "M84.7316 33.9778C82.509 39.0316 77.7947 43.4385 72.3309 43.4385H39.6655C34.2054 43.4385 29.4862 39.0316 27.2686 33.9778C32.2891 35.4039 36.1971 36.3102 40.536 36.3102H71.4641C75.8031 36.3102 79.7111 35.4039 84.7316 33.9778V33.9778Z",
        fill: "#F9C31F"
      }), n.createElement("path", {
        d: "M78.8985 25.6962C77.1353 31.528 74.1484 33.4295 68.8612 33.4295H43.1375C37.8503 33.4295 34.8634 31.528 33.1002 25.6962C35.2722 27.189 37.8701 27.9854 40.4495 27.9854C45.5799 27.9854 52.2229 21.8944 55.9975 17.4221C59.7759 21.8944 66.4188 27.9854 71.5492 27.9854C74.1286 27.9854 76.7266 27.1903 78.8985 25.6962V25.6962Z",
        fill: "#F9C31F"
      }));
    },
    espresso: function espresso(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_espresso");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F9C31F",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M56.224 75.6c-16.02 0-29.008-12.987-29.008-29.008 0-16.02 12.987-29.008 29.008-29.008 16.02 0 29.008 12.987 29.008 29.008 0 16.02-12.987 29.008-29.008 29.008",
        fill: "#FCDD83",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M56.28 68.32c-12.031 0-21.784-9.753-21.784-21.784 0-12.031 9.753-21.784 21.784-21.784 12.031 0 21.784 9.753 21.784 21.784 0 12.03-9.753 21.784-21.784 21.784",
        fill: "#FEF2CD",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M56.28 61.152c-8.072 0-14.616-6.544-14.616-14.616S48.208 31.92 56.28 31.92s14.616 6.544 14.616 14.616-6.544 14.616-14.616 14.616",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M34.496 46.592h43.568l-.076 32.734c-.012 5.253-4.294 9.501-9.565 9.49l-24.404-.054c-5.271-.012-9.535-4.28-9.523-9.532V46.592z",
        fill: "#0D0D0D",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M84.467 56.448a8.512 8.512 0 11-.038 17.024 8.512 8.512 0 01.038-17.024zm-.01 4.696a3.816 3.816 0 10-.018 7.632 3.816 3.816 0 00.017-7.632zm.926 31.816H27.177c-1.334 0-2.425-1.059-2.425-2.352 0-1.294 1.091-2.352 2.425-2.352h58.206c1.334 0 2.425 1.058 2.425 2.352 0 1.293-1.091 2.352-2.425 2.352",
        fill: "#0D0D0D",
        mask: r.maskSelector
      })));
    },
    "money-talks": function moneyTalks(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_mt_a"),
          c = Ln("nl_mt_b"),
          s = Ln("nl_mt_c");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("path", {
        id: c.defId,
        d: "M0 .085h48.612v37.234H0z"
      }), n.createElement("path", {
        id: s.defId,
        d: "M.013.061h46.931v60.83H.013z"
      }), n.createElement("circle", {
        id: r.defId,
        cx: 55.945,
        cy: 55.944,
        r: 55.944
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F97A1F",
        xlinkHref: r.defSelector
      }), n.createElement("g", {
        mask: r.maskSelector
      }, n.createElement("g", {
        transform: "translate(31.12 15.666)"
      }, n.createElement("mask", {
        id: c.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: c.defSelector
      })), n.createElement("path", {
        d: "M47.116 9.2s1.728-1.719 1.47-5.223c-.07-.962-.275-1.717-.525-2.31C47.503.362 46-.248 44.675.267L2.35 16.705c-3.24 1.254-3.025 4.45 0 5.617l37.341 14.575c4.125 1.426 7.88-.953 7.124-4.209a25.273 25.273 0 00-.172-.66 4.75 4.75 0 00-1.151-2.02c-5.346-5.487-22.516-9.704-39.816-10.657 12.306-3.89 36.155-4.114 41.44-10.152",
        fill: "#0D0D0D",
        mask: c.maskSelector
      }))), n.createElement("path", {
        d: "M75.77 34.32a1.136 1.136 0 001.066-1.124l.36-7.352c-1.744 1.288-4.46 2.284-7.717 3.1a2.772 2.772 0 01-.292.069c-.086.017-.163.043-.25.06-.128.034-.266.06-.395.095a.254.254 0 01-.086.017c-.18.043-.37.086-.558.129-.009 0-.017 0-.026.008-7.4 1.658-17.076 2.611-24.871 4.166-.069.017-.137.025-.215.043-.12.025-.232.042-.352.068l-.395.078-.12.025c-.19.043-.37.078-.56.12-.008 0-.025.01-.034.01-.799.17-1.572.36-2.32.549l36.765-.06zM71 37.37l-19.096-.705c8.139 1.366 15.367 3.41 20.196 5.875v-3.908A1.256 1.256 0 0071 37.37m.86 30.823c-1.702-.412-3.086.636-3.086 2.336 0 1.7 1.384 3.419 3.086 3.83 1.701.413 3.085-.635 3.085-2.335s-1.384-3.418-3.085-3.83",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("g", {
        mask: r.maskSelector
      }, n.createElement("g", {
        transform: "translate(31.12 35.247)"
      }, n.createElement("mask", {
        id: s.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: s.defSelector
      })), n.createElement("path", {
        d: "M45.758 43.115c-.524.292-1.392.352-2.01.094l-4.238-1.666a6.292 6.292 0 01-4.03-5.874v-2.104c0-2.895 2.905-4.887 5.612-3.84l2.664 1.057c1.53.601 3.188-.524 3.188-2.164V15.134c0-.258-.017-.507-.043-.765-.344 2.56-3.635 4.174-7.193 2.938L2.358 2.74C.89 2.174.09 1.135.014.06l.111 38.52a7.847 7.847 0 005.02 7.316l38.122 14.807c1.873.558 3.661-.12 3.661-2.121v-14.67c.009-.644-.636-1.09-1.169-.798",
        fill: "#FFF",
        mask: s.maskSelector
      })))));
    },
    "off-the-charts": function offTheCharts(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_otc");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F97A1F",
        xlinkHref: r.defSelector
      }), n.createElement("g", {
        mask: r.maskSelector
      }, n.createElement("g", {
        transform: "translate(-6.247 -4.032)"
      }, n.createElement("path", {
        fill: "#FCB583",
        d: "M35.367 22.4h29.12v99.904h-29.12z"
      }), n.createElement("path", {
        fill: "#FEE2CD",
        d: "M64.487 59.808h29.12v62.496h-29.12z"
      }), n.createElement("path", {
        fill: "#FA9851",
        d: "M6.247 46.144h29.12v76.16H6.247z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        fillRule: "nonzero",
        d: "M119.76.137l3.247 1.518L79.65 94.4 49.502 48.664 21.148 77.82.013 66.425l1.701-3.154 18.752 10.11 29.575-30.412 29.076 44.11z"
      }), n.createElement("circle", {
        fill: "#FFF",
        cx: 49.927,
        cy: 46.144,
        r: 5.6
      }), n.createElement("circle", {
        fill: "#FFF",
        cx: 79.047,
        cy: 89.152,
        r: 5.6
      }), n.createElement("circle", {
        fill: "#FFF",
        cx: 20.807,
        cy: 74.144,
        r: 5.6
      })))));
    },
    "plot-twist": function plotTwist(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        xmlns: "http://www.w3.org/2000/svg",
        width: l,
        height: t,
        viewBox: "0 0 720 720",
        fill: "none"
      }, a), n.createElement("circle", {
        cx: "360",
        cy: "360",
        r: "360",
        fill: "#F9C31F"
      }), n.createElement("path", {
        d: "M569.045 529.35L530.808 548.251L475.198 575.724V483.894L530.808 510.836L569.045 529.35Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M569.046 529.351L522.122 552.544L523.107 507.101L569.046 529.351Z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M382.798 348.57L345.586 348.122L347.882 374.46L476.543 375.716L488.734 221.498L239.242 230.402L242.679 484.274L475.198 483.887V575.731L159.189 577.761L150 144.324L569.045 143L561.812 452.897L278.24 448.686L280.977 267.124L387.036 261.691L382.798 348.57Z",
        fill: "#E3120B"
      }), n.createElement("path", {
        d: "M387.037 261.691H438.599L459.008 305.13L429.417 348.57H382.799L360.902 300.539L387.037 261.691Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M407.798 284.158C421.327 284.158 430.346 294.08 430.346 301.3C430.346 308.519 428.546 324.751 411.404 324.751C394.262 324.751 389.08 310.801 389.08 302.427C389.08 294.053 398.914 284.158 407.798 284.158Z",
        fill: "#0D0D0D"
      }));
    },
    "simply-science": function simplyScience(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_ss");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 55.944,
        cy: 55.944,
        r: 55.944
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F9C31F",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M56.051 41.119c5.34 0 10.436.387 15.099 1.089l1.156.182c14.15 2.325 24.025 7.594 24.025 13.722 0 5.465-7.855 10.247-19.593 12.867l-1.077.232-1.099.22-.556.106-1.129.201-1.147.189c-.385.06-.774.119-1.166.175l-1.183.162c-4.172.545-8.658.84-13.33.84-4.671 0-9.157-.295-13.33-.84l-1.183-.162c-.391-.056-.78-.115-1.165-.175l-1.148-.189c-13.843-2.372-23.453-7.581-23.453-13.626 0-5.548 8.095-10.392 20.129-12.985l1.088-.226a82.015 82.015 0 012.808-.511l1.156-.182c4.663-.702 9.76-1.09 15.098-1.09zm0 2.909a99.9 99.9 0 00-12.402.76l-1.1.144-1.082.156c-.358.054-.713.11-1.065.167l-1.048.177c-.173.03-.345.062-.516.093l-1.02.193-1 .203c-.165.034-.329.07-.492.105l-.97.217c-.32.074-.635.149-.948.226l-.927.235-.455.12-.894.248a65.71 65.71 0 00-.87.255l-.847.264-.823.27c-.675.229-1.324.465-1.946.707l-.732.294-.706.3c-4.73 2.07-7.527 4.535-7.527 6.95 0 2.945 4.16 5.966 10.911 8.25l.823.271.847.263c.572.173 1.16.341 1.764.503l.916.24.938.23.959.222c.484.108.977.213 1.477.315l1.01.198c.34.064.682.127 1.028.188l1.048.177 1.065.167.54.08 1.09.15a95 95 0 004.523.483l1.167.09c.391.028.785.054 1.18.077l1.194.064 1.206.05a103.447 103.447 0 007.369 0l1.206-.05 1.193-.064c.396-.023.79-.049 1.18-.077l1.168-.09a95 95 0 004.523-.483l1.09-.15 1.075-.162.53-.085 1.048-.177c.519-.092 1.03-.187 1.536-.286l1-.203c.33-.07.656-.14.98-.212l.958-.222.938-.23.916-.24c.302-.08.6-.163.894-.247l.87-.256c.716-.216 1.407-.44 2.071-.671l.785-.282c6.05-2.227 9.725-5.063 9.725-7.831 0-2.415-2.797-4.88-7.527-6.95l-.706-.3-.733-.294a50.598 50.598 0 00-4.485-1.496l-.894-.248-.455-.12-.927-.235a69.784 69.784 0 00-.949-.226l-.97-.217c-.163-.036-.327-.07-.492-.105l-1-.203-1.019-.193-1.038-.183a86.077 86.077 0 00-1.591-.254l-1.083-.156-1.1-.145a100.08 100.08 0 00-12.402-.759z",
        fill: "#0D0D0D",
        fillRule: "nonzero",
        mask: r.maskSelector,
        transform: "rotate(90 56.051 56.112)"
      }), n.createElement("path", {
        d: "M55.652 41.112c2.877.002 5.683.117 8.388.335l1.241.108 1.226.122c16.855 1.787 29.216 7.61 29.22 14.511.003 5.737-8.535 10.72-21.098 13.255l-1.103.215a86.95 86.95 0 01-1.69.297l-1.15.182c-4.638.703-9.707 1.089-15.018 1.086a103.775 103.775 0 01-10.855-.565l-1.21-.136-1.195-.15a88.01 88.01 0 01-2.91-.433l-1.131-.197a80.207 80.207 0 01-1.113-.209l-1.093-.221c-12.267-2.58-20.565-7.51-20.568-13.165-.002-4.822 6.03-9.112 15.415-11.863l.983-.279a69.886 69.886 0 014.7-1.113l1.103-.214c5.377-1.005 11.441-1.569 17.858-1.566zm0 2.238c-.42 0-.838.002-1.254.007l-1.242.022c-2.68.063-5.282.23-7.778.485l-1.145.124c-.568.065-1.13.135-1.687.21l-1.104.154a86.85 86.85 0 00-.546.082l-1.078.172c-2.494.414-4.84.92-7.004 1.5l-.916.254-.45.13-.88.266-.432.137-.845.279c-7.078 2.404-11.461 5.67-11.46 8.974.002 3.566 5.105 7.09 13.186 9.541l.893.263a67.84 67.84 0 004.8 1.178l1.022.206.518.098 1.051.19a85.09 85.09 0 002.156.347l1.105.155 1.12.144c1.506.184 3.054.335 4.638.45l1.195.08 1.207.066 1.22.052a103.47 103.47 0 006.84.024l1.225-.044c1.22-.05 2.421-.122 3.602-.214l1.174-.099 1.16-.111a92.845 92.845 0 002.273-.261l1.112-.149c.368-.051.733-.105 1.096-.16l1.078-.172c3.207-.533 6.17-1.217 8.813-2.017l.87-.27c7.571-2.428 12.306-5.82 12.304-9.254-.002-3.63-5.292-7.218-13.63-9.673l-.904-.26a68.645 68.645 0 00-4.344-1.048l-1.022-.206a79.153 79.153 0 00-.519-.1l-1.05-.189-1.07-.179-1.087-.167-1.105-.156c-.185-.025-.371-.05-.558-.073L67.071 44a94.786 94.786 0 00-2.304-.238l-1.174-.1a101.572 101.572 0 00-7.314-.31l-.628-.002z",
        fill: "#0D0D0D",
        fillRule: "nonzero",
        mask: r.maskSelector,
        transform: "rotate(150 55.66 56.168)"
      }), n.createElement("path", {
        d: "M55.919 41.4c6.208-.007 12.087.517 17.333 1.458l1.115.208c12.887 2.5 21.688 7.559 21.681 13.402-.01 8.347-17.992 15.135-40.164 15.161-2.883.003-5.694-.108-8.404-.322l-1.244-.106a94.777 94.777 0 01-3.637-.404l-1.18-.162-1.161-.175c-14.408-2.278-24.512-7.638-24.504-13.9.01-8.347 17.992-15.135 40.165-15.161zm.004 3.58c-10.385.013-20.08 1.567-27.134 4.23-6.238 2.355-9.452 5.216-9.455 7.356-.002 2.132 3.197 4.979 9.425 7.317 7.045 2.646 16.736 4.178 27.12 4.166 10.386-.012 20.08-1.567 27.134-4.23 6.239-2.355 9.453-5.216 9.455-7.355.003-2.133-3.197-4.98-9.425-7.318-6.864-2.578-16.24-4.098-26.323-4.163l-.797-.002z",
        fill: "#0D0D0D",
        fillRule: "nonzero",
        mask: r.maskSelector,
        transform: "rotate(-150 55.901 56.515)"
      }), n.createElement("circle", {
        fill: "#FFF",
        mask: r.maskSelector,
        transform: "rotate(90 78.597 78.434)",
        cx: 78.597,
        cy: 78.434,
        r: 4.084
      }), n.createElement("circle", {
        fill: "#FFF",
        mask: r.maskSelector,
        transform: "rotate(90 63.94 25.063)",
        cx: 63.94,
        cy: 25.063,
        r: 4.084
      }), n.createElement("circle", {
        fill: "#FFF",
        mask: r.maskSelector,
        transform: "rotate(90 55.66 56.392)",
        cx: 55.66,
        cy: 56.392,
        r: 6.098
      }), n.createElement("circle", {
        fill: "#FFF",
        mask: r.maskSelector,
        transform: "rotate(90 24.443 65.007)",
        cx: 24.443,
        cy: 65.007,
        r: 4.084
      })));
    },
    "the-bottom-line": function theBottomLine(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: l,
        height: t,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("circle", {
        cx: "56",
        cy: "56",
        r: "56",
        fill: "#7082DB"
      }), n.createElement("path", {
        d: "M77.4542 76.1272C78.5568 80.0701 74.5925 82.9741 70.8089 81.3368C70.9151 85.269 66.8646 87.1649 63.6347 86.0092C64.2509 89.147 59.5688 92.1065 56.0118 89.3477C52.2435 86.4248 33.7372 68.7101 33.7372 68.7101C30.4801 65.0895 28.4342 61.0168 27.1119 56.0091L45.4931 39.4631L56.837 41.3153L62.3443 51.4169L82.7442 70.2873C85.0203 72.6636 81.5436 77.6619 77.4542 76.1272Z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M44.7635 35.5369L21.293 56.1544L9.64447 43.3766L33.4161 23.6445L44.7635 35.5369Z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M59.9642 37.9038L85.3567 59.3736L78.7114 66.5605L62.3407 51.4159L52.5929 60.2035L45.4895 53.6812L59.9642 37.9038Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M75.3256 34.9243L93.6407 50.4102L87.7592 56.7731L69.4052 41.2565L75.3256 34.9243Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M102.356 40.9838L96.0455 47.8106L77.7434 32.3377L84.2022 25.4294L102.356 40.9838Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M58.7271 83.1692L50.586 91.866L30.9239 74.0782L39.549 65.4263L58.7271 83.1692Z",
        fill: "white"
      }));
    },
    "the-climate-issue": function theClimateIssue(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_tci");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F6423C",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M56.052 112C86.952 112 112 86.928 112 56S86.951 0 56.052 0C25.377 0 .472 24.71.112 55.327v1.346C.472 87.291 25.377 112 56.052 112",
        fill: "#E3120B",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M99.444 22.4a46.15 46.15 0 00-2.154-4.377C87.067 6.942 72.432 0 56.175 0 25.274 0 .224 25.072.224 56s25.05 56 55.951 56c6.275 0 12.31-1.034 17.941-2.941 18.126-14.787 38.4-56.204 25.328-86.659",
        fill: "#F6423C",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M87.965 74.169C98.26 33.455 77.615 9.765 63.795.523A56.31 56.31 0 0056.15 0C25.263 0 .224 25.072.224 56s25.039 56 55.926 56c2.967 0 5.88-.233 8.723-.68 9.008-7.407 19.496-22.929 23.092-37.151",
        fill: "#FA9851",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M72.283 24.39C68.653 11.78 61.585 4.314 55.417 0 24.87.384.224 25.31.224 56.007c0 30.406 24.18 55.153 54.324 55.993.684-1.162 28.781-49.245 17.735-87.61",
        fill: "#FAD051",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M57.59 38.345C56.082 21.958 50.251 5.2 45.566 1.008 19.744 5.946.224 28.696.224 56.018c0 29.145 22.207 53.086 50.584 55.758.758-3.601 9.36-45.361 6.781-73.431",
        fill: "#EBEDFA",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M37.095 3.248C15.467 11.018 0 31.69 0 55.975c0 25.776 17.424 47.482 41.145 54.009.965-13.683 5.82-89.64-4.05-106.736",
        fill: "#475ED1",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M0 55.944c0 21.759 12.412 40.62 30.545 49.896V6.048C12.412 15.324 0 34.185 0 55.944",
        fill: "#2E45B8",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M0 55.989c0 16.077 6.803 30.57 17.693 40.779l.097-81.648C6.843 25.334 0 39.864 0 55.989",
        fill: "#1F2E7A",
        mask: r.maskSelector
      })));
    },
    "the-economist-this-week": function theEconomistThisWeek(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_tetw_a"),
          c = Ln("nl_tetw_b"),
          s = Ln("nl_tetw_c");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("path", {
        d: "M34.406 46.592v7.603h3.265v2.156c0 6.685-5.482 12.104-12.247 12.104V92.96h61.824V68.455c-6.763 0-12.245-5.419-12.245-12.104v-2.156h3.265v-7.603H34.406z",
        id: c.defId
      }), n.createElement("path", {
        d: "M52.239 56.224l-6.095-.056.113.961c2.904.056 3.646.846 3.646 3.78v18.292c0 2.934-.742 3.726-3.646 3.782V84l6.493-.06 9.625.06 3.017-.06.912-6.49-1.594-.057c-.4 3.728-1.71 4.687-6.093 4.687-3.361 0-3.532-.114-3.532-3.444V70.45l1.483-.056 2.162.056c2.963.057 3.587.564 3.758 3.389h1.253c-.057-1.752-.057-3.05-.057-4.007 0-1.19 0-2.374.114-4.687h-1.366c0 2.878-.739 3.555-3.815 3.555-.63 0-1.196 0-1.823-.058-.342 0-.968-.056-1.709-.056V58.03l.4-.055h.852c5.583 0 6.265.395 6.552 3.949l1.594-.112-.174-5.644-2.503-.056-9.567.112z",
        id: s.defId
      }), n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56.056,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#F6423C",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M101.696-15.232S100.541-7.435 91.063 7.8C82.906 20.91 72.2 27.336 72.2 27.336s1.733.403 9.241-3.711C70.727 38.463 58.515 42.752 56.336 43.568a100.326 100.326 0 012.239-4.317c1.32-2.488 2.777-4.902 4.23-7.31 1.505-2.378 2.982-4.77 4.595-7.08l1.176-1.751 1.22-1.722c.828-1.14 1.6-2.317 2.474-3.424l2.516-3.395c.837-1.133 1.754-2.207 2.611-3.327 1.685-2.264 3.556-4.382 5.315-6.596.87-1.116 1.83-2.156 2.74-3.24L88.2-1.838c1.858-2.143 5.157-5.649 6.968-7.86 1.207-1.473 2.943-3.14 5.205-4.998l1.324-.536z",
        fillOpacity: .6,
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M101.696-15.232S88.678-6.814 82.376-.601c-19.319 19.048-26.158 41.6-26.038 44.169 10.92-13.25 43.678-54.66 45.358-58.8z",
        fill: "#FFF",
        opacity: .4,
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M101.656-15.232C96.849-11.692 89.715-4.409 87.61-2.488c-2.023 1.999-4.116 3.944-6.042 6.045a140.584 140.584 0 00-10.95 13.134c-.866 1.134-1.63 2.34-2.45 3.507-.808 1.175-1.623 2.345-2.354 3.571-1.514 2.418-2.965 4.876-4.283 7.404-1.32 2.526-2.55 5.1-3.618 7.74-.595 1.489-1.066 3.13-1.556 4.655-.522-1.91-1.856-10.386 8.41-29.172 8.668-15.864 24.83-29.391 36.929-29.628h-.04z",
        fillOpacity: .95,
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("use", {
        fill: "#0D0D0D",
        xlinkHref: c.defSelector
      }), n.createElement("use", {
        fill: "#FFF",
        xlinkHref: s.defSelector
      })));
    },
    "the-economist-today": function theEconomistToday(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_tet");
      return n.createElement("svg", i({
        width: t,
        height: l,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 55.95,
        cy: 56,
        r: 55.944
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#2E45B8",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M55.907 23.329c18.322 0 33.175 15.003 33.175 33.51 0 18.508-14.853 33.51-33.175 33.51-18.322 0-33.175-15.002-33.175-33.51 0-18.507 14.853-33.51 33.175-33.51z",
        fill: "#2F44B8",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M35.757 83.077c-7.92-6.094-13.025-15.684-13.025-26.47 0-4.191.768-8.213 2.175-11.908L55.85 56.822 35.757 82.976",
        fill: "#CED3F3",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M76.103 83.46c-5.588 4.322-12.716 6.89-20.293 6.89-7.597 0-14.832-2.547-20.427-6.89l20.448-26.565L76.103 83.46z",
        fill: "#ADB6EB",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M55.851 56.895V23.217c14.296 0 26.563 9.42 31.193 22.336L55.85 56.895z",
        fill: "#6D7BDA",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M87.246 45.37L55.851 56.949 76.02 83.413c7.97-6.085 13.175-15.672 13.175-26.465 0-4.008-.648-7.85-1.948-11.409v-.168z",
        fill: "#8D98E2",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M55.851 57.455l-.003-34.014c-14.167 0-26.218 9.02-30.99 21.615 7.086 2.762 17.417 6.895 30.993 12.399z",
        fill: "#EBEDFA",
        mask: r.maskSelector
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M46.005 21.538h19.692v-6.377H46.005z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        transform: "rotate(45 60.852 56.473)",
        d: "M57.459 45.968l6.635.048.152 20.962-6.636-.048z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        transform: "rotate(135 50.795 56.473)",
        d: "M47.553 46.016l6.635-.048-.151 20.962-6.636.048z"
      }), n.createElement("path", {
        d: "M55.963 87.582c-16.756 0-30.308-13.696-30.308-30.631 0-16.935 13.552-30.632 30.308-30.632s30.308 13.697 30.308 30.632c0 16.935-13.552 30.631-30.308 30.631m34.786-56.526l-4.591-4.596-4.248 4.343a36.857 36.857 0 00-5.835-4.835c-5.801-3.862-12.7-6.108-20.112-6.108-20.266 0-36.7 16.609-36.7 37.091s16.393 37.091 36.7 37.091c20.307 0 36.7-16.609 36.7-37.091 0-7.85-2.444-15.129-6.576-21.13l4.662-4.765z",
        fill: "#FFF",
        mask: r.maskSelector
      })));
    },
    "the-extraordinary-story": function theExtraordinaryStory(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("nl_tes");
      return n.createElement("svg", i({
        width: l,
        height: t,
        viewBox: "0 0 112 112",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("path", {
        d: "M56 0C25.072 0 0 25.072 0 56s25.072 56 56 56 56-25.072 56-56S86.928 0 56 0z",
        id: r.defId
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("path", {
        d: "M56 0c30.928 0 56 25.072 56 56s-25.072 56-56 56S0 86.928 0 56 25.072 0 56 0z",
        fill: "#F9C31F"
      }), n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("path", {
        d: "M76.52 46.61a2.597 2.597 0 115.192-.09 2.597 2.597 0 01-5.192.09zM34.123 93.417c0-2.226.503-2.713 1.789-3.148 1.215-.411 2.858-.911 3.9-1.237 1.468-.458 2.683-1.006 2.722-3.246a8835.247 8835.247 0 00-.088-14.973c-.045-1.887.697-2.061 1.776-2.078l2.509-.03c1.11-.06 1.52-.733 1.299-1.701-1.019-4.464-5.93-32.545-6.746-37.649 6.444-6.508 12.593-21.425 13.48-23.804.006-.016.151-.417.209-.592a.72.72 0 01-.198-.496c0-.399.27-.747.744-.762.321-.009.637.08.945.512.198-.263.542-.492.935-.472.398.02.721.323.721.722a.72.72 0 01-.197.496c.058.175.173.503.18.519.886 2.38 7.064 17.37 13.508 23.877-.815 5.104-5.727 33.185-6.745 37.649-.221.968.189 1.64 1.299 1.7l2.508.031c1.08.017 1.822.191 1.777 2.078-.004.371-.034 4.931-.088 14.973.039 2.24 1.253 2.788 2.721 3.246 1.042.326 2.685.826 3.9 1.237 1.286.435 1.79.922 1.79 3.148l-.033 22.927H34.155l-.032-22.927zm2.252-46.807a2.596 2.596 0 11-5.19-.09 2.596 2.596 0 015.19.09z",
        fill: "#1A1A1A",
        mask: r.maskSelector
      })));
    },
    "the-world-in-brief": function theWorldInBrief(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        width: l,
        height: t,
        viewBox: "0 0 360 360",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, a), n.createElement("circle", {
        cx: "180",
        cy: "180",
        r: "180",
        fill: "#F6423C"
      }), n.createElement("path", {
        d: "M140.234 291.787c-6.392-8.964-11.709-20.01-15.801-32.354H96.859c11.372 14.336 26.321 25.487 43.375 32.354Zm79.393 0c17.059-6.867 32.017-18.018 43.397-32.354h-27.581c-4.108 12.344-9.425 23.39-15.816 32.354Zm-1.581-32.354h-76.272c9.694 25.275 24.492 39.934 38.152 39.934s28.458-14.659 38.16-39.934h-.04ZM74.564 203.111a103.094 103.094 0 0 0 11.575 39.958h33.664a215.064 215.064 0 0 1-5.207-39.958H74.564Zm56.521 0a192.077 192.077 0 0 0 5.53 39.958h86.614a192.7 192.7 0 0 0 5.531-39.958h-97.675Zm142.55 39.958a103.086 103.086 0 0 0 11.574-39.958h-39.993a213.62 213.62 0 0 1-5.206 39.958h33.625ZM188.222 74.141a122.509 122.509 0 0 1 41.636 10.248l7.505-13.416-3.444-1.854a1.828 1.828 0 0 1-.846-1.062 1.806 1.806 0 0 1 .127-1.347l6.17-11.233a1.84 1.84 0 0 1 1.07-.834 1.858 1.858 0 0 1 1.356.122l21.41 11.436c.41.231.714.61.848 1.058.134.448.088.93-.129 1.344l-6.178 11.257a1.855 1.855 0 0 1-1.046.808 1.873 1.873 0 0 1-1.324-.089l-3.492-1.807-7.427 13.298c22.666 13.944 40.097 34.853 49.628 59.531a119.806 119.806 0 0 1 3.15 77.128c-7.487 25.36-23.157 47.594-44.612 63.303-21.455 15.71-47.516 24.03-74.199 23.69-26.682-.341-52.518-9.324-73.557-25.576-21.04-16.252-36.124-38.879-42.949-64.421a119.82 119.82 0 0 1 5.157-77.022c10.17-24.427 28.14-44.884 51.162-58.244l-6.525-11.679-3.492 1.807c-.416.19-.887.222-1.325.09a1.855 1.855 0 0 1-1.046-.81l-6.178-11.256a1.791 1.791 0 0 1-.129-1.344 1.81 1.81 0 0 1 .848-1.058l21.411-11.436c.419-.211.904-.255 1.355-.122.452.132.834.43 1.07.833l6.17 11.234c.216.416.261.898.127 1.347a1.826 1.826 0 0 1-.845 1.062l-3.445 1.854 6.684 12.164a122.357 122.357 0 0 1 38.713-9.004V57.91h-5.768a1.85 1.85 0 0 1-1.25-.535 1.814 1.814 0 0 1-.535-1.24v-19.04a1.81 1.81 0 0 1 .548-1.215 1.852 1.852 0 0 1 1.237-.522h27.747a1.85 1.85 0 0 1 1.255.533c.334.33.526.776.538 1.243v19.04c-.014.466-.207.91-.54 1.24a1.86 1.86 0 0 1-1.253.536h-5.388V74.14Zm-68.443 72.851H85.933a103.196 103.196 0 0 0-11.353 39.817h40.048c.454-13.4 2.166-26.73 5.112-39.817h.039Zm16.773 0a192.982 192.982 0 0 0-5.396 39.817h97.588a193.06 193.06 0 0 0-5.404-39.817h-86.788Zm103.608 0a215.038 215.038 0 0 1 5.112 39.817h40.048a103.214 103.214 0 0 0-11.361-39.817H240.16Zm-20.494-49.156c6.471 9.082 11.851 20.291 15.975 32.854h27.786c-11.428-14.575-26.536-25.907-43.8-32.854h.039Zm-1.367 32.854c-9.694-25.564-24.571-40.395-38.333-40.395-13.763 0-28.64 14.863-38.334 40.395h76.667Zm-94.017 0c4.132-12.516 9.481-23.741 15.975-32.854-17.25 6.953-32.344 18.285-43.76 32.854h27.785Z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M188.535 178.102a18.976 18.976 0 0 1 8.823 8.913 18.713 18.713 0 0 1 1.282 12.415 18.867 18.867 0 0 1-6.818 10.497 19.2 19.2 0 0 1-11.943 3.994 19.187 19.187 0 0 1-11.85-4.254 18.856 18.856 0 0 1-6.583-10.643 18.716 18.716 0 0 1 1.558-12.384 18.987 18.987 0 0 1 9.02-8.718v-75.834c.012-.466.204-.909.537-1.239.332-.329.78-.519 1.251-.531h12.935c.47.012.918.202 1.251.531.332.33.525.773.537 1.239v76.014Z",
        fill: "#fff"
      }));
    },
    blighty: function blighty(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]);
      return n.createElement("svg", i({
        xmlns: "http://www.w3.org/2000/svg",
        width: l,
        height: t,
        viewBox: "0 0 112 112",
        fill: "none"
      }, a), n.createElement("circle", {
        cx: "56",
        cy: "56",
        r: "56",
        fill: "#2E45B8"
      }), n.createElement("mask", {
        id: "mask0_2576_1386",
        style: {
          "mask-type": "alpha"
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "112",
        height: "112"
      }, n.createElement("circle", {
        cx: "56",
        cy: "56",
        r: "56",
        fill: "white"
      })), n.createElement("g", {
        mask: "url(#mask0_2576_1386)"
      }, n.createElement("path", {
        d: "M38 68.7212C38 62.7661 47.402 60 54.3962 60H57.6497C66.4727 60 74 62.7358 74 68.3206L56.0014 76L38.0029 69.2187",
        fill: "#F6423C"
      }), n.createElement("path", {
        d: "M56.4129 68C57.2118 68 58 68.4907 58 69.5195C58 70.2472 57.4477 71 56.5389 71C55.63 71 55 70.5093 55 69.6032C55 68.697 55.5416 68 56.4102 68H56.4129Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M56.4129 62C57.2118 62 58 62.4907 58 63.5195C58 64.2472 57.4477 65 56.5389 65C55.63 65 55 64.5093 55 63.6032C55 62.697 55.5416 62 56.4102 62H56.4129Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M65 48C65 53.2174 63.7016 60 56.9118 60H55.5288C48.9345 60 47 54.0015 47 48H65Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M47.4651 47.9972C45.2824 47.1641 43.6225 45.1988 43.4723 41.6428C43.3222 38.0867 42.1933 25.3751 44.0757 20.7595C45.9581 16.1439 48.7413 11 55.5896 11C62.4379 11 67.4038 15.691 68.5326 23.7872C69.6615 31.8833 68.4576 43.0825 67.9293 44.6704C67.401 46.2583 66.35 47.3934 64.6178 48H47.4651V47.9972Z",
        fill: "#0D0D0D"
      }), n.createElement("path", {
        d: "M34 65L56.088 73.8313L78 65V91.9792L55.8837 102L34 91.7239V65Z",
        fill: "white"
      }), n.createElement("path", {
        d: "M74 78V82.2358L68 85V80.7791L74 78Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M74 71V75.3142L68 78V73.7473L74 71Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M66 75V86.0852L59 89V77.7664L66 75Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M38 71L53 77.212V81L38 74.8498V71Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M53 84.9519V89L38 82.045V78L53 84.9519Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M53 92.1301V96L38 88.7607V85L53 92.1301Z",
        fill: "#999999"
      }), n.createElement("path", {
        d: "M59 92.2562V96L74 89.4208V86L59 92.2562Z",
        fill: "#999999"
      })));
    }
  },
      zn = (Object.keys(Tn).filter(function (e) {
    return "__filemeta" !== e;
  }), function (e) {
    var t = e.className,
        l = e.height,
        a = e.ident,
        r = e.width,
        i = Tn[a];
    return n.createElement("span", {
      className: B("ds-ident-newsletters", "ds-ident-newsletters--".concat(a), t)
    }, n.createElement(i, {
      width: r,
      height: l,
      className: "ds-ident-newsletters__svg"
    }));
  });

  zn.propTypes = {
    className: l.string,
    height: l.number,
    width: l.number,
    ident: l.oneOf(["checks-and-balance", "cover-story", "plot-twist", "drum-tower", "espresso", "money-talks", "off-the-charts", "simply-science", "the-bottom-line", "the-climate-issue", "the-economist-this-week", "the-economist-today", "the-extraordinary-story", "the-world-in-brief", "blighty"]).isRequired
  }, zn.defaultProps = {
    className: "",
    height: 112,
    width: 112
  };
  var jn = {
    babbage: function babbage(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_babbage");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#00A6E4",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M47.475 28.86a2.445 2.445 0 012.443-2.447 2.445 2.445 0 012.444 2.447 2.445 2.445 0 01-2.444 2.447 2.445 2.445 0 01-2.443-2.447m4.109-6.449c0-2.264 1.833-4.1 4.094-4.1a4.096 4.096 0 014.093 4.1c0 2.264-1.832 4.1-4.093 4.1a4.096 4.096 0 01-4.094-4.1m-6.63.746a1.466 1.466 0 112.931-.002 1.466 1.466 0 01-2.931.002m11.526-9.914a1.37 1.37 0 112.742-.002 1.37 1.37 0 01-2.741.002",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        d: "M52.703 32.371l-8.454.082-.08 29.235h-2.41v-2.784h-8.008v8.019h2.73v2.929l2.924.004-.001 5.094h2.759v5.027h2.563v5.077H47.4v8.13h25.43V85.25h2.807l.08-7.561h2.74V59.447h-2.675l.003-3.041h-2.603v-2.743l-5.366-.004v-2.228l-7.474-.003v-2.782l-5.061-.007.08-16.271z"
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M42.272 74.853h2.76v5.077h2.562v4.853h2.674v5.529h19.695v-5.204h2.809l.08-7.582h2.737v-17.94h-2.674l.002-3.051-2.37-.003v5.885h-2.87v-8.114L62.97 54.3v6.15H60.1v-8.932l-4.82-.007v6.69h-2.868v-9.562l.081-16.271-5.377.003-.04 37.26H44.21l-.04-4.912h-2.563v-2.943H36.62v5.044l2.986.004v2.897h2.668z"
      }), n.createElement("path", {
        fill: "#29241C",
        mask: r.maskSelector,
        d: "M43.27 32.732h12.935v-2.813H43.27z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        d: "M43.281 32.72h12.912v-2.79H43.281zm3.373 4.629h2.933v-1.325h-2.933z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 37.345h2.925v-1.317h-2.925z"
      }), n.createElement("path", {
        fill: "#29241C",
        mask: r.maskSelector,
        d: "M46.654 41.094V39.77h2.933v1.324z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 41.09h0v-1.317h2.925v1.318z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        d: "M46.654 44.84v-1.325h2.933v1.325z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 44.837h0v-1.318h2.925v1.318z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        d: "M46.654 48.586V47.26h2.933v1.325z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 48.582h0v-1.317h2.925v1.317z"
      }), n.createElement("path", {
        fill: "#0D0D0D",
        mask: r.maskSelector,
        d: "M46.654 52.331v-1.325h2.933v1.325z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 52.327h0V51.01h2.925v1.317z"
      }), n.createElement("path", {
        fill: "#29241C",
        mask: r.maskSelector,
        d: "M46.654 56.077h2.933v-1.325h-2.933z"
      }), n.createElement("path", {
        stroke: "#29241C",
        strokeWidth: .5,
        mask: r.maskSelector,
        d: "M46.658 56.073h2.925v-1.317h-2.925z"
      })));
    },
    "checks-and-balance": function checksAndBalance(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_cab");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("circle", {
        id: r.defId,
        cx: 56,
        cy: 56,
        r: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#D9D9D9",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        fill: "#E3120B",
        mask: r.maskSelector,
        d: "M84.729 3.696L37.356 88.579l5.752 1.111L91.102 3.696zm12.742 0L49.198 90.055l6.422-.068 48.235-86.291zm12.767 0L61.95 90.138l6.113.463 48.545-86.905z"
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M116.605 3.696L73.06 81.621l3.19 5.71 46.735-83.635z"
      }), n.createElement("path", {
        fill: "#E3120B",
        mask: r.maskSelector,
        d: "M122.979 3.696L74.34 90.743l5.082 2.329 49.94-89.376z"
      }), n.createElement("path", {
        fill: "#2E3C85",
        mask: r.maskSelector,
        d: "M9.845 48.253l24.95 44.819h44.647l-24.95-44.819z"
      }), n.createElement("path", {
        fill: "#FFF",
        mask: r.maskSelector,
        d: "M20.618 52.341l3.47 3.967h4.074l-1.929 2.451 3.47 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.662-2.451h4.074zm13.664 0l3.47 3.967h4.075l-1.93 2.451 3.47 3.967-4.662-2.452-1.929 2.452-.952-3.967-4.663-2.451h4.074zm13.665 0l3.47 3.967h4.074l-1.929 2.451 3.47 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.663-2.451H48.9zM27.906 65.459l3.47 3.966h4.074l-1.929 2.452 3.47 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.663-2.452h4.074zm14.028 0l3.47 3.966h4.074l-1.929 2.452 3.47 3.967-4.662-2.452-1.929 2.452-.952-3.967-4.663-2.452h4.074zm13.483 0l3.47 3.966h4.074l-1.93 2.452 3.471 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.663-2.452h4.074zm-20.041 13.3l3.47 3.966h4.074l-1.93 2.452 3.471 3.967-4.663-2.452-1.929 2.452-.952-3.967-4.663-2.452h4.074zm13.664 0l3.47 3.966h4.074l-1.93 2.452 3.471 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.662-2.452h4.073zm13.482 0l3.47 3.966h4.074l-1.929 2.452 3.47 3.967-4.662-2.452-1.93 2.452-.952-3.967-4.662-2.452h4.074zM91.096 3.696L60.312 58.832l3.19 5.716L97.48 3.696zm12.754 0L66.688 70.139l3.191 5.705 40.353-72.148z"
      })));
    },
    "editors-picks": function editorsPicks(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_ep");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#B9CF33",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        fill: "#121212",
        mask: r.maskSelector,
        d: "M23.5 80.992h3.459V62.758h-3.46zm6.841 8.113h3.46v-34.46h-3.46zm6.841-3.632h3.46V58.276h-3.46zm6.842 7.263h3.46V51.014h-3.46zm6.841-7.263h3.46V58.276h-3.46zm6.919-4.481h3.459V62.758h-3.46zm6.841-4.25h3.46v-9.735h-3.46zm6.842 8.731h3.459V58.276h-3.46zm9.666-43.422l3.402.45-4.593 35.014-3.402-.45zm4.017 38.941h3.459V62.758h-3.46zm6.841-4.25h3.46v-9.735h-3.46zm-75.333 0h3.46v-9.735h-3.46z"
      }), n.createElement("path", {
        d: "M72.325 33.166c-5.202 2.285-7.727 8.051-7.62 14.15.016.996.008 3.976 0 4.547 3.315.046 6.991-2.988 6.991-6.546 0-2.81 1.68-4.702 3.614-5.582",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M73.081 34.366c-.438.387-6.104 5.922-6.572 6.37-2.291 2.192-6.727 1.634-9.11-.549 0 0 8.226-8.097 11.093-10.962",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M78.678 33.706c-.585-.038-12.873-.154-13.52-.177-3.165-.085-5.913-3.62-6.067-6.854 0 0 19.549.132 23.599.147",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M100.656 12.768c-4.566 4.531-11.139 11.023-12.684 12.577-1.168 1.175-3.65 1.469-5.311 1.469-3.067 0-6.226.449-9.493 3.735-6.387 6.426-4.143 14.723 1.691 20.167.73.68 3.075 2.83 3.482 3.24 2.337-2.374 2.383-7.122-.061-9.705-2.89-3.046-2.091-7.029.223-9.07 2.582-2.281 6.118-2.073 8.363 0 2.452 2.258 3.02 6.07.392 9.07-.385.441-1.884 1.918-2.33 2.39-2.182 2.304-1.644 6.758.523 9.163 0 0 5.388-5.583 8.248-8.46 2.252-2.265 2.629-4.384 2.629-7.09 0-2.63.884-4.594 2.336-6.055 1.807-1.817 4.881-4.887 11.161-11.22l-9.17-10.211z",
        fill: "#FFF",
        mask: r.maskSelector
      })));
    },
    "money-talks": function moneyTalks(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_mt_a"),
          c = Ln("pod_mt_b"),
          s = Ln("pod_mt_c");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("path", {
        id: r.defId,
        d: "M32.364 18.074h46.12v35.342h-46.12z"
      }), n.createElement("path", {
        id: c.defId,
        d: "M32.375 36.638h44.526v57.74H32.375z"
      }), n.createElement("ellipse", {
        id: s.defId,
        cx: 56,
        cy: 56.169,
        rx: 56,
        ry: 56.112
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("use", {
        fill: "#8D4393",
        xlinkHref: s.defSelector
      }), n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("path", {
        d: "M77.064 26.725s1.64-1.63 1.395-4.957c-.066-.913-.261-1.63-.498-2.192-.53-1.24-1.957-1.818-3.212-1.33L34.593 33.85c-3.074 1.19-2.87 4.222 0 5.331L70.02 53.015c3.913 1.353 7.476-.905 6.759-3.994-.049-.204-.106-.416-.163-.628a4.51 4.51 0 00-1.093-1.916c-5.071-5.209-21.362-9.212-37.774-10.116 11.675-3.693 34.301-3.905 39.315-9.636",
        fill: "#010202",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M74.724 35.7a1.078 1.078 0 001.011-1.068l.343-6.978c-1.655 1.223-4.232 2.169-7.322 2.943-.09.025-.18.049-.277.065-.082.017-.155.041-.237.057-.122.033-.252.057-.375.09a.24.24 0 01-.081.016c-.171.041-.35.082-.53.123-.008 0-.017 0-.025.008-7.02 1.573-16.2 2.478-23.596 3.954-.065.016-.13.024-.204.04-.114.025-.22.041-.334.065l-.375.074-.114.024c-.18.041-.35.074-.53.114-.008 0-.024.009-.033.009-.758.163-1.492.342-2.201.521l34.88-.057zM70.2 38.594l-18.118-.668c7.722 1.296 14.579 3.236 19.16 5.576v-3.71a1.192 1.192 0 00-1.043-1.198",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("mask", {
        id: c.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: c.defSelector
      })), n.createElement("path", {
        d: "M75.776 77.504c-.497.277-1.32.334-1.908.09l-4.02-1.582a5.972 5.972 0 01-3.823-5.576v-1.997c0-2.748 2.755-4.639 5.324-3.644l2.527 1.002c1.452.571 3.025-.497 3.025-2.054V50.945c0-.245-.016-.481-.04-.726-.327 2.43-3.45 3.962-6.825 2.788L34.601 39.181c-1.394-.538-2.152-1.524-2.226-2.543l.106 36.561a7.448 7.448 0 004.762 6.946l36.169 14.054c1.777.53 3.473-.114 3.473-2.013V78.262c.008-.612-.603-1.035-1.109-.758",
        fill: "#FFF",
        mask: c.maskSelector
      }), n.createElement("path", {
        d: "M71.014 67.852c-1.614-.392-2.927.603-2.927 2.217s1.313 3.245 2.927 3.636c1.615.391 2.928-.603 2.928-2.217s-1.313-3.245-2.928-3.636",
        fill: "#FFF",
        mask: c.maskSelector
      })));
    },
    "the-economist-asks": function theEconomistAsks(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_tea_a"),
          c = Ln("pod_tea_b");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      }), n.createElement("path", {
        id: c.defId,
        d: "M31.338 18.016h49.459V71.06h-49.46z"
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#E3120B",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        d: "M72.792 76.494c0-1.2-.965-2.172-2.156-2.172-.27 0-.527.056-.765.147l-.003-.003-2.581.913c.454.49.87.993 1.234 1.514.092.501.359.936.73 1.252.323.692.531 1.418.563 2.194l2.307-2.273-.001-.002a2.17 2.17 0 00.672-1.57m-8.081 9.43c0 4.485-3.608 8.12-8.06 8.12-4.45 0-8.06-3.635-8.06-8.12 0-4.485 3.61-8.12 8.06-8.12 4.452 0 8.06 3.635 8.06 8.12",
        fill: "#0D0D0D",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M66.311 74.384c-1.64-1.598-3.487-2.863-4.188-3.323h-9.658c-.273.515-1.462 2.89-1.462 5.208 0 2.034.324 3.073.47 3.436a7.989 7.989 0 015.179-1.902c4.45 0 8.06 3.636 8.06 8.12 0 .411-.04.811-.099 1.205a28.01 28.01 0 001.135-.882c.676-2.771-.493-4.972-1.778-6.782l.405-.292c1.256 1.77 2.406 3.9 1.986 6.558a24.38 24.38 0 001.09-.995c.06-2.85-1.397-5.224-2.134-6.238l.4-.296c.729 1 2.12 3.269 2.224 6.041.236-.248.458-.501.667-.756.01-1.986-.664-3.927-2.064-5.877l.403-.294c1.315 1.832 2.025 3.659 2.15 5.523.344-.508.589-1.006.658-1.46.429-2.798-1.37-4.975-3.444-6.994",
        fill: "#FFF",
        mask: r.maskSelector
      }), n.createElement("mask", {
        id: c.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: c.defSelector
      })), n.createElement("path", {
        d: "M49.234 71.061c0-19.173 15.768-20.635 15.768-30.743 0-4.846-4.243-7.352-7.884-7.352-3.642 0-8.99 1.504-8.99 11.487h-16.79c0-13.102 8.35-26.437 25.25-26.437 18.28 0 24.21 12.276 24.21 21.34 0 17.336-16.004 20.678-16.004 29.659v2.046h-15.56z",
        fill: "#000",
        mask: c.maskSelector
      })));
    },
    "the-intelligence": function theIntelligence(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_ti_a"),
          c = Ln("pod_ti_b");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      }), n.createElement("path", {
        id: c.defId,
        d: "M26.54 18.144h58.902v75.04H26.54z"
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("use", {
        fill: "#8D9DD0",
        xlinkHref: r.defSelector
      }), n.createElement("mask", {
        id: c.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: c.defId
      })), n.createElement("path", {
        d: "M59.89 18.153v7.608h2.246v3.66H56.19v-3.66h2.246v-7.617c-14.247 0-24.342 8.768-25.908 21.893-.68 5.648-5.988 22.294-5.988 22.294l5.83 2.005-.069 10.467a5.311 5.311 0 005.309 5.317h6.736v13.064h8.85l.096-13.169c0-3.225-1.331-7.827-6.205-13.003l-5.352-5.247c-4.369-4.28-6.806-6.833-6.806-6.833.984-1.011 2.202-1.752 3.525-1.978-2.863-3.949-4.43-6.24-4.43-6.24 1.489-1.09 3.281-1.674 5.048-1.212-.888-4.28-1.323-6.711-1.323-6.711 1.75-.375 3.586-.192 4.987.871V34.93s6.527.523 6.527 6.127v9.56c0 2.973.6 6.006 2.855 8.263 3.733 3.739 9.799 3.739 13.532 0a9.54 9.54 0 002.794-6.911c.06-.54.096-1.125.096-1.804 0-4.942 5.709-4.829 5.709-4.829l-.035 8.393c0 7.182-8.877 8.907-8.877 22.46 0 1.821.044 10.336.061 16.986h8.285V75.5c0-4.523 1.671-8.872 4.613-12.306 4.29-5.011 7.145-11.635 7.145-18.564 0-14.328-11.366-25.998-25.552-26.477",
        fill: "#0D0D0D",
        mask: c.maskSelector
      }), n.createElement("path", {
        d: "M62.136 29.404H56.19c0 3.757-5.3 7.138-5.3 12.524v.837c0 4.576 3.708 8.289 8.277 8.289 4.569 0 8.276-3.713 8.276-8.289 0-6.188-5.308-9.604-5.308-13.36",
        fill: "#FFF",
        mask: c.maskSelector
      })));
    },
    "the-jab": function theJab(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_tj");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#6BD7D1",
        xlinkHref: r.defSelector
      }), n.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M-4.312 43.466h41.646v24.635H-4.312zM99.783 57.389H87.789v-1.274c0-3.964-.567-7.784-1.643-11.047l-.354-1.087 1.034-.472a19.188 19.188 0 005.098-3.435l.878-.157.85.157c4.403 4.136 6.924 9.974 6.924 16.041l-.793 1.274zm-9.488-2.547H98a19.511 19.511 0 00-5.27-12.092 21.933 21.933 0 01-3.852 2.59c.836 2.905 1.317 6.139 1.416 9.502zm-20.402 2.547H57.12v-1.274c0-6.07 2.52-11.912 6.925-16.05l.864-.372.863.372a19.187 19.187 0 005.098 3.436l1.034.473-.354 1.088c-1.076 3.264-1.643 7.087-1.643 11.053v1.274h-.014zm-10.21-2.549h7.704c.099-3.364.58-6.6 1.416-9.506a21.172 21.172 0 01-3.852-2.592 19.492 19.492 0 00-5.268 12.098z"
      }), n.createElement("path", {
        d: "M65.015 72.397l-.964-.284a21.814 21.814 0 01-6.931-15.924v-1.264l5.301 1.065 7.484-1.065v1.264c0 3.935.567 7.727 1.645 10.966l.354 1.08-1.035.469a19.216 19.216 0 00-5.103 3.409l-.75.284zM59.7 57.453a19.292 19.292 0 005.273 12.003 21.967 21.967 0 013.855-2.57c-.836-2.884-1.332-6.095-1.417-9.433l-4.153-.724-3.558.724zm33.038 14.944l-.808-.158a19.207 19.207 0 00-5.103-3.434l-1.035-.472.354-1.088c1.078-3.262 1.645-7.083 1.645-11.047v-1.273h12.147l.638 1.273c0 6.068-2.523 11.906-6.931 16.041l-.907.158zm-3.856-5.424a21.194 21.194 0 013.856 2.59 19.468 19.468 0 005.272-12.091H90.3c-.1 3.363-.582 6.597-1.418 9.501z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M90.272 57.389H67.424v-1.262c0-4.198.61-8.253 1.774-11.741l.44-1.333 1.277.581a19.025 19.025 0 007.919 1.702 19.16 19.16 0 007.919-1.702l1.277-.581.44 1.333c1.163 3.488 1.774 7.543 1.774 11.74v1.263h.028zm-20.294-2.524h17.754c-.1-2.964-.511-5.814-1.235-8.38a21.498 21.498 0 01-7.649 1.389c-2.64 0-5.208-.468-7.65-1.39-.709 2.567-1.12 5.417-1.22 8.38z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M69.638 69.26l-.44-1.332c-1.05-3.134-1.646-6.736-1.76-10.48-.014-.425-.014-.836-.014-1.261l22.848-1.262v1.262c0 4.197-.61 8.253-1.774 11.74l-.44 1.334-1.277-.582a19.025 19.025 0 00-7.919-1.701c-2.767 0-5.435.581-7.919 1.701l-1.305.582zm9.196-4.82c2.64 0 5.208.468 7.649 1.39.724-2.567 1.135-5.418 1.235-8.381l-11.013-.723-6.74.723c.099 2.963.51 5.814 1.234 8.38a21.421 21.421 0 017.635-1.39z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M78.848 77.997v-2.53c2.77 0 5.54-3.156 7.222-8.23l.439-1.336 1.272.583a21.516 21.516 0 015.766 3.866l.085.924-.085.924a21.5 21.5 0 01-14.699 5.799zm9.116-8.6c-.763 1.962-1.696 3.64-2.742 4.961a19.051 19.051 0 005.54-3.099 19.57 19.57 0 00-2.798-1.862zm-9.116 8.6a21.877 21.877 0 01-14.865-5.8l-.143-.923.143-.924a21.89 21.89 0 015.832-3.866L71.1 65.9l.443 1.336c1.701 5.074 4.503 8.23 7.304 8.23v2.53zm-12.035-6.723a19.145 19.145 0 005.603 3.098c-1.058-1.336-2.001-2.999-2.773-4.96-1 .526-1.944 1.15-2.83 1.862z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M78.974 77.997c-4.006 0-7.64-3.722-9.73-9.96l-.028-.951.715-.597c2.848-1.293 5.895-1.932 9.043-1.932 3.148 0 6.196.653 9.043 1.932l.515.753.172.796c-2.089 6.237-5.723 9.959-9.73 9.959zm-6.896-9.661c1.717 4.418 4.306 7.118 6.91 7.118 2.605 0 5.195-2.7 6.912-7.118a19.337 19.337 0 00-6.911-1.265c-2.404.015-4.722.427-6.911 1.265zM86.61 46.413l-.444-1.336c-1.704-5.075-4.511-8.23-7.318-8.23v-2.53a21.942 21.942 0 0114.893 5.8l.115.923-.115.924A21.935 21.935 0 0187.9 45.83l-1.29.583zm-1.303-8.457c1.06 1.336 2.004 2.999 2.778 4.96a20.543 20.543 0 002.821-1.862 18.798 18.798 0 00-5.6-3.098zm-14.164 8.457l-1.28-.583a21.65 21.65 0 01-5.799-3.866l.028-.924-.028-.924a21.692 21.692 0 0114.784-5.8v2.53c-2.786 0-5.572 3.156-7.264 8.23l-.44 1.337zM66.88 41.04a19.16 19.16 0 002.8 1.862c.768-1.962 1.706-3.639 2.758-4.96a19.266 19.266 0 00-5.558 3.098z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M78.848 47.757c-3.116 0-6.133-.654-8.952-1.932l-.41-.597-.27-.952c2.068-6.237 5.666-9.96 9.632-9.96 3.966 0 7.564 3.723 9.632 9.96l-.354.952-.326.597a21.497 21.497 0 01-8.952 1.932zm-6.827-3.794a18.972 18.972 0 006.841 1.265c2.366 0 4.66-.426 6.842-1.265-1.7-4.418-4.264-7.117-6.842-7.117-2.578 0-5.142 2.685-6.841 7.117z",
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        fill: "#FFF",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M77.728 35.661h2.464v41.216h-2.464z"
      }), n.createElement("path", {
        d: "M-23.87 64.155h-12.96V47.397h12.961v16.758zm-10.415-2.568h7.855V49.965h-7.855v11.622zM-5.6 48.688h2.547v14.19H-5.6z",
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M-5.6 43.466h2.547v24.305H-5.6zm10.415 5.222h2.547v14.19H4.815z"
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M4.815 48.688h2.547v14.19H4.815zm10.415 0h2.547v14.19H15.23z"
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M15.23 48.688h2.547v14.19H15.23zm10.415 0h2.547v14.19h-2.547z"
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M25.645 48.688h2.547v14.19h-2.547zm10.416 0h2.547v14.19h-2.547z"
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M36.061 48.688h2.547v14.19h-2.547z"
      }), n.createElement("path", {
        d: "M49.022 64.155H36.061V47.397h12.961v16.758zm-10.415-2.568h7.855V49.965h-7.855v11.622zm-75.438-18.121h2.547v24.635h-2.547z",
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        d: "M38.607 69.378h-65.023V42.174h65.023v27.204zm-62.477-2.569h59.916V44.743H-23.87v22.066z",
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M-26.416 36.966h2.547V74.6h-2.547z"
      }), n.createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        mask: r.maskSelector,
        d: "M-26.416 54.341h23.377v2.554h-23.377zm106.608.539H47.936v2.464h29.711z"
      })));
    },
    "the-world-ahead": function theWorldAhead(e) {
      var t = e.height,
          l = e.width,
          a = o(e, ["height", "width"]),
          r = Ln("pod_twa_a"),
          c = Ln("pod_twa_b");
      return n.createElement("svg", i({
        width: t,
        height: l,
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
      }, a), n.createElement("defs", null, n.createElement("ellipse", {
        id: r.defId,
        cx: 56,
        cy: 56,
        rx: 55.944,
        ry: 56
      }), n.createElement("path", {
        id: c.defId,
        d: "M0 0h76.112v76.14H0z"
      })), n.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, n.createElement("mask", {
        id: r.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: r.defSelector
      })), n.createElement("use", {
        fill: "#333",
        xlinkHref: r.defSelector
      }), n.createElement("g", {
        mask: r.maskSelector
      }, n.createElement("g", {
        transform: "translate(17.92 17.92)"
      }, n.createElement("mask", {
        id: c.maskId,
        fill: "#fff"
      }, n.createElement("use", {
        xlinkHref: c.defSelector
      })), n.createElement("path", {
        d: "M48.96 70.78c2.815-3.086 5.23-7.387 7.043-12.757H66.13c-4.16 5.906-10.193 10.406-17.17 12.757zM9.992 58.023h10.126c.802 2.35 1.68 4.568 2.75 6.584a32.057 32.057 0 004.294 6.25c-6.91-2.428-12.942-6.928-17.17-12.834zM27.23 5.37c-1.546 1.682-3.016 3.765-4.295 6.25-1.136 2.083-2.08 4.367-2.882 6.851H9.792a35.081 35.081 0 0117.437-13.1zm39.1 13.101H56.07c-1.68-5.17-4.027-9.536-6.843-12.757l-.334-.334c7.11 2.341 13.209 7.043 17.437 13.091zM39.904 72.32V58.023h12.273c-2.949 8.056-7.444 13.292-12.273 14.296zm-3.617-14.296v14.305c-3.76-.803-7.31-4.1-10.126-9.47-.802-1.48-1.48-3.153-2.148-4.835h12.274zM20.72 39.886h15.49v14.506H22.8c-1.202-4.434-1.947-9.336-2.08-14.506zm-3.55 0c.133 5.103.801 10.005 1.946 14.506H7.778c-2.348-4.367-3.827-9.27-4.094-14.506h13.485zm0-3.622H3.76c.268-5.102 1.68-9.938 3.894-14.238H19.06c-1.155 4.434-1.823 9.27-1.89 14.238zm19.116-14.17V36.33h-15.5c.134-5.036.802-9.87 2.014-14.238h13.486zm0-18.262v14.64H23.879c.668-1.816 1.412-3.555 2.28-5.17 2.816-5.38 6.366-8.667 10.127-9.47zm15.957 14.64H39.836V3.831c4.963 1.07 9.525 6.44 12.407 14.64zm16.1 35.92H39.837V39.886H69.28l-9.19 9.27 2.547 2.55 13.476-13.492L62.646 24.71l-2.548 2.552 8.99 9.001H39.903V22.026H72.57C66.54 9.002 53.321 0 38.032 0 17.036 0 0 17.057 0 38.07c0 7.253 2.014 14.038 5.564 19.81v.133h.067c6.71 10.875 18.715 18.128 32.392 18.128 13.676 0 25.682-7.253 32.392-18.128l.066-.133a86.751 86.751 0 001.88-3.421h-4.027v-.067h.01z",
        fill: "#FFF",
        mask: c.maskSelector
      })))));
    }
  },
      Dn = (Object.keys(jn).filter(function (e) {
    return "__filemeta" !== e;
  }), function (e) {
    var t = e.className,
        l = e.height,
        a = e.ident,
        r = e.width,
        i = jn[a];
    return n.createElement("span", {
      className: B("ds-ident-podcasts", "ds-ident-podcasts--".concat(a), t)
    }, n.createElement(i, {
      width: r,
      height: l,
      className: "ds-ident-podcasts__svg"
    }));
  });
  Dn.propTypes = {
    className: l.string,
    height: l.number,
    width: l.number,
    ident: l.oneOf(["babbage", "checks-and-balance", "editors-picks", "money-talks", "the-economist-asks", "the-intelligence", "the-jab", "the-world-ahead"]).isRequired
  }, Dn.defaultProps = {
    className: "",
    height: 112,
    width: 112
  };

  var In = "ds-indicator",
      Sn = "ds-indicator__circle",
      Cn = "ds-indicator__circle--inverse",
      On = function On(e) {
    var t = e.inverse;
    return n.createElement("svg", {
      width: "32",
      height: "32",
      className: B(In),
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("circle", {
      className: B(Sn, R({}, Cn, t)),
      fill: "transparent",
      cx: "16",
      cy: "16",
      r: "14"
    }));
  };

  On.defaultProps = {
    inverse: !1
  }, On.propTypes = {
    inverse: l.bool
  };

  var An = {
    "ds-inline-alert": "ds-inline-alert",
    "ds-inline-alert__lede": "ds-inline-alert__lede",
    "ds-inline-alert--error": "ds-inline-alert--error",
    "ds-inline-alert--success": "ds-inline-alert--success",
    "ds-inline-alert--warning": "ds-inline-alert--warning"
  },
      Fn = function Fn(e) {
    var t = e.description,
        l = e.text,
        a = e.variant,
        r = o(e, ["description", "text", "variant"]);
    return n.createElement("div", i({
      className: B(An["ds-inline-alert"], R({}, An["ds-inline-alert--".concat(a)], a))
    }, r), n.createElement("strong", {
      className: An["ds-inline-alert__lede"]
    }, l), n.createElement("span", {
      className: An["ds-inline-alert__description"]
    }, t));
  };

  Fn.defaultProps = {
    description: "",
    text: "",
    variant: null
  }, Fn.propTypes = {
    description: l.string,
    text: l.string,
    variant: l.oneOf(["error", "success", "warning"])
  };

  var _n = "ds-link-with-arrow-icon",
      Un = "ds-link-with-arrow-icon--heavy",
      Pn = "ds-link-with-arrow-icon--inverse",
      Vn = "ds-link-with-arrow-icon--minor",
      Rn = function Rn(e) {
    var t,
        l = e.text,
        a = e.href,
        r = e.minor,
        c = e.heavy,
        s = e.inverse,
        d = o(e, ["text", "href", "minor", "heavy", "inverse"]);
    return n.createElement("a", i({
      className: B(_n, (t = {}, R(t, Vn, r), R(t, Un, c), R(t, Pn, s), t)),
      href: a
    }, d), n.createElement("svg", {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      className: "path-background",
      d: "M12 1c6.075 0 11 4.925 11 11s-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1zm.142 4.5l-1.008 1.062c3.33 3.276 4.194 4.14 4.608 4.5-1.602-.018-3.168-.018-10.242-.018v1.584c7.074 0 8.73 0 10.242-.018-.432.36-1.314 1.206-4.608 4.536l1.008 1.044 6.354-6.354L12.142 5.5z",
      fill: "#2E45B8",
      fillRule: "nonzero"
    }))), n.createElement("span", null, l));
  };

  Rn.defaultProps = {
    text: "",
    minor: !1,
    heavy: !1,
    inverse: !1,
    href: ""
  }, Rn.propTypes = {
    text: l.string,
    href: l.string,
    minor: l.bool,
    heavy: l.bool,
    inverse: l.bool
  };

  var Bn = function Bn(e) {
    var t = typeof e;
    return null != e && ("object" == t || "function" == t);
  },
      Hn = "object" == typeof a && a && a.Object === Object && a,
      Yn = "object" == typeof self && self && self.Object === Object && self,
      Qn = Hn || Yn || Function("return this")(),
      Zn = function Zn() {
    return Qn.Date.now();
  },
      qn = /\s/;

  var Gn = function Gn(e) {
    for (var t = e.length; t-- && qn.test(e.charAt(t));) {
      ;
    }

    return t;
  },
      Wn = /^\s+/;

  var Xn = function Xn(e) {
    return e ? e.slice(0, Gn(e) + 1).replace(Wn, "") : e;
  },
      Kn = Qn.Symbol,
      Jn = Object.prototype,
      $n = Jn.hasOwnProperty,
      ea = Jn.toString,
      ta = Kn ? Kn.toStringTag : void 0;

  var la = function la(e) {
    var t = $n.call(e, ta),
        l = e[ta];

    try {
      e[ta] = void 0;
      var n = !0;
    } catch (e) {}

    var a = ea.call(e);
    return n && (t ? e[ta] = l : delete e[ta]), a;
  },
      na = Object.prototype.toString;

  var aa = function aa(e) {
    return na.call(e);
  },
      ra = Kn ? Kn.toStringTag : void 0;

  var ia = function ia(e) {
    return null == e ? void 0 === e ? "[object Undefined]" : "[object Null]" : ra && ra in Object(e) ? la(e) : aa(e);
  };

  var ca = function ca(e) {
    return null != e && "object" == typeof e;
  };

  var oa = function oa(e) {
    return "symbol" == typeof e || ca(e) && "[object Symbol]" == ia(e);
  },
      sa = /^[-+]0x[0-9a-f]+$/i,
      da = /^0b[01]+$/i,
      ma = /^0o[0-7]+$/i,
      ua = parseInt;

  var ha = function ha(e) {
    if ("number" == typeof e) return e;
    if (oa(e)) return NaN;

    if (Bn(e)) {
      var t = "function" == typeof e.valueOf ? e.valueOf() : e;
      e = Bn(t) ? t + "" : t;
    }

    if ("string" != typeof e) return 0 === e ? e : +e;
    e = Xn(e);
    var l = da.test(e);
    return l || ma.test(e) ? ua(e.slice(2), l ? 2 : 8) : sa.test(e) ? NaN : +e;
  },
      ga = Math.max,
      va = Math.min;

  var pa = function pa(e, t, l) {
    var n,
        a,
        r,
        i,
        c,
        o,
        s = 0,
        d = !1,
        m = !1,
        u = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");

    function h(t) {
      var l = n,
          r = a;
      return n = a = void 0, s = t, i = e.apply(r, l);
    }

    function g(e) {
      return s = e, c = setTimeout(p, t), d ? h(e) : i;
    }

    function v(e) {
      var l = e - o;
      return void 0 === o || l >= t || l < 0 || m && e - s >= r;
    }

    function p() {
      var e = Zn();
      if (v(e)) return f(e);
      c = setTimeout(p, function (e) {
        var l = t - (e - o);
        return m ? va(l, r - (e - s)) : l;
      }(e));
    }

    function f(e) {
      return c = void 0, u && n ? h(e) : (n = a = void 0, i);
    }

    function b() {
      var e = Zn(),
          l = v(e);

      if (n = arguments, a = this, o = e, l) {
        if (void 0 === c) return g(o);
        if (m) return clearTimeout(c), c = setTimeout(p, t), h(o);
      }

      return void 0 === c && (c = setTimeout(p, t)), i;
    }

    return t = ha(t) || 0, Bn(l) && (d = !!l.leading, r = (m = "maxWait" in l) ? ga(ha(l.maxWait) || 0, t) : r, u = "trailing" in l ? !!l.trailing : u), b.cancel = function () {
      void 0 !== c && clearTimeout(c), s = 0, n = o = a = c = void 0;
    }, b.flush = function () {
      return void 0 === c ? i : f(Zn());
    }, b;
  };

  var fa = function fa(e, t, l) {
    var n = !0,
        a = !0;
    if ("function" != typeof e) throw new TypeError("Expected a function");
    return Bn(l) && (n = "leading" in l ? !!l.leading : n, a = "trailing" in l ? !!l.trailing : a), pa(e, t, {
      leading: n,
      maxWait: t,
      trailing: a
    });
  },
      ba = "ds-masthead-monogram",
      Ea = "ds-masthead-logo",
      wa = function wa(e) {
    var t = e.href;
    return n.createElement("a", {
      href: t,
      className: "ds-masthead-home"
    }, n.createElement(N, {
      className: Ea
    }), n.createElement(z, {
      className: ba
    }));
  };

  wa.defaultProps = {
    href: $t.economist
  }, wa.propTypes = {
    href: l.string
  };

  var Ma = "ds-menu-disclosure",
      ya = "is-open",
      ka = "ds-menu-disclosure--inverse",
      Na = "ds-menu-disclosure--no-menu-text",
      xa = function xa(e) {
    var t,
        l = e.testId,
        a = e.menuIsOpen,
        r = e.inverse,
        c = e.className,
        s = e.hideMenuText,
        d = o(e, ["testId", "menuIsOpen", "inverse", "className", "hideMenuText"]);
    return n.createElement("a", i({
      className: B(c, Ma, (t = {}, R(t, ka, a), R(t, ya, a), R(t, ka, r), R(t, Na, s), t)),
      href: "#",
      "data-menu-is-open": a,
      "aria-expanded": a,
      id: "menu-button",
      "data-test-id": l
    }, d), a ? n.createElement("svg", {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      id: "icon-menu-disclosure",
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      className: "path-foreground",
      fill: "#0D0D0D",
      d: "M18.75 6.61l-1.36-1.36L12 10.64 6.61 5.25 5.25 6.61 10.64 12l-5.39 5.39 1.36 1.36L12 13.36l5.39 5.39 1.36-1.36L13.36 12z"
    }))) : n.createElement("svg", {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      id: "icon-menu-disclosure",
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      d: "M0 0h24v24H0z"
    }), n.createElement("path", {
      className: "path-foreground",
      d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
      fill: "#0D0D0D",
      fillRule: "nonzero"
    }))), a ? "Close" : "Menu");
  };

  xa.defaultProps = {
    testId: "Menu link",
    className: null,
    menuIsOpen: !1,
    hideMenuText: !1,
    inverse: !1
  }, xa.propTypes = {
    testId: l.string,
    className: l.string,
    menuIsOpen: l.bool,
    hideMenuText: l.bool,
    inverse: l.bool
  };

  var La = {
    "ds-navigation-disclosure": "ds-navigation-disclosure",
    "path-foreground": "path-foreground",
    "is-selected": "is-selected",
    "ds-navigation-disclosure--inverse": "ds-navigation-disclosure--inverse",
    "ds-navigation-disclosure--icon": "ds-navigation-disclosure--icon",
    "ds-navigation-disclosure--icon-account": "ds-navigation-disclosure--icon-account",
    "ds-navigation-disclosure--icon-search": "ds-navigation-disclosure--icon-search"
  },
      Ta = function Ta(e) {
    var t,
        l = e.className,
        a = e.text,
        r = e.inverse,
        c = e.expanded,
        s = o(e, ["className", "text", "inverse", "expanded"]);
    return n.createElement("a", i({
      className: B(l, La["ds-navigation-disclosure"], (t = {}, R(t, La["ds-navigation-disclosure--inverse"], r), R(t, La["is-selected"], c), t))
    }, s), a, n.createElement("svg", {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg"
    }, n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      className: "path-foreground",
      fill: "#0D0D0D",
      fillRule: "nonzero",
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
    }), n.createElement("path", {
      d: "M0 0h24v24H0z"
    }))));
  };

  Ta.defaultProps = {
    className: null,
    text: "",
    inverse: !1,
    expanded: !1
  }, Ta.propTypes = {
    className: l.string,
    text: l.string,
    inverse: l.bool,
    expanded: l.bool
  };

  var za = function za(e) {
    var t = e.icon,
        l = e.className,
        a = o(e, ["icon", "className"]);
    return n.createElement(Ta, i({
      className: B(l, La["ds-navigation-disclosure--icon"], R({}, La["ds-navigation-disclosure--icon-".concat(t)], t))
    }, a));
  };

  za.defaultProps = {
    icon: null,
    className: null
  }, za.propTypes = {
    className: l.string,
    icon: l.oneOf(["account", "search"])
  };

  var ja = "ds-account-disclosure",
      Da = "is-selected",
      Ia = "ds-account-disclosure--inverse",
      Sa = "ds-account-disclosure__arrow",
      Ca = "ds-account-disclosure__avatar",
      Oa = "ds-account-disclosure__avatar-initials",
      Aa = "ds-account-disclosure__avatar-initials--inverse",
      Fa = "ds-account-disclosure__overlay",
      _a = "ds-account-disclosure__avatar-text",
      Ua = function Ua(e) {
    var t,
        l = e.className,
        a = e.text,
        r = e.inverse,
        c = e.expanded,
        s = e.fullName,
        d = o(e, ["className", "text", "inverse", "expanded", "fullName"]),
        m = function (e) {
      var t = e ? e.split(" ").map(function (e) {
        return e[0];
      }).join("") : "";
      return t.length > 1 ? t[0] + t[t.length - 1] : t;
    }(s);

    return n.createElement(n.Fragment, null, n.createElement("button", i({
      className: B(l, ja, (t = {}, R(t, Ia, r), R(t, Da, c), t)),
      type: "button"
    }, d), n.createElement("div", {
      className: B(Oa, R({}, Aa, r))
    }, m || n.createElement("svg", {
      viewBox: "0 0 22 22",
      xmlns: "http://www.w3.org/2000/svg",
      className: Ca
    }, n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      className: "avatar-foreground",
      d: "M10.9993 10.9998C13.0252 10.9998 14.666 9.359 14.666 7.33317C14.666 5.30734 13.0252 3.6665 10.9993 3.6665C8.97352 3.6665 7.33268 5.30734 7.33268 7.33317C7.33268 9.359 8.97352 10.9998 10.9993 10.9998ZM10.9993 12.8332C8.55185 12.8332 3.66602 14.0615 3.66602 16.4998V17.4165C3.66602 17.9207 4.07852 18.3332 4.58268 18.3332H17.416C17.9202 18.3332 18.3327 17.9207 18.3327 17.4165V16.4998C18.3327 14.0615 13.4468 12.8332 10.9993 12.8332Z",
      fill: "white",
      fillRule: "nonzero"
    })))), n.createElement("div", {
      className: "".concat(_a)
    }, a), n.createElement("svg", {
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      className: B(l, Sa, R({}, Da, c))
    }, n.createElement("g", {
      fill: "none",
      fillRule: "evenodd"
    }, n.createElement("path", {
      className: "path-foreground",
      fill: "#0D0D0D",
      fillRule: "nonzero",
      d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6z"
    }), n.createElement("path", {
      d: "M0 0h24v24H0z"
    })))), c && n.createElement("div", i({
      className: "".concat(Fa)
    }, d)));
  };

  Ua.defaultProps = {
    className: null,
    text: "",
    inverse: !1,
    expanded: !1,
    fullName: ""
  }, Ua.propTypes = {
    className: l.string,
    text: l.string,
    inverse: l.bool,
    expanded: l.bool,
    fullName: l.string
  };

  var Pa = function Pa(e) {
    var t = e.isLoggedIn,
        l = e.loginUrl,
        a = e.logoutUrl,
        r = e.inverse,
        i = e.toggleAccount,
        c = e.expanded,
        o = e.className,
        s = e.fullName;
    return n.createElement(n.Fragment, null, t && !a && n.createElement(Ua, {
      onClick: i,
      text: "My Economist",
      inverse: r,
      expanded: c,
      className: o,
      fullName: s
    }), t && a && n.createElement(At, {
      href: a,
      text: "Log out",
      inverse: r
    }), !t && n.createElement(At, {
      href: l,
      text: "Log in",
      inverse: r
    }));
  };

  function Va(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  Pa.defaultProps = {
    isLoggedIn: !1,
    loginUrl: "",
    logoutUrl: "",
    inverse: !1,
    toggleAccount: function toggleAccount() {},
    expanded: !1,
    className: "",
    fullName: ""
  }, Pa.propTypes = {
    isLoggedIn: l.bool,
    loginUrl: l.string,
    logoutUrl: l.string,
    inverse: l.bool,
    toggleAccount: l.func,
    expanded: l.bool,
    className: l.string,
    fullName: l.string
  };

  var Ra = function Ra(e, t, l, n, a, r, i, c, o, s, d) {
    var m = function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var l = null != arguments[t] ? arguments[t] : {};
        t % 2 ? Va(Object(l), !0).forEach(function (t) {
          R(e, t, l[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : Va(Object(l)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
        });
      }

      return e;
    }({}, tl),
        u = function u(e, t, l) {
      e ? m[l].find(function (e) {
        return e.name === t;
      }).url = e : "My Economist" !== t && "Saved stories" !== t && "Account" !== t && (m[l] = m[l].filter(function (e) {
        return e.name !== t;
      }));
    };

    e && (m["account-logged-out"].find(function (e) {
      return "Log in" === e.name;
    }).url = e);
    return u(t, "Log out", "account-logged-in"), u(l, "My Economist", "account-logged-in"), u(n, "Saved stories", "account-logged-in"), u(a, "Admin account", "account-logged-in"), u(r, "My subscription", "account-logged-in"), u(i, "Personal information", "account-logged-in"), u(c, "Billing", "account-logged-in"), u(o, "Newsletters & preferences", "account-logged-in"), u(s, "Gift subscriptions", "account-logged-in"), u(d, "Help", "account-logged-in"), u(t, "Log out", "account-logged-in-main"), u(l, "Account", "account-logged-in-main"), u(n, "Saved stories", "account-logged-in-main"), u(a, "Admin account", "account-logged-in-main"), m;
  },
      Ba = "ds-layout-masthead",
      Ha = "ds-masthead",
      Ya = "is-open",
      Qa = "search-is-open",
      Za = "account-is-open",
      qa = "ds-masthead-nav",
      Ga = "ds-masthead--secondary",
      Wa = "ds-masthead-nav-alpha",
      Xa = "ds-masthead-nav-alpha__item",
      Ka = "ds-masthead-nav-beta__item",
      Ja = "ds-masthead-nav-beta__item--log-in",
      $a = "ds-masthead-nav-alpha__item--weekly-edition",
      er = "ds-masthead-nav-alpha__item--the-world-in-brief",
      tr = "ds-masthead-nav-alpha__item--search",
      lr = "ds-masthead-nav-beta",
      nr = "ds-masthead-nav-beta__item--extra-item",
      ar = "ds-masthead-nav-alpha__item--menu",
      rr = "ds-masthead-nav-beta__item--call-to-action",
      ir = "ds-masthead-nav-lists",
      cr = function cr(e) {
    var t = e.inverse,
        l = e.selectedLink,
        a = e.links;
    return n.createElement(n.Fragment, null, n.createElement("li", {
      className: "".concat(Xa, " ").concat($a)
    }, n.createElement(At, {
      text: "Weekly edition",
      href: a.weeklyEdition,
      inverse: t,
      selected: "weekly-edition" === l,
      className: "weekly-edition-link"
    })), n.createElement("li", {
      className: "".concat(Xa, " ").concat(er)
    }, n.createElement(At, {
      text: "The world in brief",
      href: a.theWorldInBrief,
      inverse: t,
      selected: "the-world-in-brief" === l,
      className: "the-world-in-brief-link"
    })));
  };

  cr.defaultProps = {
    inverse: !1,
    selectedLink: null,
    links: $t
  }, cr.propTypes = {
    inverse: l.bool,
    selectedLink: l.oneOf(["weekly-edition", "the-world-in-brief", "today"]),
    links: l.shape({
      economist: l.string.isRequired,
      weeklyEdition: l.string.isRequired,
      theWorldInBrief: l.string.isRequired
    })
  };

  var or = {
    "ds-navigation-list": "ds-navigation-list",
    "ds-navigation-list--blog": "ds-navigation-list--blog",
    "ds-navigation-link": "ds-navigation-link",
    "ds-navigation-list__header": "ds-navigation-list__header",
    "is-selected": "is-selected",
    "ds-navigation-list__header-anchor": "ds-navigation-list__header-anchor",
    "ds-navigation-list__header-username": "ds-navigation-list__header-username",
    "ds-navigation-list__link-description": "ds-navigation-list__link-description",
    "ds-masthead-nav-lists": "ds-masthead-nav-lists",
    "ds-navigation-list--account-logged-in": "ds-navigation-list--account-logged-in",
    "ds-navigation-list--account-logged-out": "ds-navigation-list--account-logged-out",
    "ds-masthead": "ds-masthead",
    "ds-masthead--secondary": "ds-masthead--secondary",
    "ds-navigation-list-items--section": "ds-navigation-list-items--section",
    "ds-navigation-list-items--blog": "ds-navigation-list-items--blog",
    "ds-navigation-list-items--more": "ds-navigation-list-items--more",
    "ds-navigation-list-items--account-logged-in": "ds-navigation-list-items--account-logged-in",
    "ds-navigation-list--section": "ds-navigation-list--section",
    "ds-navigation-list--feature": "ds-navigation-list--feature",
    "ds-navigation-list--more": "ds-navigation-list--more"
  },
      sr = function sr(e) {
    var l = e.title,
        a = e.children,
        r = e.type,
        i = e.menuIsOpen,
        c = e.showNavToggle,
        o = e.listIsOpen,
        s = t.useState(),
        d = tt(s, 2),
        m = d[0],
        u = d[1];

    function h(e) {
      e.preventDefault(), u(!m);
    }

    return t.useEffect(function () {
      i || o || u(!1), o && u(!0);
    }, [i]), n.createElement("li", {
      className: B(or["ds-navigation-list"], or["ds-navigation-list--".concat(r)], R({}, or["is-selected"], m))
    }, c ? n.createElement("h2", {
      className: or["ds-navigation-list__header"]
    }, n.createElement("a", {
      className: or["ds-navigation-list__header-anchor"],
      onClick: h,
      onKeyDown: function onKeyDown(e) {
        [nl.ENTER, nl.SPACE].includes(e.keyCode) && h(e);
      },
      role: "button",
      tabIndex: "0",
      "aria-expanded": m
    }, l)) : n.createElement("h2", {
      className: or["ds-navigation-list__header"]
    }, l), n.createElement("ul", {
      className: B(or["ds-navigation-list-items--".concat(r)], R({}, or["is-selected"], m))
    }, a));
  };

  sr.defaultProps = {
    listIsOpen: !1
  }, sr.propTypes = {
    title: l.node.isRequired,
    children: l.node.isRequired,
    type: l.node.isRequired,
    menuIsOpen: l.bool.isRequired,
    showNavToggle: l.bool.isRequired,
    listIsOpen: l.bool
  };

  var dr = function dr(e) {
    return n.createElement("li", {
      key: e.name.toString()
    }, n.createElement(At, {
      inverse: !0,
      href: e.url,
      text: e.name
    }));
  },
      mr = function mr(e) {
    var t,
        l,
        a = e.type,
        r = e.baseUrl,
        i = e.menuIsOpen,
        c = e.showNavToggle,
        o = e.username,
        s = e.accountData,
        d = e.listIsOpen,
        m = function () {
      var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : $t.economist;
      return {
        feature: [{
          name: "War in Ukraine",
          url: "".concat(e, "/ukraine-crisis")
        }, {
          name: "Recession watch",
          url: "".concat(e, "/recession")
        }, {
          name: "The World Ahead 2023",
          url: "".concat(e, "/the-world-ahead-2023")
        }, {
          name: "US politics",
          url: "".concat(e, "/president-joe-biden")
        }, {
          name: "Climate change",
          url: "".concat(e, "/climate-change")
        }, {
          name: "Coronavirus",
          url: "".concat(e, "/coronavirus-pandemic")
        }, {
          name: "1843 magazine",
          url: "".concat(e, "/1843")
        }, {
          name: "The world in brief",
          url: "".concat(e, "/the-world-in-brief")
        }],
        section: [{
          name: "The world this week",
          url: "".concat(e, "/the-world-this-week")
        }, {
          name: "Leaders",
          url: "".concat(e, "/leaders")
        }, {
          name: "Letters",
          url: "".concat(e, "/letters")
        }, {
          name: "Briefing",
          url: "".concat(e, "/briefing")
        }, {
          name: "United States",
          url: "".concat(e, "/united-states")
        }, {
          name: "The Americas",
          url: "".concat(e, "/the-americas")
        }, {
          name: "Asia",
          url: "".concat(e, "/asia")
        }, {
          name: "China",
          url: "".concat(e, "/china")
        }, {
          name: "Middle East & Africa",
          url: "".concat(e, "/middle-east-and-africa")
        }, {
          name: "Europe",
          url: "".concat(e, "/europe")
        }, {
          name: "Britain",
          url: "".concat(e, "/britain")
        }, {
          name: "International",
          url: "".concat(e, "/international")
        }, {
          name: "Business",
          url: "".concat(e, "/business")
        }, {
          name: "Finance & economics",
          url: "".concat(e, "/finance-and-economics")
        }, {
          name: "Science & technology",
          url: "".concat(e, "/science-and-technology")
        }, {
          name: "Culture",
          url: "".concat(e, "/culture")
        }, {
          name: "Graphic detail",
          url: "".concat(e, "/graphic-detail")
        }, {
          name: "Obituary",
          url: "".concat(e, "/obituary")
        }, {
          name: "Special reports",
          url: "".concat(e, "/special-reports")
        }, {
          name: "Technology Quarterly",
          url: "".concat(e, "/technology-quarterly")
        }, {
          name: "Essay",
          url: "".concat(e, "/essay")
        }, {
          name: "By Invitation",
          url: "".concat(e, "/by-invitation")
        }, {
          name: "Schools brief",
          url: "".concat(e, "/schools-brief")
        }, {
          name: "The Economist explains",
          url: "".concat(e, "/the-economist-explains")
        }, {
          name: "The Economist reads",
          url: "".concat(e, "/the-economist-reads")
        }],
        more: [{
          name: "Newsletters",
          url: "".concat(e, "/newsletters")
        }, {
          name: "Podcasts",
          url: "".concat(e, "/podcasts")
        }, {
          name: "Films",
          url: "".concat(e, "/films")
        }, {
          name: "Subscriber events",
          url: "https://subscriberevents.economist.com"
        }, {
          name: "The Economist app",
          url: "".concat(e, "/get-the-app")
        }, {
          name: "Online courses",
          url: "https://education.economist.com"
        }],
        account: [{
          name: "Manage my account",
          url: "https://my.economist.com"
        }, {
          name: "Log out",
          url: ""
        }]
      };
    }(r);

    switch (a) {
      case "account-logged-in":
        t = s[a].map(function (e) {
          return dr(e);
        }), o && t.unshift(n.createElement("li", {
          key: "username"
        }, n.createElement("strong", {
          className: or["ds-navigation-list__header-username"]
        }, o))), l = "My account";
        break;

      case "feature":
        t = m[a].map(function (e) {
          return dr(e);
        }), l = "Featured";
        break;

      case "more":
        t = m[a].map(function (e) {
          return dr(e);
        }), l = "More";
        break;

      case "section":
        t = m[a].map(function (e) {
          return dr(e);
        }), l = "Sections";
        break;

      default:
        return null;
    }

    return n.createElement(sr, {
      title: l,
      type: a,
      menuIsOpen: i,
      showNavToggle: c,
      listIsOpen: d
    }, t);
  };

  mr.defaultProps = {
    baseUrl: $t.economist,
    accountData: {},
    username: "",
    listIsOpen: !1
  }, mr.propTypes = {
    baseUrl: l.string,
    menuIsOpen: l.bool.isRequired,
    accountData: l.objectOf(l.array),
    showNavToggle: l.bool.isRequired,
    type: l.oneOf(["blog", "account-logged-in", "account-logged-out", "more", "section", "feature"]).isRequired,
    username: l.string,
    listIsOpen: l.bool
  };

  var ur = function ur(e) {
    var t = e.menuIsOpen,
        l = e.urls,
        a = e.showNavToggle;
    return n.createElement("nav", {
      className: ir
    }, n.createElement("div", {
      id: "menu-nav",
      tabIndex: "-1",
      role: "presentation"
    }), n.createElement("ul", null, t && n.createElement(cr, {
      inverse: !0
    }), n.createElement(mr, {
      type: "feature",
      baseUrl: l.economist,
      menuIsOpen: t,
      showNavToggle: a,
      listIsOpen: !0
    }), n.createElement(mr, {
      type: "section",
      baseUrl: l.economist,
      menuIsOpen: t,
      showNavToggle: a
    }), n.createElement(mr, {
      type: "more",
      baseUrl: l.economist,
      menuIsOpen: t,
      showNavToggle: a
    })));
  };

  ur.defaultProps = {
    urls: $t
  }, ur.propTypes = {
    menuIsOpen: l.bool.isRequired,
    urls: el,
    showNavToggle: l.bool.isRequired
  };

  var hr = "ds-masthead-account-lists",
      gr = "ds-masthead-account-list",
      vr = "ds-masthead-account-main-list",
      pr = "ds-masthead-account-list__item",
      fr = function fr(e) {
    return n.createElement("li", {
      className: pr,
      key: e.url.toString()
    }, n.createElement(At, {
      href: e.url,
      text: e.name
    }));
  },
      br = function br(e) {
    var t = e.accountData;
    return n.createElement("nav", {
      className: hr
    }, n.createElement("ul", {
      className: gr
    }, t["account-logged-in"].map(function (e) {
      return fr(e);
    })), n.createElement("ul", {
      className: vr
    }, t["account-logged-in-main"].map(function (e) {
      return fr(e);
    })));
  };

  br.propTypes = {
    accountData: l.objectOf(l.array).isRequired
  };

  var Er = "ds-skip-to-content",
      wr = "ds-skip-to-content--inverse",
      Mr = function Mr(e) {
    var t = e.targetId,
        l = e.inverse;
    return n.createElement("a", {
      className: B(Er, R({}, wr, l)),
      href: "#".concat(t),
      onClick: function onClick(e) {
        var l = document.getElementById(t);
        l && (e.preventDefault(), l.setAttribute("tabindex", "-1"), l.focus({
          preventScroll: !0
        }), l.style.outline = "0", l.addEventListener("blur", function e(t) {
          t.target.removeAttribute("tabindex"), l.removeEventListener("blur", e);
        }));
      }
    }, "Skip to content");
  };

  Mr.defaultProps = {
    inverse: !1
  }, Mr.propTypes = {
    inverse: l.bool,
    targetId: l.string.isRequired
  };

  var yr = "ds-search-form",
      kr = "ds-search-form-container",
      Nr = function Nr(e) {
    var l = e.labelText,
        a = e.searchUrl,
        r = e.searchIsOpen,
        i = t.useState(""),
        c = tt(i, 2),
        o = c[0],
        s = c[1];
    return n.createElement("div", {
      className: yr
    }, n.createElement("div", {
      id: "search-form",
      tabIndex: "-1",
      role: "presentation"
    }), n.createElement("form", {
      action: a,
      method: "get",
      className: kr
    }, n.createElement(gn, {
      adjacent: !0,
      value: o,
      onChange: function onChange(e) {
        s(e.target.value);
      },
      inverse: !0,
      labelText: l,
      name: "q",
      focusInput: r,
      id: "masthead-search"
    })));
  };

  function xr(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function Lr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? xr(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : xr(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  Nr.defaultProps = {
    labelText: "Search",
    searchUrl: "",
    searchIsOpen: !1
  }, Nr.propTypes = {
    labelText: l.string,
    searchUrl: l.string,
    searchIsOpen: l.bool
  };
  var Tr = n.memo(function (e) {
    var l,
        a = e.isLoggedIn,
        r = e.loginUrl,
        i = e.logoutUrl,
        c = e.overrideUrls,
        o = e.selectedLink,
        s = e.showSubscribe,
        d = e.subscribeCtaText,
        m = e.subscribeUrl,
        u = e.testId,
        h = e.skipTargetId,
        g = e.manageMyAccountUrl,
        v = e.savedStoriesUrl,
        p = e.gsClientAdminUrl,
        f = e.mySubscriptionUrl,
        b = e.personalInfoUrl,
        E = e.billingUrl,
        w = e.newslettersAndPreferencesUrl,
        M = e.giftSubscriptionsUrl,
        y = e.helpUrl,
        k = e.isClientAdmin,
        N = e.isGroupSubscriber,
        x = e.fullName,
        L = e.temporaryExtraItem,
        T = t.useState(function () {
      if ("undefined" != typeof window) return window.innerWidth;
    }()),
        z = tt(T, 2),
        j = z[0],
        D = z[1],
        I = t.useState(!1),
        S = tt(I, 2),
        C = S[0],
        O = S[1],
        A = t.useState(!1),
        F = tt(A, 2),
        _ = F[0],
        U = F[1],
        P = t.useState(!1),
        V = tt(P, 2),
        H = V[0],
        Y = V[1],
        Q = t.useState(!1),
        Z = tt(Q, 2),
        q = Z[0],
        G = Z[1],
        W = t.useRef(),
        X = C || H,
        K = Ra(r, i, g, v, p, f, b, E, w, M, y);
    s && (K["account-logged-in"] = K["account-logged-in"].filter(function (e) {
      return "Billing" !== e.name;
    })), (N || k) && (K["account-logged-in"] = K["account-logged-in"].filter(function (e) {
      return "Gift subscriptions" !== e.name && "Billing" !== e.name;
    })), k || (K["account-logged-in"] = K["account-logged-in"].filter(function (e) {
      return "Admin account" !== e.name;
    }), K["account-logged-in-main"] = K["account-logged-in-main"].filter(function (e) {
      return "Admin account" !== e.name;
    }));

    var J = Lr(Lr({}, $t), c),
        $ = [],
        ee = function ee(e) {
      e.keyCode === nl.TAB && (e.shiftKey || document.getElementById(e.target.type).focus());
    };

    var te = function te(e) {
      var t, l, n, a, r;

      switch (e.keyCode) {
        case 9:
          r = W.current ? W.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])') : [], $ = Array.from(r).filter(function (e) {
            if (null === e.offsetParent) return !1;
            var t = window.getComputedStyle(e);
            return "none" !== t.getPropertyValue("display") && "hidden" !== t.getPropertyValue("visibility");
          }), n = $, a = j < 960 ? "ds-navigation-disclosure--icon-search" : "weekly-edition-link", l = Array.from(n).find(function (e) {
            return Array.from(e.classList).includes(a);
          }), t = $[$.length - 1], e.shiftKey ? document.activeElement === l && (e.preventDefault(), t.focus()) : document.activeElement === t && (e.preventDefault(), l.focus());
          break;

        case 27:
          O(!1), Y(!1), U(!1);
      }
    };

    return t.useEffect(function () {
      return (C || H || _) && window.addEventListener("keydown", te), function () {
        window.removeEventListener("keydown", te);
      };
    }, [C, H, _]), t.useEffect(function () {
      var e = fa(function () {
        var e = window.innerWidth;
        e !== j && (D(e), 600 >= e && (U(!1), Y(!1)));
      }, 200);
      return G(1088 > j), window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    }), n.createElement("header", {
      "data-test-id": u,
      className: B(Ha, (l = {}, R(l, Ya, C), R(l, Za, _), R(l, Qa, H), l))
    }, n.createElement("div", {
      className: Ba,
      ref: W
    }, n.createElement(wa, {
      href: "".concat(J.economist, "/")
    }), n.createElement(Mr, {
      targetId: h,
      inverse: X
    }), n.createElement("div", {
      className: qa
    }, n.createElement("nav", {
      className: Wa
    }, n.createElement("ul", null, n.createElement("li", {
      className: "".concat(Xa, " ").concat(ar)
    }, n.createElement(xa, {
      url: "#sections",
      menuIsOpen: C,
      inverse: X,
      onClick: function onClick(e) {
        e.preventDefault(), U(!1), Y(!1), O(!C);
      },
      onKeyDown: ee,
      type: "menu-nav",
      hideMenuText: s
    })), n.createElement(cr, {
      inverse: X,
      selectedLink: o,
      links: J
    }), n.createElement("li", {
      className: "".concat(Xa, " ").concat(tr)
    }, n.createElement(za, {
      text: "Search",
      onClick: function onClick(e) {
        e.preventDefault(), O(!1), U(!1), Y(!H);
      },
      expanded: H,
      href: "#",
      icon: "search",
      inverse: X,
      onKeyDown: ee,
      type: "search-form"
    })))), n.createElement("div", {
      className: lr
    }, L && n.createElement("div", {
      className: "".concat(Ka, " ").concat(nr)
    }, L), s && n.createElement("div", {
      className: "".concat(Ka, " ").concat(rr)
    }, n.createElement(ve, {
      text: d,
      href: m || J.subscribe,
      inverse: X
    })), n.createElement("div", {
      className: "".concat(Ka, " ").concat(Ja)
    }, n.createElement(Pa, {
      isLoggedIn: a,
      loginUrl: r,
      inverse: X,
      toggleAccount: function toggleAccount(e) {
        e.preventDefault(), O(!1), Y(!1), U(!_);
      },
      expanded: _,
      className: "my-account-link",
      fullName: x
    })))), n.createElement(ur, {
      accountData: K,
      menuIsOpen: C,
      showSubscribe: s,
      urls: J,
      subscribeUrl: m || J.subscribe,
      showNavToggle: q,
      isLoggedIn: a
    }), n.createElement(br, {
      accountData: K
    }), n.createElement(Nr, {
      searchUrl: J.search,
      searchIsOpen: H
    })), n.createElement("div", {
      id: "skip-to-content-target"
    }));
  });
  Tr.displayName = "Masthead", Tr.defaultProps = {
    isLoggedIn: !1,
    loginUrl: "",
    logoutUrl: "",
    overrideUrls: {},
    selectedLink: null,
    showSubscribe: !0,
    subscribeCtaText: "Subscribe",
    skipTargetId: "skip-to-content-target",
    subscribeUrl: null,
    testId: "Masthead",
    manageMyAccountUrl: "",
    savedStoriesUrl: "",
    gsClientAdminUrl: "",
    mySubscriptionUrl: "",
    personalInfoUrl: "",
    billingUrl: "",
    newslettersAndPreferencesUrl: "",
    giftSubscriptionsUrl: "",
    helpUrl: "",
    isClientAdmin: !1,
    isGroupSubscriber: !1,
    fullName: "",
    temporaryExtraItem: void 0
  }, Tr.propTypes = {
    isLoggedIn: l.bool,
    loginUrl: l.string,
    logoutUrl: l.string,
    overrideUrls: el,
    selectedLink: l.oneOf(["weekly-edition"]),
    showSubscribe: l.bool,
    subscribeCtaText: l.string,
    skipTargetId: l.string,
    testId: l.string,
    subscribeUrl: l.string,
    manageMyAccountUrl: l.string,
    savedStoriesUrl: l.string,
    gsClientAdminUrl: l.string,
    mySubscriptionUrl: l.string,
    personalInfoUrl: l.string,
    billingUrl: l.string,
    newslettersAndPreferencesUrl: l.string,
    giftSubscriptionsUrl: l.string,
    helpUrl: l.string,
    isClientAdmin: l.bool,
    isGroupSubscriber: l.bool,
    fullName: l.string,
    temporaryExtraItem: l.node
  };

  var zr = function zr(e) {
    var t = e.links,
        l = e.inverse,
        a = e.selectedLink;
    return n.createElement(n.Fragment, null, t.map(function (e, t) {
      var r = e.text,
          i = e.href,
          c = e.id;
      return n.createElement("li", {
        key: c,
        className: Xa
      }, n.createElement(At, {
        text: r,
        href: i,
        inverse: l,
        selected: t === a
      }));
    }));
  };

  zr.defaultProps = {
    inverse: !1,
    selectedLink: null
  }, zr.propTypes = {
    inverse: l.bool,
    links: l.arrayOf(l.shape({
      text: l.string,
      href: l.string,
      id: l.string
    })).isRequired,
    selectedLink: l.number
  };

  var jr = function jr(e) {
    var t = e.links,
        l = e.menuIsOpen,
        a = e.showLogin,
        r = e.showNavToggle,
        i = e.accountData,
        c = e.username,
        o = e.isLoggedIn,
        s = e.showAccountNav,
        d = e.loginUrl,
        m = function (e, t, l, a, r, i, c) {
      return n.createElement(n.Fragment, null, e && !i && n.createElement("li", {
        className: "".concat(Ka, " ").concat(Ja)
      }, n.createElement(At, {
        href: c,
        text: "Log out",
        inverse: !0
      })), e && i && n.createElement(mr, {
        type: "account-logged-in",
        accountData: t,
        menuIsOpen: l,
        showNavToggle: r,
        username: a
      }), !e && n.createElement(mr, {
        type: "account-logged-out",
        accountData: t,
        menuIsOpen: l,
        showNavToggle: r
      }));
    }(o, i, l, c, r, s, e.logoutUrl);

    return n.createElement("nav", {
      className: ir
    }, n.createElement("ul", null, !o && d && n.createElement("li", {
      className: "".concat(Ka, " ").concat(Ja)
    }, n.createElement(At, {
      href: d,
      text: "Log in",
      inverse: !0
    })), a && o && !s && m, t && n.createElement(zr, {
      links: t,
      inverse: !0
    }), a && o && s && m));
  };

  jr.defaultProps = {
    accountData: null,
    isLoggedIn: !1,
    links: null,
    loginUrl: "",
    logoutUrl: "",
    showLogin: !1,
    showNavToggle: !1,
    showAccountNav: !0,
    username: ""
  }, jr.propTypes = {
    accountData: l.objectOf(l.array),
    isLoggedIn: l.bool,
    links: l.arrayOf(l.shape({
      text: l.string,
      href: l.string,
      id: l.string
    })),
    loginUrl: l.string,
    logoutUrl: l.string,
    menuIsOpen: l.bool.isRequired,
    showLogin: l.bool,
    showNavToggle: l.bool,
    showAccountNav: l.bool,
    username: l.string
  };
  var Dr = $t.subscribe,
      Ir = n.memo(function (e) {
    var l,
        a = e.isLoggedIn,
        r = e.loginUrl,
        i = e.logoutUrl,
        c = e.mastheadLinks,
        o = e.selectedLink,
        s = e.showAccountNav,
        d = e.showLogin,
        m = e.showSubscribe,
        u = e.subscribeCtaText,
        h = e.subscribeUrl,
        g = e.username,
        v = e.manageMyAccountUrl,
        p = e.savedStoriesUrl,
        f = e.gsClientAdminUrl,
        b = e.mySubscriptionUrl,
        E = e.personalInfoUrl,
        w = e.billingUrl,
        M = e.newslettersAndPreferencesUrl,
        y = e.giftSubscriptionsUrl,
        k = e.helpUrl,
        N = e.isClientAdmin,
        x = e.isGroupSubscriber,
        L = e.fullName,
        T = t.useState(function () {
      if ("undefined" != typeof window) return window.innerWidth;
    }()),
        z = tt(T, 2),
        j = z[0],
        D = z[1],
        I = t.useState(!1),
        S = tt(I, 2),
        C = S[0],
        O = S[1],
        A = t.useState(!1),
        F = tt(A, 2),
        _ = F[0],
        U = F[1],
        P = C,
        V = Ra(r, i, v, p, f, b, E, w, M, y, k);
    m && (V["account-logged-in"] = V["account-logged-in"].filter(function (e) {
      return "Billing" !== e.name;
    })), (x || N) && (V["account-logged-in"] = V["account-logged-in"].filter(function (e) {
      return "Gift subscriptions" !== e.name && "Billing" !== e.name;
    })), N || (V["account-logged-in"] = V["account-logged-in"].filter(function (e) {
      return "Admin account" !== e.name;
    }), V["account-logged-in-main"] = V["account-logged-in-main"].filter(function (e) {
      return "Admin account" !== e.name;
    }));
    var H = d ? V : null,
        Y = c && c.length;
    return t.useEffect(function () {
      var e = fa(function () {
        var e = window.innerWidth;
        e !== j && (D(e), e < 1088 && U(!1), e >= 1088 && O(!1));
      }, 200);
      return window.addEventListener("resize", e), function () {
        window.removeEventListener("resize", e);
      };
    }), n.createElement("header", {
      className: B("".concat(Ha, " ").concat(Ga), (l = {}, R(l, Ya, C), R(l, Za, _), l))
    }, n.createElement("div", {
      className: Ba
    }, n.createElement(wa, null), n.createElement("div", {
      className: qa
    }, Y && n.createElement("nav", {
      className: Wa
    }, n.createElement("ul", null, n.createElement(zr, {
      links: c,
      selectedLink: o,
      inverse: P
    }), n.createElement("li", {
      className: "".concat(Xa, " ").concat(ar)
    }, n.createElement(xa, {
      url: "#sections",
      menuIsOpen: C,
      inverse: P,
      onClick: function onClick(e) {
        e.preventDefault(), U(!1), O(!C);
      },
      hideMenuText: m
    })))), n.createElement("div", {
      className: lr
    }, m && n.createElement("div", {
      className: "".concat(Ka, " ").concat(rr)
    }, n.createElement(ve, {
      text: u,
      href: h,
      inverse: P
    })), d && n.createElement("div", {
      className: "".concat(Ka, " ").concat(Ja)
    }, n.createElement(Pa, {
      isLoggedIn: a,
      loginUrl: r,
      logoutUrl: s ? null : i,
      inverse: P,
      toggleAccount: function toggleAccount(e) {
        e.preventDefault(), O(!1), U(!_);
      },
      expanded: _,
      fullName: L
    })))), C && n.createElement(jr, {
      accountData: H,
      links: c,
      logoutUrl: i,
      menuIsOpen: C,
      showAccountNav: !1,
      showSubscribe: m,
      showLogin: !1,
      showNavToggle: !0,
      subscribeUrl: h,
      username: g,
      isLoggedIn: a
    }), d && n.createElement(br, {
      accountData: H
    })));
  });
  Ir.displayName = "MastheadSecondary", Ir.defaultProps = {
    isLoggedIn: !1,
    loginUrl: "",
    logoutUrl: "",
    mastheadLinks: null,
    selectedLink: null,
    showAccountNav: !0,
    showLogin: !1,
    showSubscribe: !1,
    subscribeCtaText: "Subscribe",
    subscribeUrl: Dr,
    username: "",
    manageMyAccountUrl: "",
    savedStoriesUrl: "",
    gsClientAdminUrl: "",
    mySubscriptionUrl: "",
    personalInfoUrl: "",
    billingUrl: "",
    newslettersAndPreferencesUrl: "",
    giftSubscriptionsUrl: "",
    helpUrl: "",
    isClientAdmin: !1,
    isGroupSubscriber: !1,
    fullName: ""
  }, Ir.propTypes = {
    isLoggedIn: l.bool,
    loginUrl: l.string,
    logoutUrl: l.string,
    mastheadLinks: l.arrayOf(l.shape({
      text: l.string,
      href: l.string,
      id: l.string
    })),
    selectedLink: l.number,
    showAccountNav: l.bool,
    showLogin: l.bool,
    showSubscribe: l.bool,
    subscribeCtaText: l.string,
    subscribeUrl: l.string,
    username: l.string,
    manageMyAccountUrl: l.string,
    savedStoriesUrl: l.string,
    gsClientAdminUrl: l.string,
    mySubscriptionUrl: l.string,
    personalInfoUrl: l.string,
    billingUrl: l.string,
    newslettersAndPreferencesUrl: l.string,
    giftSubscriptionsUrl: l.string,
    helpUrl: l.string,
    isClientAdmin: l.bool,
    isGroupSubscriber: l.bool,
    fullName: l.string
  };

  var Sr = "ds-media-promo",
      Cr = "ds-layout-media-promo",
      Or = "ds-media-promo--inverse",
      Ar = "ds-media-promo--podcasts",
      Fr = "ds-media-promo--films",
      _r = "ds-media-promo--editorial",
      Ur = "ds-media-promo__group",
      Pr = "ds-media-promo__title",
      Vr = "ds-media-promo__description",
      Rr = function Rr(e) {
    var t,
        l = e.title,
        a = e.description,
        r = e.inverse,
        i = e.variant,
        c = e.linkText,
        o = e.linkURL;
    return n.createElement("div", {
      className: B(Sr, (t = {}, R(t, Or, r), R(t, Ar, "podcasts" === i), R(t, Fr, "films" === i), R(t, _r, "editorial" === i), t))
    }, n.createElement("div", {
      className: Cr
    }, n.createElement("div", {
      className: "ds-layout-grid ".concat(Ur)
    }, n.createElement("h2", {
      className: Pr
    }, l), n.createElement("p", {
      className: Vr
    }, a), n.createElement(Rn, {
      href: o,
      text: c,
      inverse: r,
      heavy: !0,
      minor: !0
    }))));
  };

  Rr.defaultProps = {
    description: "",
    inverse: !1
  }, Rr.propTypes = {
    title: l.string.isRequired,
    description: l.string,
    linkText: l.string.isRequired,
    linkURL: l.string.isRequired,
    variant: l.oneOf(["films", "podcasts", "editorial"]).isRequired,
    inverse: l.bool
  };

  var Br = "ds-missed-target",
      Hr = "ds-missed-target__illustration",
      Yr = "ds-missed-target__headline",
      Qr = "ds-missed-target__summary",
      Zr = function Zr(e) {
    var t = e.headline,
        l = e.summary;
    return n.createElement("div", {
      className: Br
    }, n.createElement("img", {
      className: Hr,
      src: "data:image/svg+xml;base64,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",
      alt: "Arrow laying on the ground next to a target"
    }), n.createElement("h1", {
      className: Yr
    }, t), n.createElement("p", {
      className: Qr
    }, l));
  };

  Zr.defaultProps = {
    summary: ""
  }, Zr.propTypes = {
    headline: l.string.isRequired,
    summary: l.oneOfType([l.node, l.string])
  };

  var qr = {
    "ds-modal--container": "ds-modal--container",
    "ds-modal": "ds-modal",
    "ds-modal--small": "ds-modal--small",
    "ds-modal--medium": "ds-modal--medium",
    "ds-modal--large": "ds-modal--large",
    "ds-modal--dark-mode": "ds-modal--dark-mode"
  },
      Gr = function Gr(e) {
    var l = e.showModal,
        a = e.onClose,
        r = e.width,
        i = e.ariaLabel,
        c = e.darkMode,
        o = e.children,
        s = t.useRef(),
        d = t.useCallback(function (e) {
      s.current.contains(e.target) || a();
    }, [s]),
        m = function m(e) {
      if (e.key === rl && a(), e.key === al) {
        var t = s.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if (0 === t.length) return void e.preventDefault();
        var l = t[t.length - 1];
        e.shiftKey && e.target === t[0] ? (e.preventDefault(), l.focus()) : e.shiftKey || e.target !== l || (e.preventDefault(), t[0].focus());
      }
    };

    return t.useEffect(function () {
      if (l) {
        var e = s.current.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        0 === e.length ? s.current.focus() : e[0].focus(), window.addEventListener("keydown", m), document.addEventListener("click", d, !0), document.body.style.overflow = "hidden";
      }

      return function () {
        window.removeEventListener("keydown", m), document.removeEventListener("click", d, !0), document.body.style.overflow = "visible";
      };
    }, [l, d, s.current]), l ? n.createElement("div", {
      className: "ds-modal--container"
    }, n.createElement("dialog", {
      open: !0,
      className: B(qr["ds-modal"], [qr["ds-modal--".concat(r)]], R({}, qr["ds-modal--dark-mode"], c)),
      ref: s,
      "aria-modal": "true",
      "aria-label": i,
      tabIndex: "0"
    }, o)) : null;
  };

  Gr.defaultProps = {
    darkMode: !1
  }, Gr.propTypes = {
    showModal: l.bool.isRequired,
    onClose: l.func.isRequired,
    width: l.oneOf(["small", "medium", "large"]).isRequired,
    ariaLabel: l.string.isRequired,
    darkMode: l.bool
  };

  var Wr = function Wr(e) {
    var t = e.icon,
        l = e.className,
        a = o(e, ["icon", "className"]);
    return n.createElement(At, i({
      className: B(l, Ot["ds-navigation-link--icon"], R({}, Ot["ds-navigation-link--icon-".concat(t)], t))
    }, a));
  };

  Wr.defaultProps = {
    className: null,
    icon: null
  }, Wr.propTypes = {
    className: l.string,
    icon: l.oneOf(["account", "search"])
  };

  var Xr = {
    "ds-notification": "ds-notification",
    "ds-notification--active": "ds-notification--active",
    "ds-notification--error": "ds-notification--error",
    "ds-notification--success": "ds-notification--success",
    "ds-notification--warning": "ds-notification--warning"
  },
      Kr = function Kr(e) {
    var l,
        a = e.text,
        r = e.variant,
        c = e.notificationId,
        s = e.time,
        d = o(e, ["text", "variant", "notificationId", "time"]),
        m = t.useState(!1),
        u = tt(m, 2),
        h = u[0],
        g = u[1],
        v = t.useState(!1),
        p = tt(v, 2),
        f = p[0],
        b = p[1];
    return t.useEffect(function () {
      g(!0);
      var e = setTimeout(function () {
        return g(!1);
      }, s),
          t = setTimeout(function () {
        return b(!0);
      }, 400),
          l = setTimeout(function () {
        return b(!1);
      }, s - 400);
      return function () {
        clearTimeout(e), clearTimeout(t), clearTimeout(l);
      };
    }, [c]), h && null !== c ? n.createElement("div", i({
      className: B(Xr["ds-notification"], (l = {}, R(l, Xr["ds-notification--active"], f), R(l, Xr["ds-notification--".concat(r)], r), l))
    }, d), n.createElement("span", null, a)) : null;
  };

  Kr.defaultProps = {
    notificationId: null,
    text: "",
    variant: null,
    time: 7e3
  }, Kr.propTypes = {
    notificationId: l.oneOfType([l.string, l.number, l.bool]),
    text: l.string,
    variant: l.oneOf(["error", "success", "warning"]),
    time: l.number
  };

  var Jr = function Jr(e) {
    if (Array.isArray(e)) return Je(e);
  };

  var $r = function $r(e) {
    if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
  };

  var ei = function ei() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  };

  var ti = function ti(e) {
    return Jr(e) || $r(e) || $e(e) || ei();
  },
      li = "ds-pagination";

  var ni = {
    "ds-pagination__nav": "ds-pagination__nav",
    "ds-pagination__nav--next": "ds-pagination__nav--next",
    "ds-pagination__nav--previous": "ds-pagination__nav--previous",
    "ds-pagination__item": "ds-pagination__item",
    "ds-pagination__item--active": "ds-pagination__item--active",
    "ds-pagination__nav-link": "ds-pagination__nav-link",
    "ds-pagination__nav--disabled": "ds-pagination__nav--disabled",
    "ds-pagination__item-link": "ds-pagination__item-link"
  },
      ai = function ai(e) {
    var t = e.id,
        l = e.value,
        a = e.label,
        r = e.active,
        i = e.disabled,
        c = e.edge,
        o = {},
        s = {
      href: e.href,
      onClick: e.onClick
    };
    return c || (o.className = B(ni["ds-pagination__item"], R({}, ni["ds-pagination__item--active"], r)), r && (o["aria-current"] = !0, o["aria-label"] = a), i && (o["aria-disabled"] = !0), r || i || (s.className = ni["ds-pagination__item-link"], s["data-value"] = l, s["aria-label"] = a)), c && (s.rel = t, s.className = ni["ds-pagination__nav-link"], s["aria-label"] = a, i && (s["aria-disabled"] = !0, s.href && delete s.href), o.className = B(ni["ds-pagination__nav"], ni["ds-pagination__nav--".concat(t)], R({}, ni["ds-pagination__nav--disabled"], i))), n.createElement("li", o, c || !r && !i ? n.createElement("a", s, n.createElement("span", {
      "aria-hidden": !0
    }, l)) : n.createElement("span", {
      "aria-hidden": !0
    }, l));
  };

  function ri(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  ai.defaultProps = {
    active: !1,
    disabled: !1,
    edge: !1
  }, ai.propTypes = {
    id: l.string.isRequired,
    value: l.oneOfType([l.number, l.string]).isRequired,
    label: l.string.isRequired,
    active: l.bool,
    disabled: l.bool,
    edge: l.bool,
    href: l.string.isRequired,
    onClick: l.func.isRequired
  };

  var ii = function ii(e) {
    var t = e.currentPage,
        l = e.totalPages,
        a = e.onPageChanged,
        r = e.pageNeighbours,
        c = e.hrefBuilder,
        o = 1 === t,
        s = t === l,
        d = Math.max(1, t - 1),
        m = Math.min(l, t + 1);

    function u(e, t) {
      a && (e.preventDefault(), a(t));
    }

    function h(e) {
      u(e, Number(e.currentTarget.getAttribute("data-value")));
    }

    var g = function (e, t) {
      var l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 2,
          n = e - l,
          a = e + l + 1;

      function r(e, l, r) {
        var i = r + 1;
        return 1 === i || i === t || i >= n && i < a ? [].concat(ti(e), [i]) : e;
      }

      function i(e, t, l, n) {
        var a = n[l - 1];
        return [].concat(ti(e), null != a && t - a != 1 ? ["...", t] : [t]);
      }

      var c = ti(Array(t).keys()).reduce(r, []);
      return c.reduce(i, []).map(function (t, l) {
        var n = "..." === t;
        return {
          id: n ? "ellipsis-".concat(l) : "page-no-".concat(t),
          value: t,
          active: e === t,
          disabled: n
        };
      });
    }(t, l, r).map(function (e) {
      var t = function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var l = null != arguments[t] ? arguments[t] : {};
          t % 2 ? ri(Object(l), !0).forEach(function (t) {
            R(e, t, l[t]);
          }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : ri(Object(l)).forEach(function (t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
          });
        }

        return e;
      }({}, e);

      return t.href = c(t.value), t.onClick = h, t.label = t.active ? "Current page: ".concat(t.value) : "Go to page ".concat(t.value), t;
    }),
        v = {
      id: "previous",
      value: "Previous",
      label: "Go to the previous page, ".concat(d),
      edge: !0,
      disabled: o,
      href: c(d),
      onClick: function onClick(e) {
        u(e, d);
      }
    },
        p = {
      id: "next",
      value: "Next",
      disabled: s,
      edge: !0,
      label: "Go to the next page, ".concat(m),
      href: c(m),
      onClick: function onClick(e) {
        u(e, m);
      }
    },
        f = [v].concat(ti(g), [p]);

    return n.createElement("nav", null, n.createElement("ul", {
      className: li
    }, f.map(function (e) {
      return n.createElement(ai, i({
        key: e.id
      }, e));
    })));
  };

  ii.defaultProps = {
    currentPage: 1,
    pageNeighbours: 1,
    onPageChanged: null,
    hrefBuilder: function hrefBuilder(e) {
      return "?page=".concat(e);
    }
  }, ii.propTypes = {
    currentPage: l.number,
    totalPages: l.number.isRequired,
    pageNeighbours: l.number,
    onPageChanged: l.func,
    hrefBuilder: l.func
  };

  var ci = function ci(e) {
    var t = e.text;
    return n.createElement("cite", null, t);
  };

  ci.defaultProps = {
    text: ""
  }, ci.propTypes = {
    text: l.string
  };

  var oi = "ds-section-control",
      si = "ds-section-control--inverse",
      di = "ds-section-control__content--closed",
      mi = function mi(e) {
    var l = e.children,
        a = e.inverse,
        r = e.sectionTitle,
        i = t.createRef(),
        c = t.useState(!1),
        o = tt(c, 2),
        s = o[0],
        d = o[1];

    function m() {
      d(!s);
    }

    return t.useEffect(function () {
      var e = !(null === i.current.getAttribute("open"));
      s && !e && i.current.setAttribute("open", "open"), !s && e && i.current.removeAttribute("open");
    }), n.createElement("details", {
      className: B(oi, R({}, si, a)),
      ref: i
    }, n.createElement("summary", {
      onClick: m,
      onKeyDown: function onKeyDown(e) {
        e.keyCode === nl.SPACE && m();
      },
      role: "button",
      "aria-expanded": s ? "true" : "false",
      tabIndex: "0"
    }, n.createElement("span", null, r)), n.createElement("div", {
      className: B(R({}, di, !s))
    }, l));
  };

  mi.defaultProps = {
    children: "",
    inverse: !1
  }, mi.propTypes = {
    children: l.node,
    inverse: l.bool,
    sectionTitle: l.string.isRequired
  };
  var ui = "ds-section-link",
      hi = n.forwardRef(function (e, t) {
    var l = e.href,
        a = e.title;
    return n.createElement("a", {
      className: ui,
      href: l,
      ref: t
    }, n.createElement("span", null, a));
  });
  hi.displayName = "SectionLink", hi.defaultProps = {
    href: ""
  }, hi.propTypes = {
    title: l.string.isRequired,
    href: l.string
  };
  var gi = "ds-share-list";

  function vi(e) {
    var t = Object.keys(e).filter(function (t) {
      return !!e[t];
    });
    return t.length ? "?".concat(t.map(function (t) {
      return "".concat(t, "=").concat(encodeURIComponent(e[t]));
    }).join("&")) : "";
  }

  var pi = {
    facebook: function facebook(e) {
      var t = e.url,
          l = e.text,
          n = void 0 === l ? "" : l,
          a = e.longtext,
          r = void 0 === a ? "" : a;
      return "https://www.facebook.com/sharer/sharer.php".concat(vi({
        u: t,
        quote: "".concat(n, " ").concat(r)
      }));
    },
    twitter: function twitter(e) {
      var t = e.url,
          l = e.text;
      return "https://twitter.com/share".concat(vi({
        url: t,
        text: void 0 === l ? "" : l
      }));
    },
    linkedin: function linkedin(e) {
      var t = e.url,
          l = e.text,
          n = void 0 === l ? "" : l,
          a = e.longtext;
      return "https://www.linkedin.com/shareArticle".concat(vi({
        url: t,
        title: n,
        summary: void 0 === a ? "" : a
      }));
    },
    whatsapp: function whatsapp(e) {
      var t = e.url,
          l = e.text,
          n = void 0 === l ? "" : l,
          a = e.longtext,
          r = void 0 === a ? "" : a;
      return "https://wa.me/".concat(vi({
        text: "".concat(n, " ").concat(r, " ").concat(t)
      }));
    }
  };
  var fi = {
    facebook: j,
    twitter: C,
    linkedin: I,
    whatsapp: O
  };

  var bi = function bi(e) {
    var t = e.inverse,
        l = e.longtext,
        a = e.platforms,
        r = e.text,
        i = e.url,
        c = e.onShare;

    function s(e, t) {
      e.preventDefault();
      var n = {
        platform: t,
        url: i,
        text: r,
        longtext: l
      };
      !function (e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 650,
            l = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 450,
            n = window.outerWidth / 2 + (window.screenX || window.screenLeft || 0) - t / 2,
            a = window.outerHeight / 2 + (window.screenY || window.screenTop || 0) - l / 2,
            r = {
          height: l,
          width: t,
          left: n,
          top: a,
          location: "no",
          toolbar: "no",
          status: "no",
          directories: "no",
          menubar: "no",
          scrollbars: "yes",
          resizable: "no",
          centerscreen: "yes",
          chrome: "yes"
        };
        window.open(e, "share", Object.keys(r).map(function (e) {
          return "".concat(e, "=").concat(r[e]);
        }).join(","));
      }(function (e) {
        var t = e.platform,
            l = o(e, ["platform"]),
            n = t.toLowerCase();
        return pi[n](l);
      }(n)), c(n);
    }

    return n.createElement("ul", {
      className: B(gi)
    }, a.map(function (e) {
      var l = function (e) {
        return fi[e.toLowerCase()];
      }(e);

      return n.createElement("li", {
        key: e,
        id: e
      }, n.createElement(Xt, {
        onClick: function onClick(t) {
          return s(t, e);
        },
        "aria-label": "Share on ".concat(e),
        icon: n.createElement(l, null),
        inverse: t,
        href: "#"
      }));
    }));
  };

  bi.defaultProps = {
    inverse: null,
    longtext: "",
    text: "",
    onShare: function onShare() {}
  }, bi.propTypes = {
    inverse: l.bool,
    longtext: l.string,
    platforms: l.arrayOf(l.string).isRequired,
    text: l.string,
    url: l.string.isRequired,
    onShare: l.func
  };

  var Ei = {
    "ds-slim-media-promo": "ds-slim-media-promo",
    "ds-link-with-arrow-icon": "ds-link-with-arrow-icon",
    "ds-slim-media-promo--inverse": "ds-slim-media-promo--inverse",
    "ds-slim-media-promo--singapore-55": "ds-slim-media-promo--singapore-55",
    "ds-slim-media-promo--paris-90": "ds-slim-media-promo--paris-90",
    "ds-slim-media-promo--chicago-20": "ds-slim-media-promo--chicago-20",
    "ds-slim-media-promo__title": "ds-slim-media-promo__title",
    "ds-layout-slim-media-promo": "ds-layout-slim-media-promo"
  },
      wi = function wi(e) {
    var t,
        l = e.title,
        a = e.inverse,
        r = e.variant,
        i = e.linkText,
        c = e.linkURL;
    return n.createElement("div", {
      className: B(Ei["ds-slim-media-promo"], (t = {}, R(t, Ei["ds-slim-media-promo--inverse"], a), R(t, Ei["ds-slim-media-promo--".concat(r)], r), t))
    }, n.createElement("div", {
      className: "ds-layout-grid ds-layout-grid--edged ".concat(Ei["ds-layout-slim-media-promo"])
    }, n.createElement("h2", {
      className: Ei["ds-slim-media-promo__title"]
    }, l), n.createElement(Rn, {
      href: c,
      text: i,
      inverse: a,
      heavy: !0,
      minor: !0
    })));
  };

  wi.defaultProps = {
    inverse: !1,
    variant: null
  }, wi.propTypes = {
    title: l.string.isRequired,
    linkText: l.string.isRequired,
    linkURL: l.string.isRequired,
    variant: l.oneOf(["singapore-55", "paris-90", "chicago-20"]),
    inverse: l.bool
  };

  var Mi = "ds-stage-banner",
      yi = "ds-layout-stage-banner",
      ki = "ds-stage-banner__badge",
      Ni = "ds-stage-banner__text",
      xi = function xi(e) {
    var t = e.badge,
        l = e.text;
    return n.createElement("div", {
      className: Mi
    }, n.createElement("div", {
      className: yi
    }, t && n.createElement("span", {
      className: ki
    }, t), n.createElement("p", {
      className: Ni
    }, l)));
  };

  xi.defaultProps = {
    badge: "",
    text: ""
  }, xi.propTypes = {
    badge: l.string,
    text: l.oneOfType([l.node, l.string])
  };

  var Li = {
    "ds-status-alert": "ds-status-alert",
    "ds-status-alert--error": "ds-status-alert--error",
    "ds-status-alert--success": "ds-status-alert--success",
    "ds-status-alert--warning": "ds-status-alert--warning"
  },
      Ti = function Ti(e) {
    var t = e.text,
        l = e.variant,
        a = o(e, ["text", "variant"]);
    return n.createElement("div", i({
      className: B(Li["ds-status-alert"], R({}, Li["ds-status-alert--".concat(l)], l))
    }, a), t);
  };

  function zi(e, t) {
    var l = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), l.push.apply(l, n);
    }

    return l;
  }

  function ji(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = null != arguments[t] ? arguments[t] : {};
      t % 2 ? zi(Object(l), !0).forEach(function (t) {
        R(e, t, l[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : zi(Object(l)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(l, t));
      });
    }

    return e;
  }

  Ti.defaultProps = {
    text: "",
    variant: null
  }, Ti.propTypes = {
    text: l.string,
    variant: l.oneOf(["error", "success", "warning"])
  };

  var Di = t.createContext({}),
      Ii = "ADD_TAB",
      Si = "SELECT_TAB",
      Ci = Di.Consumer,
      Oi = function Oi(e, t) {
    switch (t.type) {
      case Ii:
        var l = t.payload.id,
            n = e.tabs.some(function (e) {
          return e.id === l;
        }),
            a = ji({}, e);
        return n || a.tabs.push(ji({}, t.payload)), a;

      case Si:
        var r = t.payload;
        return ji(ji({}, e), {}, {
          activeTabId: r
        });

      default:
        return e;
    }
  },
      Ai = function Ai(e) {
    var l = e.children,
        a = {
      tabs: [],
      activeTabId: void 0
    },
        r = t.useReducer(Oi, a),
        i = tt(r, 2),
        c = i[0],
        o = i[1],
        s = c.activeTabId,
        d = c.tabs;

    function m(e) {
      o({
        type: Si,
        payload: e
      });
    }

    return d.length && !s && m(d[0].id), n.createElement(Di.Provider, {
      value: {
        state: c,
        addTab: function addTab(e) {
          var t = e.id,
              l = e.title;
          o({
            type: Ii,
            payload: {
              id: t,
              title: l
            }
          });
        },
        selectTab: m
      }
    }, l);
  };

  Ai.defaultProps = {
    children: null
  }, Ai.propTypes = {
    children: l.node
  };

  var Fi = function Fi(e) {
    var t = e.children,
        l = e.labelledby,
        a = o(e, ["children", "labelledby"]);
    return n.createElement("section", i({
      role: "tabpanel",
      "aria-labelledby": l
    }, a), t);
  };

  Fi.defaultProps = {
    children: null
  }, Fi.propTypes = {
    children: l.node,
    labelledby: l.string.isRequired
  };

  var _i = function _i(e) {
    var l = e.children,
        a = e.id,
        r = e.title,
        i = e.defaultSelected,
        c = t.useContext(Di),
        o = c.state.activeTabId;
    return t.useEffect(function () {
      c.addTab({
        id: a,
        title: r
      }), i && c.selectTab(a);
    }, []), o === a ? n.createElement(Fi, {
      labelledby: a
    }, l) : null;
  };

  _i.defaultProps = {
    defaultSelected: !1,
    children: null
  }, _i.propTypes = {
    defaultSelected: l.bool,
    children: l.node,
    id: l.string.isRequired,
    title: l.string.isRequired
  };

  var Ui = "ds-tab-item",
      Pi = "ds-tab-item__link",
      Vi = "ds-tab-item__link--selected",
      Ri = "ds-tab-item__link--adjacent",
      Bi = "ds-tab-item__link--minor",
      Hi = function Hi(e) {
    var t,
        l = e.title,
        a = e.minor,
        r = e.adjacent,
        c = e.selected,
        s = o(e, ["title", "minor", "adjacent", "selected"]);
    return n.createElement("li", {
      role: "presentation",
      className: B(Ui)
    }, n.createElement("a", i({
      role: "tab",
      title: l,
      "aria-selected": c,
      className: B(Pi, (t = {}, R(t, Ri, r), R(t, Bi, a), R(t, Vi, c), t))
    }, s), l));
  };

  Hi.defaultProps = {
    minor: null,
    title: null,
    adjacent: !1,
    selected: !1
  }, Hi.propTypes = {
    minor: l.bool,
    title: l.string,
    adjacent: l.bool,
    selected: l.bool
  };

  var Yi = "ds-table",
      Qi = "ds-table--scroll",
      Zi = function Zi(e) {
    var t = e.children,
        l = e.scroll;
    return n.createElement("div", {
      className: l ? Qi : null
    }, n.createElement("table", {
      className: Yi
    }, t));
  };

  Zi.defaultProps = {
    children: null,
    scroll: !1
  }, Zi.propTypes = {
    children: l.node,
    scroll: l.bool
  };

  var qi = function qi(e) {
    var t = e.children,
        l = e.dataLabel,
        a = o(e, ["children", "dataLabel"]);
    return n.createElement("td", i({
      "data-label": l
    }, a), t);
  };

  qi.defaultProps = {
    children: null
  }, qi.propTypes = {
    children: l.node,
    dataLabel: l.string.isRequired
  };

  var Gi = "ds-table-collapse",
      Wi = function Wi(e) {
    var t = e.children;
    return n.createElement("div", {
      className: Gi
    }, n.createElement(Zi, null, t));
  };

  Wi.defaultProps = {
    children: null
  }, Wi.propTypes = {
    children: l.node
  };

  var Xi = "ds-tab-list",
      Ki = "ds-tab-list--adjacent",
      Ji = function Ji(e) {
    var t = e.children,
        l = e.adjacent;
    return n.createElement("ul", {
      role: "tablist",
      className: B(Xi, R({}, Ki, l))
    }, t);
  };

  Ji.defaultProps = {
    adjacent: !1,
    children: null
  }, Ji.propTypes = {
    adjacent: l.bool,
    children: l.node
  };

  var $i = function $i(e) {
    var t = e.adjacent,
        l = e.children,
        a = e.minor;
    return n.createElement(Ai, null, n.createElement(Ci, null, function (e) {
      var r = e.state,
          i = e.selectTab,
          c = r.activeTabId,
          o = r.tabs;
      return n.createElement(n.Fragment, null, n.createElement(Ji, {
        adjacent: t
      }, o.map(function (e) {
        return n.createElement(Hi, {
          id: e.id,
          key: e.id,
          minor: a,
          title: e.title,
          href: "#".concat(e.id),
          adjacent: t,
          "aria-controls": "panel-".concat(e.id),
          selected: c === e.id,
          onClick: (l = e.id, function (e) {
            e.preventDefault(), i(l);
          })
        });
        var l;
      })), l);
    }));
  };

  $i.defaultProps = {
    adjacent: !1,
    children: null,
    minor: !1
  }, $i.propTypes = {
    adjacent: l.bool,
    children: l.arrayOf(l.element),
    minor: l.bool
  };

  var ec = "ds-tag",
      tc = function tc(e) {
    var t = e.text,
        l = o(e, ["text"]);
    return n.createElement("span", i({
      className: B(ec)
    }, l), t);
  };

  tc.defaultProps = {
    text: ""
  }, tc.propTypes = {
    text: l.string
  };

  var lc = {
    "ds-tooltip": "ds-tooltip",
    "ds-tooltip-label": "ds-tooltip-label",
    "ds-tooltip-label--right": "ds-tooltip-label--right",
    "ds-tooltip-label--inverse": "ds-tooltip-label--inverse",
    "ds-tooltip__balloon": "ds-tooltip__balloon",
    "ds-tooltip__balloon--inverse": "ds-tooltip__balloon--inverse",
    "ds-tooltip__balloon--north": "ds-tooltip__balloon--north",
    "ds-tooltip__balloon--south": "ds-tooltip__balloon--south",
    "ds-tooltip__balloon--east": "ds-tooltip__balloon--east",
    "ds-tooltip__balloon--west": "ds-tooltip__balloon--west",
    "ds-tooltip-button": "ds-tooltip-button",
    "path-background": "path-background",
    "ds-tooltip-button--inverse": "ds-tooltip-button--inverse",
    "path-foreground": "path-foreground",
    "ds-tooltip-button--left": "ds-tooltip-button--left"
  },
      nc = "north",
      ac = "south",
      rc = "east",
      ic = "west",
      cc = function cc(e) {
    var t,
        l,
        a,
        r = e.balloonText,
        i = e.labelText,
        c = e.inverse,
        o = e.direction,
        s = Math.floor(Math.random() * Math.floor(100));
    return n.createElement("div", {
      className: lc["ds-tooltip"]
    }, n.createElement("label", {
      htmlFor: "tooltipButton_".concat(s),
      className: B(lc["ds-tooltip-label"], (t = {}, R(t, lc["ds-tooltip-label--inverse"], c), R(t, lc["ds-tooltip-label--right"], o === rc), t))
    }, n.createElement("span", null, i), n.createElement("button", {
      className: B(lc["ds-tooltip-button"], (l = {}, R(l, lc["ds-tooltip-button--inverse"], c), R(l, lc["ds-tooltip-button--left"], o === rc), l)),
      id: "tooltipButton_".concat(s),
      type: "button"
    }, n.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "-2 -2 24 24"
    }, n.createElement("g", {
      fillRule: "nonzero",
      fill: "none"
    }, n.createElement("path", {
      d: "M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0z",
      fill: "#333",
      className: B(lc["path-background"])
    }), n.createElement("path", {
      fill: "#FFF",
      d: "M11 15H9V9h2zM11 7H9V5h2z",
      className: B(lc["path-foreground"])
    }))), n.createElement("span", {
      role: "tooltip",
      id: "tooltip",
      className: B(lc["ds-tooltip__balloon"], (a = {}, R(a, lc["ds-tooltip__balloon--".concat(o)], o), R(a, lc["ds-tooltip__balloon--inverse"], c), a))
    }, r))));
  };

  cc.defaultProps = {
    balloonText: "",
    direction: nc,
    labelText: "",
    inverse: !1
  }, cc.propTypes = {
    balloonText: l.string,
    direction: l.oneOf([nc, ac, rc, ic]),
    labelText: l.string,
    inverse: l.bool
  }, e.ActionedLink = Y, e.Avatar = s, e.AvatarPlaceholder = u, e.Badge = Z, e.BannerAlert = ee, e.Blockquote = te, e.BrandEspresso = d, e.BrandEspressoWeb = m, e.Breadcrumb = ie, e.Button = me, e.CallToAction = ve, e.CallToActionWithArrow = Ee, e.Card = Oe, e.ChapterList = Se, e.ControlCheck = rt, e.ControlClose = J, e.ControlCollapse = dt, e.ControlDrag = ut, e.ControlDragHandle = bt, e.ControlExpand = kt, e.ControlLabel = Lt, e.ControlMedia = It, e.EmphasisedLink = Ct, e.Footer = dl, e.FooterSecondary = bl, e.FormCheckbox = xl, e.FormFieldCombinedInput = Wl, e.FormFieldDate = $l, e.FormFieldMultipleInputs = en, e.FormFieldNumber = rn, e.FormFieldPassword = hn, e.FormFieldSearch = gn, e.FormFieldSelect = vn, e.FormFieldText = pn, e.FormFieldTextArea = fn, e.FormHelperText = Jl, e.FormInput = Ol, e.FormLabel = _l, e.FormNotice = Vl, e.FormPasswordStrengthMeter = on, e.FormRadioButton = wn, e.GraphicAudioChicago = h, e.GraphicAudioLondon = g, e.GraphicNewsletterChicago = v, e.GroupLogo = p, e.GroupLogoMasthead = f, e.GroupWordmark = b, e.IconCheck = E, e.IconCopy = w, e.IdentColumns = yn, e.IdentNewsletters = zn, e.IdentPodcasts = Dn, e.Indicator = On, e.InlineAlert = Fn, e.LinkWithArrow = Te, e.LinkWithArrowIcon = Rn, e.Logo = N, e.LogoKeyline = x, e.Masthead = Tr, e.MastheadSecondary = Ir, e.MediaPromo = Rr, e.MenuDisclosure = xa, e.MissedTarget = Zr, e.Modal = Gr, e.MonogramCircle = L, e.MonogramRounded = T, e.MonogramSquare = z, e.NavigationDisclosure = Ta, e.NavigationDisclosureIcon = za, e.NavigationLink = At, e.NavigationLinkIcon = Wr, e.Notification = Kr, e.Pagination = ii, e.Podcasts = k, e.Pullquote = ci, e.Rule = je, e.SectionControl = mi, e.SectionHeadline = Me, e.SectionLink = hi, e.Share = bi, e.ShareLink = Xt, e.SlimButton = Ql, e.SlimMediaPromo = wi, e.SocialIconFacebook = j, e.SocialIconInstagram = D, e.SocialIconLinkedIn = I, e.SocialIconRss = S, e.SocialIconTwitter = C, e.SocialIconWhatsApp = O, e.SocialIconYoutube = A, e.StageBanner = xi, e.StatusAlert = Ti, e.Tab = _i, e.TabItem = Hi, e.TabList = Ji, e.Table = Zi, e.TableCellCollapse = qi, e.TableCollapse = Wi, e.Tabs = $i, e.Tag = tc, e.Tooltip = cc, e.Wordmark = F, e.Wordmark1843 = U, e.Wordmark1843Plain = P, e.WordmarkStacked = _, e.WorldAheadWordmark = V, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});